const customizationMain = document.querySelector('.flask-customization-main');
const defaultCapType = customizationMain.getAttribute('data-cap-type');
const LOOP_STYLE_CAP_TYPES = ['pebble'];
const CONNECTOR_STYLE_CAP_TYPES = ['robo', 'base', 'chug', 'sip'];

function isLoopStyleCapType(capType) {
  return LOOP_STYLE_CAP_TYPES.includes(capType || '');
}

function isConnectorStyleCapType(capType) {
  return CONNECTOR_STYLE_CAP_TYPES.includes(capType || '');
}

function getAllConnectorPreviewElements() {
  return connectorPreview ? [connectorPreview] : [];
}

function getActiveConnectorSwiper() {
  return connectorSwiper;
}

function getConnectorSlideImageUrl(slide, size, capType) {
  if (!slide) return '';
  if (capType === 'robo') {
    if (size === '25oz') return slide.getAttribute('data-image') || slide.getAttribute('data-image_25oz');
    return slide.getAttribute(`data-image_${size}`) || slide.getAttribute('data-image');
  }
  if (capType === 'base' || capType === 'chug' || capType === 'sip') {
    const getAttr = (suffix) => slide.getAttribute(`data-${capType}-image${suffix}`);
    let capUrl = '';
    if (size === '16oz') capUrl = getAttr('_16oz') || getAttr('');
    else if (size === '30oz') capUrl = getAttr('_30oz') || getAttr('');
    else if (size === '32oz') capUrl = getAttr('_32oz') || getAttr('');
    else if (size === '40oz') capUrl = getAttr('_40oz') || getAttr('_32oz') || getAttr('');
    else if (size === '64oz') capUrl = getAttr('_64oz') || getAttr('_32oz') || getAttr('');
    else capUrl = getAttr('') || getAttr('_25oz');
    if (capUrl) return capUrl;
    if (size === '25oz') return slide.getAttribute('data-image') || slide.getAttribute('data-image_25oz');
    return slide.getAttribute(`data-image_${size}`) || slide.getAttribute('data-image');
  }
  return '';
}

function getCheckedConnectorRadio() {
  return document.querySelector('.connector_component_radio:checked') || document.querySelector('.connector_component_radio');
}

function markLoopAccessorySectionFilled() {
  summaryLoopSection.setAttribute('data-filled', 'filled');
  summaryLoopSection.setAttribute('data-loop', 'with');
  if (summaryLoopSectionMobile) {
    summaryLoopSectionMobile.setAttribute('data-filled', 'filled');
    summaryLoopSectionMobile.setAttribute('data-loop', 'with');
  }
}

function syncConnectorAccessoryForCapType(capType) {
  if (!isConnectorStyleCapType(capType)) return;
  const connectorRadio = getCheckedConnectorRadio();
  if (connectorRadio) updateConnectorSummary(connectorRadio);
}

function syncConnectorSelectionForCapType(capType, connectorRadio) {
  if (!isConnectorStyleCapType(capType) || !connectorRadio) return;

  connectorPreview?.setAttribute('data-filled', 'filled');
  updateComponentPreviewImages(bottleSizeOption);

  const slideIndex = parseInt(connectorRadio.dataset.slider_index, 10);
  if (connectorSwiper && !Number.isNaN(slideIndex)) {
    connectorSwiper.slideToLoop(slideIndex, 0, false);
  }

  updateConnectorSummary(connectorRadio);
}

function isConnectorPreviewActive() {
  return getAllConnectorPreviewElements().some(function (preview) {
    return preview?.classList.contains('active');
  });
}

function getConnectorMainForCapType(capType) {
  return connectorMain;
}

function getConnectorImageSrcFromElement(element, capType) {
  if (!element) return '';
  return getConnectorSlideImageUrl(element, bottleSizeOption, capType);
}

function getCapImageSrcFromElement(element) {
  if (!element) return '';
  const image = element.dataset.image;
  const image_32oz = element.dataset.image_32oz;
  const image_16oz = element.dataset.image_16oz;
  const image_30oz = element.dataset.image_30oz || element.dataset.image;
  const image_40oz = element.dataset.image_40oz;
  const image_64oz = element.dataset.image_64oz;
  if (bottleSizeOption == '32oz') return image_32oz || image;
  if (bottleSizeOption == '16oz') return image_16oz || image;
  if (bottleSizeOption == '30oz') return image_30oz || image;
  if (bottleSizeOption == '40oz') return image_40oz || image_32oz || image;
  if (bottleSizeOption == '64oz') return image_64oz || image_32oz || image;
  return image;
}

function getCheckedCapRadioForCapType(capType) {
  const selectorMap = {
    pebble: '.cap_component_radio',
    robo: '.robocap_component_radio',
    bubble: '.bubblecap_component_radio',
    base: '.basecap_component_radio',
    chug: '.chugcap_component_radio',
    sip: '.sipcap_component_radio'
  };
  const selector = selectorMap[capType] || selectorMap.pebble;
  return document.querySelector(selector + ':checked') || document.querySelector(selector);
}

function markCapSectionFilled() {
  summaryCapSection.setAttribute('data-filled', 'filled');
  if (summaryCapSectionMobile) {
    summaryCapSectionMobile.setAttribute('data-filled', 'filled');
  }
}

function syncCapPopupForCapType(capType) {
  capType = capType || getCapType();
  const radio = getCheckedCapRadioForCapType(capType);
  if (!radio) return;

  if (capType === 'pebble') updateCapSummary(radio);
  else if (capType === 'robo') updateroboCapSummary(radio);
  else if (capType === 'bubble') updateBubblecapSummary(radio);
  else if (capType === 'base') updateBasecapSummary(radio);
  else if (capType === 'chug') updateChugcapSummary(radio);
  else if (capType === 'sip') updateSipcapSummary(radio);
}

function getLoopStyleCapSectionClass(capType) {
  if (capType === 'robo') return 'robocap--section';
  if (capType === 'bubble') return 'bubblecap--section';
  if (capType === 'base') return 'base-cap--section';
  if (capType === 'chug') return 'chug-cap--section';
  if (capType === 'sip') return 'sip-cap--section';
  return 'pebble-cap--section';
}

const ADDITIONAL_CAP_DEFAULT_SLIDE = 1;

function isAdditionalCapType(capType) {
  return capType === 'base' || capType === 'chug' || capType === 'sip';
}

function getDefaultAdditionalCapRadio(radioSelector) {
  return document.querySelector(radioSelector + '[data-slider_index="' + ADDITIONAL_CAP_DEFAULT_SLIDE + '"]:not(.disabled)')
    || document.querySelector(radioSelector + ':not(.disabled)')
    || document.querySelector(radioSelector);
}

function slideAdditionalCapSwiper(swiper, index) {
  if (!swiper) return;
  const slideIndex = parseInt(index, 10);
  if (Number.isNaN(slideIndex)) return;
  swiper.slideTo(slideIndex, randomizeCondition ? 0 : animationSpeed, false);
}

function getAdditionalCapSwiperForCapType(capType) {
  if (capType === 'base') return basecapSwiper;
  if (capType === 'chug') return chugcapSwiper;
  if (capType === 'sip') return sipcapSwiper;
  return null;
}

function syncAdditionalCapSwiperForCapType(capType) {
  const swiper = getAdditionalCapSwiperForCapType(capType);
  if (!swiper) return;

  const selectorMap = {
    base: '.basecap_component_radio',
    chug: '.chugcap_component_radio',
    sip: '.sipcap_component_radio'
  };
  const selector = selectorMap[capType];
  if (!selector) return;

  const checkedRadio = document.querySelector(selector + ':checked');
  const hasUserCapSelection = checkedRadio && capBundleVariantID.length > 1 && getCapType() === capType;

  requestAnimationFrame(function () {
    swiper.update();
    if (hasUserCapSelection) {
      const idx = parseInt(checkedRadio.dataset.slider_index, 10);
      slideAdditionalCapSwiper(swiper, Number.isNaN(idx) ? ADDITIONAL_CAP_DEFAULT_SLIDE : idx);
      return;
    }
    slideAdditionalCapSwiper(swiper, ADDITIONAL_CAP_DEFAULT_SLIDE);
    const slide = swiper.slides[swiper.activeIndex];
    if (!slide) return;
    if (capType === 'base') basecapPreviewChanges(slide);
    else if (capType === 'chug') chugcapPreviewChanges(slide);
    else if (capType === 'sip') sipcapPreviewChanges(slide);
  });
}

function isStrawGliderCapType(capType) {
  return capType === 'robo' || capType === 'sip';
}

function getAdditionalCapRadioSelector(capType) {
  if (capType === 'base') return '.basecap_component_radio';
  if (capType === 'chug') return '.chugcap_component_radio';
  if (capType === 'sip') return '.sipcap_component_radio';
  return null;
}

function getAdditionalCapMainSlide(capType) {
  if (capType === 'base') return basecapMain;
  if (capType === 'chug') return chugcapMain;
  if (capType === 'sip') return sipcapMain;
  return null;
}

function getAdditionalCapImageSource(capType) {
  const selector = getAdditionalCapRadioSelector(capType);
  if (!selector) return null;

  const radio = document.querySelector(selector + ':checked') || getDefaultAdditionalCapRadio(selector);
  if (radio && getCapImageSrcFromElement(radio)) return radio;

  const slide = getAdditionalCapMainSlide(capType);
  if (slide && getCapImageSrcFromElement(slide)) return slide;

  const swiper = getAdditionalCapSwiperForCapType(capType);
  const activeSlide = swiper?.slides?.[swiper.activeIndex];
  if (activeSlide && getCapImageSrcFromElement(activeSlide)) return activeSlide;

  return radio || slide || activeSlide;
}

function syncMainCapImageForCapType(capType) {
  capType = capType || getCapType();
  const summaryUpdaters = {
    pebble: updateCapSummary,
    robo: updateroboCapSummary,
    bubble: updateBubblecapSummary,
    base: updateBasecapSummary,
    chug: updateChugcapSummary,
    sip: updateSipcapSummary
  };
  const mainSlideGetters = {
    pebble: () => capMain,
    robo: () => robocapMain,
    bubble: () => bubblecapMain
  };

  const source = isAdditionalCapType(capType)
    ? getAdditionalCapImageSource(capType)
    : (getCheckedCapRadioForCapType(capType) || mainSlideGetters[capType]?.());

  if (!source) return;

  const updater = summaryUpdaters[capType];
  if (updater) updater(source);

  if (getCapType() !== capType) return;

  const src = getCapImageSrcFromElement(source);
  if (!src) return;

  const normalized = imageSrcWithoutWidthParam(src);
  capImage.src = normalized;
  popupCapImage.src = normalized;
}

function getPricingCapTypeKey(capType) {
  if (capType === 'robo' || capType === 'bubble' || capType === 'pebble') return capType;
  return 'pebble';
}

function resolveFlaskBundlePricing(size, capType, loopColorType, maps) {
  const { bundlePriceMap, combinedPriceMap, baseBundlePriceMap, baseCombinedPriceMap } = maps;
  const fallbackSize = '32oz';

  if (capType === 'base') {
    return {
      bundle: baseBundlePriceMap[size] ?? baseBundlePriceMap[fallbackSize],
      combined: baseCombinedPriceMap[size] ?? baseCombinedPriceMap[fallbackSize]
    };
  }

  if (capType === 'chug' || capType === 'sip') {
    return {
      bundle: bundlePriceMap[size]?.pebble ?? bundlePriceMap[fallbackSize].pebble,
      combined: combinedPriceMap[size]?.pebble ?? combinedPriceMap[fallbackSize].pebble
    };
  }

  const priceKey = loopColorType === 'charm' && capType === 'pebble' ? 'charm' : getPricingCapTypeKey(capType);
  return {
    bundle: bundlePriceMap[size]?.[priceKey] ?? bundlePriceMap[fallbackSize]?.[priceKey] ?? bundlePriceMap[fallbackSize].pebble,
    combined: combinedPriceMap[size]?.[priceKey] ?? combinedPriceMap[fallbackSize]?.[priceKey] ?? combinedPriceMap[fallbackSize].pebble
  };
}

function getAllCapPreviewElements() {
  return [capPreview, basecapPreview, chugcapPreview, sipcapPreview, robocapPreview, bubblecapPreview].filter(Boolean);
}

/** Normalize Shopify CDN image URLs to a consistent `width=600` transform. */
function imageSrcWithoutWidthParam(url) {
  if (url == null || url === '' || typeof url !== 'string') return url;
  try {
    var u = new URL(url, typeof window !== 'undefined' ? window.location.href : 'https://example.com');
    u.searchParams.set('width', '600');
    return u.toString();
  } catch (e) {
    return url;
  }
}

let currentSection = '';
document.addEventListener('DOMContentLoaded', function() {
  document.addEventListener('click', function (e) {
    if(e.target.classList.contains('ocf--back')){
      onBoardingPreviousSlide(e.target.dataset.step);
    }
    if(e.target.classList.contains('ocf--next')){
      onBoardingNextSlide(e.target.dataset.step);
    }
    if(e.target.classList.contains('onboarding_close') || e.target.closest('.onboarding_close')){

      document.querySelectorAll('.onboarding_content').forEach(function (oc) { oc.classList.remove('active') })
      localStorage.setItem('flaskOnboarding', 'hide');
      stopOnboardingVideo();
      closeOnboarding();
    }
    if(e.target.classList.contains('summary-details-edit')){
      e.preventDefault();
      customizationMain.classList.remove('overview');
      updateCTA();
    }
  });
});

let clickFromMainRadios = false;
let swiperInitialized = false;

let bottleIndividualVariantID = '';
let bottleBundleVariantID = '';

let bottleIndividualVariantID32oz = ''
let bottleBundleVariantID32oz = '';

let bottleIndividualVariantID30oz = ''
let bottleBundleVariantID30oz = '';

let bottleIndividualVariantID40oz = ''
let bottleBundleVariantID40oz = '';

let bottleIndividualVariantID64oz = ''
let bottleBundleVariantID64oz = '';

let loopBundleVariantID = '';
let loopIndividualVariantID = '';

let capBundleVariantID = '';
let capIndividualVariantID = '';

let bootVariantID = '';
let bootVariantID32oz = '';

let engravingValue = '';
let engravingPlacement = 'bottom';
let engravingColor = '';

let engravingOrientation = 'horizontal';
let engravingFont = 'Replica';

let chosenMainColor = document.querySelector('variant-radios fieldset.swatch input[checked]').dataset.handleName;

let bottleSizeOption = document.querySelector('.flask-customization-main').getAttribute('data-size');
const defaultSize = document.querySelectorAll('fieldset#size input[type="radio"]').length > 1 ? document.querySelector('.flask-customization-main').getAttribute('data-size') : document.querySelectorAll('fieldset#size input[type="radio"]')[0].value;

let totalPrice = 0;
let bundlePrice = bottleSizeOption == '25oz' || bottleSizeOption == '16oz' ? 995 : bottleSizeOption == '30oz' ? 695 : 1095;
let loopPrice = 195;
let bottlePrice = bottleSizeOption == '16oz' ? 795 : bottleSizeOption == '25oz' ? 895 : bottleSizeOption == '30oz' ? 595 : bottleSizeOption == '40oz' ? 1095 : bottleSizeOption == '64oz' ? 1495 : 995;
let capPrice = 345;
let bootPrice = bottleSizeOption == '25oz' || bottleSizeOption == '16oz' || bottleSizeOption == '30oz' ? 195 : 245;

let gliderPrice = 100;
let gliderVariantID = '';
let gliderActive = false;

let customizerLoaded = false;
let pageLoaded = false;

const totalPriceText = document.querySelector('.flask-price');
const originalPriceText = document.querySelector('.original-price');

const unavailable32OZColors = ['pomodoro', 'ikura','creamsicle','pina','slush', 'piña'];
const available16OZColors = ["macchiato", "gulaman", "boysenberry", "taffy", "pistachio", "gumball", "peach", "buttermilk", "key lime", "jelly", "blackberry", "bubblegum"];

let randomizeCondition = false;
let isCheckingBottle = false;
let isDispatchingEvents = false;
let bottleMainImage25oz;
let bottleMain25oz;
let bottleMainImage32oz;
let bottleMain32oz;
let bottleMainImage40oz;
let bottleMain40oz;
let bottleMainImage64oz;
let bottleMain64oz;
let bottleMainImage16oz;
let bottleMain16oz;
let bottleMainImage30oz;
let bottleMain30oz;

let capMain;
let basecapMain;
let chugcapMain;
let sipcapMain;
let robocapMain;
let bubblecapMain;
let loopMain;
let bandMain;
let connectorMain;

let bootMain25oz;
let bootMain16oz;
let bootMain32oz;


let bottleIsAvailable = true;
let capIsAvailable = true;
let loopIsAvailable = true;
let bootIsAvailable = true;
let engravingIsValid = true;

let item_cart_count;
let bottleInventory = {};
let loopInventory = {};
let capInventory = {};
let bootInventory = {};

// Function to check if a URL parameter exists
function checkUrlParameter(parameterName, url) {
  // Get the query string from the URL
  var queryString = url.split('?')[1];

  if (!queryString) {
    return false;
  }

  var parameters = queryString.split('&');

  for (var i = 0; i < parameters.length; i++) {
    var parameter = parameters[i].split('=');
    if (parameter[0] === parameterName) {
      return true;
    }
  }

  return false;
}

let url = location.href;

let sizeExists = checkUrlParameter("size", url);
let capExists = checkUrlParameter("cap", url);
let loopExists = checkUrlParameter("loop", url);
let bottleExists = checkUrlParameter("bottle", url);
let bootExists = checkUrlParameter("boot", url);
let sourceExists = checkUrlParameter("source", url);

// Function to get the value of a URL parameter
function getUrlParameterValue(parameterName, url) {
  var queryString = url.split('?')[1];

  if (!queryString) {
    return null;
  }

  var parameters = queryString.split('&');

  for (var i = 0; i < parameters.length; i++) {
    var parameter = parameters[i].split('=');
    if (parameter[0] === parameterName) {
      // Decode the parameter value and return it
      return decodeURIComponent(parameter[1]).toLowerCase();
    }
  }

  return null;
}

// Get the values of the parameters
var sizeValue = getUrlParameterValue("size", url) || defaultSize;
var capTypeValue = getUrlParameterValue("captype", url) || defaultCapType;
var capValue = getUrlParameterValue("cap", url) || '';
var loopValue = getUrlParameterValue("loop", url) || '';
var bottleValue = getUrlParameterValue("bottle", url) || '';
var bootValue = getUrlParameterValue("boot", url) || '';
var sourceValue = getUrlParameterValue("source", url) || '';

let withLoop = true;
let withBoot = false;
let animationSpeed = 300;

const closeFlaskBtn = document.querySelector('.preview-close svg');
closeFlaskBtn && closeFlaskBtn.addEventListener('click', function (params) {
  customizationMain.classList.remove('show');
});

const customizeMainBtn = document.querySelector('.customize-flask-button');
const customizeMainBtnMobile = document.querySelector('.customize-flask-button.mobile');
customizeMainBtn.addEventListener('click', function (e) {
  oosModal.classList.remove('show');
  if (customizeMainBtn.getAttribute('disabled') == null) {
    try {
      localStorage.getItem('flaskOnboarding') ? (document.querySelector('.onboarding-section').classList.remove('closed'), document.querySelector('.onboarding-section').classList.add('hidden')) : document.querySelector('.onboarding--step-1.active .ocm--video').play();
    } catch (error) { }
    showCustomizer();;
    setDefaultCapType();
    updatePricing();
  }
});
customizeMainBtnMobile.addEventListener('click', function (e) {
  oosModal.classList.remove('show');
  if (customizeMainBtnMobile.getAttribute('disabled') == null) {
    try {
      localStorage.getItem('flaskOnboarding') ? (document.querySelector('.onboarding-section').classList.remove('closed'), document.querySelector('.onboarding-section').classList.add('hidden')) : document.querySelector('.onboarding--step-1.active .ocm--video').play();
    } catch (error) { }
    showCustomizer();;
    setDefaultCapType();
    updatePricing();
  }
});

function setDefaultCapType(){

  const capSection = summaryCapSection;
  capSection.querySelectorAll('.cap-type-options').forEach(section => {
    if (defaultCapType == 'robo') {
      section.querySelectorAll('input[type="radio"]')[1].checked = true;
      section.querySelectorAll('input[type="radio"]')[1].dispatchEvent(changeEvent);
    }
    else{
      section.querySelectorAll('input[type="radio"]')[0].checked = true;
      section.querySelectorAll('input[type="radio"]')[0].dispatchEvent(changeEvent);
    }
  });
}

const addToBag = document.querySelector('.add-flask');
const proceedFlask = document.querySelector('.proceed-flask');
addToBag.addEventListener('click', async function () {

    addToBag.classList.add('disabled');
    addToBag.classList.add('loading-icon');
    const checker = await getItemCartCount();
    if(!checker){
      checkoutOOS(true);
    }
    else{
      if(bottleIsAvailable && bootIsAvailable && loopIsAvailable && capIsAvailable && engravingIsValid){

        syncConnectorAccessoryForCapType(getCapType());
        syncCapPopupForCapType(getCapType());
        customizationMain.classList.add('overview');
        // popupCheckout.classList.add('show');
        customizationMain.scrollTop = -999999;
        bottleBundleVariantID.length > 1 ? popupBottleImage.classList.remove('hidden') : popupBottleImage.classList.add('hidden');
        capBundleVariantID.length > 1 ? popupCapImage.classList.remove('hidden') : popupCapImage.classList.add('hidden');
        loopBundleVariantID.length > 1 ? popupLoopImage.classList.remove('hidden') : popupLoopImage.classList.add('hidden');
        bootVariantID.length > 1 ? popupBootImage.classList.remove('hidden') : popupBootImage.classList.add('hidden');
        engravingValue.length > 1 ? '' : (engravingPlacement = '', engravingColor = '');
        updateSummaryOverview();
      }
      else{
        checkoutOOS(false);
      }
    }
  // }
});


async function getItemCartCount(){
  try {
      const response = await fetch('/cart.js');
      if (!response.ok) {
          throw new Error('Network response was not ok ' + response.statusText);
      }
      const data = await response.json();
      item_cart_count = groupByItemId(data.items);
      if(item_cart_count[bottleInventory.variantID] >= bottleInventory.variantQuantity && bottleInventory.variantQuantity > 0){
        bottleIsAvailable = false
        return bottleIsAvailable;
      }
      if(item_cart_count[capInventory.variantID] >= capInventory.variantQuantity && capInventory.variantQuantity > 0){
        capIsAvailable = false
        return capIsAvailable;
      }
      if(item_cart_count[loopInventory.variantID] >= loopInventory.variantQuantity && loopInventory.variantQuantity > 0){
        loopIsAvailable = false
        return loopIsAvailable;
      }
      if(item_cart_count[bootInventory.variantID] >= bootInventory.variantQuantity && bootInventory.variantQuantity > 0){
        bootIsAvailable = false
        return bootIsAvailable;
      }
      addToBag.removeAttribute('disabled');
      return true;
  } catch (error) {
      console.error('There was a problem with the fetch operation:', error);
  }
}

function groupByItemId(items) {
  if (!Array.isArray(items)) {
      return {};
  }

  const counts = {};

  items.forEach(item => {
      counts[item.id] = (counts[item.id] || 0) + 1;
  });
  return counts;
}


const changeEvent = new Event('change');

// let firstAvailableBottle25oz = document.querySelector('.bottle-section .color-section input[type="radio"][name="summary-body-component-25oz"]:not(.disabled)') || document.querySelector('.bottle-section .color-section input[type="radio"][name="summary-body-component-25oz"]'); // summary-desktop
// let firstAvailableBottle32oz = document.querySelector('.bottle-section .color-section input[type="radio"][name="summary-body-component-32oz"]:not(.disabled)') || document.querySelector('.bottle-section .color-section input[type="radio"][name="summary-body-component-32oz"]');
// let firstAvailableBottle16oz = document.querySelector('.bottle-section .color-section input[type="radio"][name="summary-body-component-16oz"]:not(.disabled)') || document.querySelector('.bottle-section .color-section input[type="radio"][name="summary-body-component-16oz"]');
// let firstAvailableBottle30oz = document.querySelector('.bottle-section .color-section input[type="radio"][name="summary-body-component-30oz"]:not(.disabled)') || document.querySelector('.bottle-section .color-section input[type="radio"][name="summary-body-component-30oz"]');
// let firstAvailableBottle40oz = document.querySelector('.bottle-section .color-section input[type="radio"][name="summary-body-component-40oz"]:not(.disabled)') || document.querySelector('.bottle-section .color-section input[type="radio"][name="summary-body-component-40oz"]');
// let firstAvailableBottle64oz = document.querySelector('.bottle-section .color-section input[type="radio"][name="summary-body-component-64oz"]:not(.disabled)') || document.querySelector('.bottle-section .color-section input[type="radio"][name="summary-body-component-64oz"]');
let firstAvailableBottle25oz = document.querySelector('.bottle-section-mobile .color-section input[type="radio"][name="summary-bottle-component-mobile-25oz"]:not(.disabled)') || document.querySelector('.bottle-section-mobile .color-section input[type="radio"][name="summary-bottle-component-mobile-25oz"]');
let firstAvailableBottle32oz = document.querySelector('.bottle-section-mobile .color-section input[type="radio"][name="summary-bottle-component-mobile-32oz"]:not(.disabled)') || document.querySelector('.bottle-section-mobile .color-section input[type="radio"][name="summary-bottle-component-mobile-32oz"]');
let firstAvailableBottle16oz = document.querySelector('.bottle-section-mobile .color-section input[type="radio"][name="summary-bottle-component-mobile-16oz"]:not(.disabled)') || document.querySelector('.bottle-section-mobile .color-section input[type="radio"][name="summary-bottle-component-mobile-16oz"]');
let firstAvailableBottle30oz = document.querySelector('.bottle-section-mobile .color-section input[type="radio"][name="summary-bottle-component-mobile-30oz"]:not(.disabled)') || document.querySelector('.bottle-section-mobile .color-section input[type="radio"][name="summary-bottle-component-mobile-30oz"]');
let firstAvailableBottle40oz = document.querySelector('.bottle-section-mobile .color-section input[type="radio"][name="summary-bottle-component-mobile-40oz"]:not(.disabled)') || document.querySelector('.bottle-section-mobile .color-section input[type="radio"][name="summary-bottle-component-mobile-40oz"]');
let firstAvailableBottle64oz = document.querySelector('.bottle-section-mobile .color-section input[type="radio"][name="summary-bottle-component-mobile-64oz"]:not(.disabled)') || document.querySelector('.bottle-section-mobile .color-section input[type="radio"][name="summary-bottle-component-mobile-64oz"]');


// elements for bottle section
// const bottleRadios = document.querySelectorAll('.bottle-section .color-section input[type="radio"][name="summary-body-component-25oz"]'); // summary-desktop
const bottleRadiosMobile = document.querySelectorAll('.bottle-section-mobile input[type="radio"][name="summary-bottle-component-mobile-25oz"]');
const bottleRadios = bottleRadiosMobile;
// const bottleRadios32oz = document.querySelectorAll('.bottle-section .color-section input[type="radio"][name="summary-body-component-32oz"]');
const bottleRadiosMobile32oz = document.querySelectorAll('.bottle-section-mobile input[type="radio"][name="summary-bottle-component-mobile-32oz"]');
const bottleRadios32oz = bottleRadiosMobile32oz;
// const bottleRadios16oz = document.querySelectorAll('.bottle-section .color-section input[type="radio"][name="summary-body-component-16oz"]');
const bottleRadiosMobile16oz = document.querySelectorAll('.bottle-section-mobile input[type="radio"][name="summary-bottle-component-mobile-16oz"]');
const bottleRadios16oz = bottleRadiosMobile16oz;
// const bottleRadios30oz = document.querySelectorAll('.bottle-section .color-section input[type="radio"][name="summary-body-component-30oz"]');
const bottleRadiosMobile30oz = document.querySelectorAll('.bottle-section-mobile input[type="radio"][name="summary-bottle-component-mobile-30oz"]');
const bottleRadios30oz = bottleRadiosMobile30oz;
// const bottleRadios40oz = document.querySelectorAll('.bottle-section .color-section input[type="radio"][name="summary-body-component-40oz"]');
const bottleRadiosMobile40oz = document.querySelectorAll('.bottle-section-mobile input[type="radio"][name="summary-bottle-component-mobile-40oz"]');
const bottleRadios40oz = bottleRadiosMobile40oz;
// const bottleRadios64oz = document.querySelectorAll('.bottle-section .color-section input[type="radio"][name="summary-body-component-64oz"]');
const bottleRadiosMobile64oz = document.querySelectorAll('.bottle-section-mobile input[type="radio"][name="summary-bottle-component-mobile-64oz"]');
const bottleRadios64oz = bottleRadiosMobile64oz;
// const bottleColorTextClassic = document.querySelector('.summary-desktop [data-size-category="25oz"] #bottle-color-text-classic');
// const bottleColorTextLimited = document.querySelector('.summary-desktop [data-size-category="25oz"] #bottle-color-text-limited');
const bottleColorTextClassicMobile = document.querySelector('.summary-mobile [data-size-category="25oz"] #bottle-color-text-classic');
const bottleColorTextLimitedMobile = document.querySelector('.summary-mobile [data-size-category="25oz"] #bottle-color-text-limited');
const bottleColorTextClassic = bottleColorTextClassicMobile;
const bottleColorTextLimited = bottleColorTextLimitedMobile;
// const bottleColorTextClassic32oz = document.querySelector('.summary-desktop [data-size-category="32oz"] #bottle-color-text-classic');
// const bottleColorTextLimited32oz = document.querySelector('.summary-desktop [data-size-category="32oz"] #bottle-color-text-limited');
const bottleColorTextClassicMobile32oz = document.querySelector('.summary-mobile [data-size-category="32oz"] #bottle-color-text-classic');
const bottleColorTextLimitedMobile32oz = document.querySelector('.summary-mobile [data-size-category="32oz"] #bottle-color-text-limited');
const bottleColorTextClassic32oz = bottleColorTextClassicMobile32oz;
const bottleColorTextLimited32oz = bottleColorTextLimitedMobile32oz;
// const bottleColorTextClassic16oz = document.querySelector('.summary-desktop [data-size-category="16oz"] #bottle-color-text-classic');
// const bottleColorTextLimited16oz = document.querySelector('.summary-desktop [data-size-category="16oz"] #bottle-color-text-limited');
const bottleColorTextClassicMobile16oz = document.querySelector('.summary-mobile [data-size-category="16oz"] #bottle-color-text-classic');
const bottleColorTextLimitedMobile16oz = document.querySelector('.summary-mobile [data-size-category="16oz"] #bottle-color-text-limited');
const bottleColorTextClassic16oz = bottleColorTextClassicMobile16oz;
const bottleColorTextLimited16oz = bottleColorTextLimitedMobile16oz;
// const bottleColorTextClassic30oz = document.querySelector('.summary-desktop [data-size-category="30oz"] #bottle-color-text-classic');
// const bottleColorTextLimited30oz = document.querySelector('.summary-desktop [data-size-category="30oz"] #bottle-color-text-limited');
const bottleColorTextClassicMobile30oz = document.querySelector('.summary-mobile [data-size-category="30oz"] #bottle-color-text-classic');
const bottleColorTextLimitedMobile30oz = document.querySelector('.summary-mobile [data-size-category="30oz"] #bottle-color-text-limited');
const bottleColorTextClassic30oz = bottleColorTextClassicMobile30oz;
const bottleColorTextLimited30oz = bottleColorTextLimitedMobile30oz;
// const bottleColorTextClassic40oz = document.querySelector('.summary-desktop [data-size-category="40oz"] #bottle-color-text-classic');
// const bottleColorTextLimited40oz = document.querySelector('.summary-desktop [data-size-category="40oz"] #bottle-color-text-limited');
const bottleColorTextClassicMobile40oz = document.querySelector('.summary-mobile [data-size-category="40oz"] #bottle-color-text-classic');
const bottleColorTextLimitedMobile40oz = document.querySelector('.summary-mobile [data-size-category="40oz"] #bottle-color-text-limited');
const bottleColorTextClassic40oz = bottleColorTextClassicMobile40oz;
const bottleColorTextLimited40oz = bottleColorTextLimitedMobile40oz;
// const bottleColorTextClassic64oz = document.querySelector('.summary-desktop [data-size-category="64oz"] #bottle-color-text-classic');
// const bottleColorTextLimited64oz = document.querySelector('.summary-desktop [data-size-category="64oz"] #bottle-color-text-limited');
const bottleColorTextClassicMobile64oz = document.querySelector('.summary-mobile [data-size-category="64oz"] #bottle-color-text-classic');
const bottleColorTextLimitedMobile64oz = document.querySelector('.summary-mobile [data-size-category="64oz"] #bottle-color-text-limited');
const bottleColorTextClassic64oz = bottleColorTextClassicMobile64oz;
const bottleColorTextLimited64oz = bottleColorTextLimitedMobile64oz;
// const bottleColorTextAnimal16oz = document.querySelector('.summary-desktop .color-section[data-size-category="16oz"] #bottle-color-text-animal');
const bottleColorTextAnimalMobile16oz = document.querySelector('.summary-mobile .color-section[data-size-category="16oz"] #bottle-color-text-animal');
const bottleColorTextAnimal16oz = bottleColorTextAnimalMobile16oz;
// const bottleColorTextAnimal40oz = document.querySelector('.summary-desktop .color-section[data-size-category="40oz"] #bottle-color-text-animal');
const bottleColorTextAnimalMobile40oz = document.querySelector('.summary-mobile .color-section[data-size-category="40oz"] #bottle-color-text-animal');
const bottleColorTextAnimal40oz = bottleColorTextAnimalMobile40oz;
// const bottleColorTextAnimal64oz = document.querySelector('.summary-desktop .color-section[data-size-category="64oz"] #bottle-color-text-animal');
const bottleColorTextAnimalMobile64oz = document.querySelector('.summary-mobile .color-section[data-size-category="64oz"] #bottle-color-text-animal');
const bottleColorTextAnimal64oz = bottleColorTextAnimalMobile64oz;
// Set default checked state with safety checks
// if (bottleRadios && bottleRadios.length > 0) {
//   bottleRadios[0].checked = true;
// }
// if (bottleRadiosMobile && bottleRadiosMobile.length > 0) {
//   bottleRadiosMobile[0].checked = true;
// }
// if (bottleRadios32oz && bottleRadios32oz.length > 0) {
//   bottleRadios32oz[0].checked = true;
// }
// if (bottleRadiosMobile32oz && bottleRadiosMobile32oz.length > 0) {
//   bottleRadiosMobile32oz[0].checked = true;
// }
// if (bottleRadios16oz && bottleRadios16oz.length > 0) {
//   bottleRadios16oz[0].checked = true;
// }
// if (bottleRadiosMobile16oz && bottleRadiosMobile16oz.length > 0) {
//   bottleRadiosMobile16oz[0].checked = true;
// }
// if (bottleRadios30oz && bottleRadios30oz.length > 0) {
//   bottleRadios30oz[0].checked = true;
// }
// if (bottleRadiosMobile30oz && bottleRadiosMobile30oz.length > 0) {
//   bottleRadiosMobile30oz[0].checked = true;
// }
// if (bottleRadios40oz && bottleRadios40oz.length > 0) {
//   bottleRadios40oz[0].checked = true;
// }
// if (bottleRadiosMobile40oz && bottleRadiosMobile40oz.length > 0) {
//   bottleRadiosMobile40oz[0].checked = true;
// }
// if (bottleRadios64oz && bottleRadios64oz.length > 0) {
//   bottleRadios64oz[0].checked = true;
// }
// if (bottleRadiosMobile64oz && bottleRadiosMobile64oz.length > 0) {
//   bottleRadiosMobile64oz[0].checked = true;
// }

// Get first bottle colors with safety checks
const first25ozBottleColor = (bottleRadios && bottleRadios.length > 0) ? bottleRadios[0].dataset.name : '';
const first16ozBottleColor = (bottleRadios16oz && bottleRadios16oz.length > 0) ? bottleRadios16oz[0].dataset.name : '';
const first32ozBottleColor = (bottleRadios32oz && bottleRadios32oz.length > 0) ? bottleRadios32oz[0].dataset.name : '';
const first30ozBottleColor = (bottleRadios30oz && bottleRadios30oz.length > 0) ? bottleRadios30oz[0].dataset.name : '';
const first40ozBottleColor = (bottleRadios40oz && bottleRadios40oz.length > 0) ? bottleRadios40oz[0].dataset.name : '';
const first64ozBottleColor = (bottleRadios64oz && bottleRadios64oz.length > 0) ? bottleRadios64oz[0].dataset.name : '';

// const bottleSizeRadios = document.querySelectorAll('.summary-desktop .bottle-size-option input[type="radio"]'); // summary-desktop
const bottleSizeRadiosMobile = document.querySelectorAll('.summary-mobile .bottle-size-option input[type="radio"]');
const bottleSizeRadios = bottleSizeRadiosMobile;

let bottleSizeHolder = null;

window.addEventListener('DOMContentLoaded', function () {
  // if (sizeExists) {
  //   // Convert size value to match radio button data-name format (e.g., "32oz" -> "32oz")
  //   const validSizes = ["25oz", "32oz", "16oz"];
  //   if (validSizes.includes(sizeValue)) {
  //     checkSizeRadioButtonWithValue(sizeValue);
  //   }
  // }
  
  if (!capExists || !loopExists || !bottleExists) {
    // if(defaultSize == '32oz'){
    // bottleRadios32oz[0].dispatchEvent(changeEvent);
    // }
    // else if(defaultSize == '16oz'){
    //   bottleRadios16oz[0].dispatchEvent(changeEvent);
    // }
    // else{
    //   bottleRadios[0].dispatchEvent(changeEvent);
    // }
    // // bottleRadiosMobile[0].dispatchEvent(changeEvent);
    // // bottleRadiosMobile32oz[0].dispatchEvent(changeEvent);

  } else {
    document.querySelector('body').classList.remove('hide');
  }
  customizeMainBtn.removeAttribute('disabled');
  customizeMainBtnMobile.removeAttribute('disabled');
})


// elements for cap section
// const capRadios = document.querySelectorAll('.cap-section .color-section.pebble-cap--section input[type="radio"]'); // summary-desktop
const capRadiosMobile = document.querySelectorAll('.cap-section-mobile .color-section.pebble-cap--section input[type="radio"]');
const capRadios = capRadiosMobile;
// const capColorTextClassic = document.querySelector('#cap-color-text-classic');
// const capColorTextLimited = document.querySelector('#cap-color-text-limited');
// const capColorTextAnimal = document.querySelector('#cap-color-text-animal');
const capColorTextClassicMobile = document.querySelector('.summary-mobile #cap-color-text-classic');
const capColorTextLimitedMobile = document.querySelector('.summary-mobile #cap-color-text-limited');
const capColorTextAnimalMobile = document.querySelector('.summary-mobile #cap-color-text-animal');
const capColorTextClassic = capColorTextClassicMobile;
const capColorTextLimited = capColorTextLimitedMobile;
const capColorTextAnimal = capColorTextAnimalMobile;

// const robocapRadios = document.querySelectorAll('.cap-section .color-section.robocap--section input[type="radio"]'); // summary-desktop
const robocapRadiosMobile = document.querySelectorAll('.cap-section-mobile .color-section.robocap--section input[type="radio"]');
const robocapRadios = robocapRadiosMobile;
// const robocapColorTextClassic = document.querySelector('#robocap-color-text-classic');
// const robocapColorTextLimited = document.querySelector('#robocap-color-text-limited');
// const robocapColorTextAnimal = document.querySelector('#robocap-color-text-animal');
const robocapColorTextClassicMobile = document.querySelector('.summary-mobile #robocap-color-text-classic');
const robocapColorTextLimitedMobile = document.querySelector('.summary-mobile #robocap-color-text-limited');
const robocapColorTextAnimalMobile = document.querySelector('.summary-mobile #robocap-color-text-animal');
const robocapColorTextClassic = robocapColorTextClassicMobile;
const robocapColorTextLimited = robocapColorTextLimitedMobile;
const robocapColorTextAnimal = robocapColorTextAnimalMobile;

// const bubblecapRadios = document.querySelectorAll('.cap-section .color-section.bubblecap--section input[type="radio"]'); // summary-desktop
const bubblecapRadiosMobile = document.querySelectorAll('.cap-section-mobile .color-section.bubblecap--section input[type="radio"]');
const bubblecapRadios = bubblecapRadiosMobile;
const basecapRadiosMobile = document.querySelectorAll('.cap-section-mobile .color-section.base-cap--section input[type="radio"]');
const basecapRadios = basecapRadiosMobile;
const chugcapRadiosMobile = document.querySelectorAll('.cap-section-mobile .color-section.chug-cap--section input[type="radio"]');
const chugcapRadios = chugcapRadiosMobile;
const sipcapRadiosMobile = document.querySelectorAll('.cap-section-mobile .color-section.sip-cap--section input[type="radio"]');
const sipcapRadios = sipcapRadiosMobile;
// const bubblecapColorTextClassic = document.querySelector('#bubblecap-color-text-classic');
// const bubblecapColorTextLimited = document.querySelector('#bubblecap-color-text-limited');
// const bubblecapColorTextAnimal = document.querySelector('#bubblecap-color-text-animal');
const bubblecapColorTextClassicMobile = document.querySelector('.summary-mobile #bubblecap-color-text-classic');
const bubblecapColorTextLimitedMobile = document.querySelector('.summary-mobile #bubblecap-color-text-limited');
const bubblecapColorTextAnimalMobile = document.querySelector('.summary-mobile #bubblecap-color-text-animal');
const bubblecapColorTextClassic = bubblecapColorTextClassicMobile;
const bubblecapColorTextLimited = bubblecapColorTextLimitedMobile;
const bubblecapColorTextAnimal = bubblecapColorTextAnimalMobile;

const loopSection = document.querySelector('.loop-section-mobile');
const loopRadiosMobile = document.querySelectorAll('.loop-section-mobile .color-section.loop--section input[type="radio"]');
const loopRadios = loopRadiosMobile;
const capRadios30oz = document.querySelectorAll('.cap-section-mobile .color-section.pebble-cap--section [name="summary-cap-component"]');
const robocapRadios30oz = document.querySelectorAll('.cap-section-mobile .color-section.robocap--section [name="summary-robocap-component"]');
const bubblecapRadios30oz = document.querySelectorAll('.cap-section-mobile .color-section.bubblecap--section [name="summary-bubblecap-component"]');
const loopRadios30oz = document.querySelectorAll('.loop-section-mobile .color-section.loop--section [name="summary-loop-component"]');
const connectorRadios30oz = document.querySelectorAll('.loop-section-mobile .color-section.connector--section [name="summary-connector-component"]');
const loopColorTextClassicMobile = document.querySelector('.summary-mobile #loop-color-text-classic');
const loopColorTextLimitedMobile = document.querySelector('.summary-mobile #loop-color-text-limited');
const loopColorTextCharmMobile = document.querySelector('.summary-mobile #loop-color-text-charm');
const loopColorTextAnimalMobile = document.querySelector('.summary-mobile #loop-color-text-animal');
const loopColorTextClassic = loopColorTextClassicMobile;
const loopColorTextLimited = loopColorTextLimitedMobile;
const loopColorTextCharm = loopColorTextCharmMobile;
const loopColorTextAnimal = loopColorTextAnimalMobile;


const connectorRadiosMobile = document.querySelectorAll('.loop-section-mobile .color-section.connector--section input[type="radio"]');
const connectorRadios = connectorRadiosMobile;
const connectorColorTextClassicMobile = document.querySelector('.summary-mobile #connector-color-text-classic');
const connectorColorTextLimitedMobile = document.querySelector('.summary-mobile #connector-color-text-limited');
const connectorColorTextAnimalMobile = document.querySelector('.summary-mobile #connector-color-text-animal');
const connectorColorTextClassic = connectorColorTextClassicMobile;
const connectorColorTextLimited = connectorColorTextLimitedMobile;
const connectorColorTextAnimal = connectorColorTextAnimalMobile;

const bandRadiosMobile = document.querySelectorAll('.loop-section-mobile .color-section.band--section input[type="radio"]');
const bandRadios = bandRadiosMobile;
const bandColorTextClassicMobile = document.querySelector('.summary-mobile #band-color-text-classic');
const bandColorTextLimitedMobile = document.querySelector('.summary-mobile #band-color-text-limited');
const bandColorTextAnimalMobile = document.querySelector('.summary-mobile #band-color-text-animal');
const bandColorTextClassic = bandColorTextClassicMobile;
const bandColorTextLimited = bandColorTextLimitedMobile;
const bandColorTextAnimal = bandColorTextAnimalMobile;


const bootSection = document.querySelector('.boot-section-mobile');
const bootRadiosMobile = document.querySelectorAll('.boot-section-mobile input[type="radio"][name="summary-boot-component-mobile-25oz"]');
const bootRadios = bootRadiosMobile;
const bootRadiosMobile32oz = document.querySelectorAll('.boot-section-mobile input[type="radio"][name="summary-boot-component-mobile-32oz"]');
const bootRadios32oz = bootRadiosMobile32oz;
const bootColorTextClassicMobile = document.querySelector('.summary-mobile [data-size-category="25oz"] #boot-color-text-classic');
const bootColorTextClassicMobile32oz = document.querySelector('.summary-mobile [data-size-category="32oz"] #boot-color-text-classic');
const bootColorTextCandyMobile = document.querySelector('.summary-mobile [data-size-category="25oz"] #boot-color-text-candy');
const bootColorTextCandyMobile32oz = document.querySelector('.summary-mobile [data-size-category="32oz"] #boot-color-text-candy');
const bootColorTextLimitedMobile = document.querySelector('.summary-mobile [data-size-category="25oz"] #boot-color-text-limited');
const bootColorTextLimitedMobile32oz = document.querySelector('.summary-mobile [data-size-category="32oz"] #boot-color-text-limited');
const bootColorTextClassic = bootColorTextClassicMobile;
const bootColorTextClassic32oz = bootColorTextClassicMobile32oz;
const bootColorTextCandy = bootColorTextCandyMobile;
const bootColorTextCandy32oz = bootColorTextCandyMobile32oz;
const bootColorTextLimited = bootColorTextLimitedMobile;
const bootColorTextLimited32oz = bootColorTextLimitedMobile32oz;
const bootColorTextAnimalMobile = document.querySelector('.summary-mobile #boot-color-text-animal');
const bootColorTextAnimal = bootColorTextAnimalMobile;
const bootChoicesMobile = document.querySelector('.summary-mobile .boot-choices');
const bootChoicesMobile32oz = document.querySelector('.summary-mobile .boot-choices');
const bootChoices = bootChoicesMobile;
const bootChoices32oz = bootChoicesMobile32oz;
const bootColorSectionMobile = document.querySelector('.summary-mobile .boot-section-mobile .color-section[data-size-category="25oz"]');
const bootColorSection = bootColorSectionMobile;
const bootColorSectionMobile32oz = document.querySelector('.summary-mobile .boot-section-mobile .color-section[data-size-category="32oz"]');
const bootColorSection32oz = bootColorSectionMobile32oz;

// elements for mobile tabs
const mobileTabs = document.querySelectorAll('.summary-mobile-tab');
const summaryMobileTabsStrip = document.querySelector('.summary-mobile-tabs');
const summaryContentMobile = document.querySelectorAll('.summary-content-mobile');

// summary sections
// const summaryContent = document.querySelectorAll('.summary-content'); // summary-desktop
const summaryContent = document.querySelectorAll('.summary-content-mobile');
// const summaryEngravingSection = document.querySelector('.summary-content.engraving-section'); // summary-desktop
const overviewBottleSwatch = document.querySelector('.summary-overview .bottle-swatch');
const overviewBottleValue = document.querySelector('.summary-overview .bottle-value');
const overviewCapSwatch = document.querySelector('.summary-overview .cap-swatch');
const overviewCapValue = document.querySelector('.summary-overview .cap-value');
const overviewLoopSwatch = document.querySelector('.summary-overview .loop-swatch');
const overviewLoopText = document.querySelector('.summary-overview .loop-text');
const overviewLoopValue = document.querySelector('.summary-overview .loop-value');
const overviewBootDetails = document.querySelector('.summary-overview .boot-details');
const overviewBootSwatch = document.querySelector('.summary-overview .boot-swatch');
const overviewBootValue = document.querySelector('.summary-overview .boot-value');
const overviewEngravingDetails = document.querySelector('.summary-overview .engraving-details');
const summaryOverviewEl = document.querySelector('.summary-overview');
const summaryBottleSectionMobile = document.querySelector('.bottle-section-mobile');
const summaryBootSectionMobile = document.querySelector('.boot-section-mobile');
const summaryCapSectionMobile = document.querySelector('.cap-section-mobile');
const summaryLoopSectionMobile = document.querySelector('.loop-section-mobile');
// const summaryBottleSection = document.querySelector('.summary-content.bottle-section'); // summary-desktop
// const summaryBootSection = document.querySelector('.summary-content.boot-section');
// const summaryCapSection = document.querySelector('.summary-content.cap-section');
// const summaryLoopSection = document.querySelector('.summary-content.loop-section');
const summaryBottleSection = summaryBottleSectionMobile;
const summaryBootSection = summaryBootSectionMobile;
const summaryCapSection = summaryCapSectionMobile;
const summaryLoopSection = summaryLoopSectionMobile;
const summaryEngravingSectionMobile = document.querySelector('.engraving-section-mobile');
// const summaryEngravingSection = document.querySelector('.summary-content.engraving-section'); // summary-desktop
const summaryEngravingSection = summaryEngravingSectionMobile;
// const engravingInput = document.querySelector('#engraving'); // summary-desktop duplicate
const engravingInputMobile = document.querySelector('.summary-mobile #engraving');
const engravingInput = engravingInputMobile;
// const engravingPlacementDesktop = document.querySelectorAll('.summary-desktop .desktop-summary-placement');
// const engravingOrientationDesktop = document.querySelectorAll('.summary-desktop .desktop-summary-orientation');
const engravingPlacementMobile = document.querySelectorAll('.summary-mobile .mobile-summary-placement');
const engravingOrientationMobile = document.querySelectorAll('.summary-mobile .mobile-summary-orientation');

const previewSections = document.querySelectorAll('.preview-components');
const bottlePreview = document.querySelector('.bottle-preview[data-size-category="25oz"]');
const bottlePreview16oz = document.querySelector('.bottle-preview[data-size-category="16oz"]');
const bottlePreview32oz = document.querySelector('.bottle-preview[data-size-category="32oz"]');
const bottlePreview30oz = document.querySelector('.bottle-preview[data-size-category="30oz"]');
const bottlePreview40oz = document.querySelector('.bottle-preview[data-size-category="40oz"]');
const bottlePreview64oz = document.querySelector('.bottle-preview[data-size-category="64oz"]');
const capPreview = document.querySelector('.cap-preview');
const basecapPreview = document.querySelector('.basecap-preview');
const chugcapPreview = document.querySelector('.chugcap-preview');
const sipcapPreview = document.querySelector('.sipcap-preview');
const robocapPreview = document.querySelector('.robocap-preview');
const bubblecapPreview = document.querySelector('.bubblecap-preview');
const loopPreview = document.querySelector('.loop-preview');
const connectorPreview = document.querySelector('.connector-preview');
const bandPreview = document.querySelector('.band-preview');
const bootPreview = document.querySelector('.boot-preview[data-size-category="25oz"]');
const bootPreview32oz = document.querySelector('.boot-preview[data-size-category="32oz"]');
// 30oz uses 25oz boot
const bootPreview30oz = bootPreview;

// preview main images
const swipeElement = document.querySelector('.preview-main .content');
const previewMainImage = document.querySelectorAll('.preview-main-image');
const bottleImage = document.querySelector('.preview-image-containers .bottle-image');
const capImage = document.querySelector('.preview-image-containers .cap-image');
const loopImage = document.querySelector('.preview-image-containers .loop-image');
const bootImage = document.querySelector('.preview-image-containers .boot-image');

// popup images

const popupCheckout = document.querySelector('.preview-popup');
const popupCapImage = document.querySelector('.popup-image-cap');
const popupBottleImage = document.querySelector('.popup-image-bottle');
const popupLoopImage = document.querySelector('.popup-image-loop');
const popupBootImage = document.querySelector('.popup-image-boot');
const popupButtonEdit = document.querySelectorAll('.popup-button-edit');

const mainRadios = document.querySelectorAll('.flask-swatch').length > 0 ?  document.querySelectorAll('.flask-swatch') : document.querySelectorAll('.swatch input[type="radio"]') ;
const mainSizeRadios = document.querySelectorAll('variant-radios #size input');
const variantNameClassic = document.querySelector('.variant-name p.color-text-classic');
const variantNameLimited = document.querySelector('.variant-name p.color-text-limited');
const previewEngraving = document.querySelector('.bottle-hover');
const previewEngravingText = document.querySelector('.bottle-hover span');
const popupEngraving = document.querySelector('.popup-engraving');
const popupEngravingText = document.querySelector('.popup-engraving span');

let chosenBottle = '';
let chosenCap = '';
let chosenLoop = '';
let chosenBoot = '';

const randomize = document.querySelector('#randomize-button');

const sliderNavButtons = document.querySelectorAll('.slider-nav');

const capNext = document.querySelector('.cap-next');
const capPrevious = document.querySelector('.cap-previous');

const bottleNext = document.querySelector('.bottle-next');
const bottleNext16oz = document.querySelector('.bottle-next-16oz');
const bottleNext30oz = document.querySelector('.bottle-next-30oz');
const bottleNext32oz = document.querySelector('.bottle-next-32oz');
const bottleNext40oz = document.querySelector('.bottle-next-40oz');
const bottleNext64oz = document.querySelector('.bottle-next-64oz');
const bottlePrevious = document.querySelector('.bottle-previous');
const bottlePrevious16oz = document.querySelector('.bottle-previous-16oz');
const bottlePrevious30oz = document.querySelector('.bottle-previous-30oz');
const bottlePrevious32oz = document.querySelector('.bottle-previous-32oz');
const bottlePrevious40oz = document.querySelector('.bottle-previous-40oz');
const bottlePrevious64oz = document.querySelector('.bottle-previous-64oz');

const loopNext = document.querySelector('.loop-next');
const loopPrevious = document.querySelector('.loop-previous');

const bootNext = document.querySelector('.boot-next');
const bootNext32oz = document.querySelector('.boot-next-32oz');
const bootPrevious = document.querySelector('.boot-previous');
const bootPrevious32oz = document.querySelector('.boot-previous-32oz');

// form inputs
const mainBundle = document.querySelector('#main-bundle');
const bottleComponent = document.querySelector('#bottle-component');
const capComponent = document.querySelector('#cap-component');
const loopComponent = document.querySelector('#loop-component');
const bootComponent = document.querySelector('#boot-component');
const engravingComponent = document.querySelector('#engraving-component');
const productForm = document.querySelector('product-form-kit form button');

const buttonFont = document.querySelectorAll('.button-font');

window.addEventListener('DOMContentLoaded', function () {
  // mainRadios[0].checked = true;
  // mainRadios[0].dataset.color_type == 'classic' ? variantNameClassic.innerText = ': ' + mainRadios[0].id : variantNameLimited.innerText = ': ' + mainRadios[0].id;
  // variantNameClassic.innerText = mainRadios[0].id;
})

// mainRadios.forEach(function (r) {
//   r.addEventListener('click', function (e) {
//     animationSpeed = 0;
//     checkRadioButtonWithValue(r.dataset.color);
//     chosenMainColor = r.dataset.color;
//     if (r.dataset.color_type === 'limited') {
//       variantNameLimited.innerText = ': ' + r.id;
//       variantNameClassic.innerText = '';
//     } else {
//       variantNameLimited.innerText = '';
//       variantNameClassic.innerText = ': ' + r.id;
//     }
//     document.querySelectorAll('#vto-image-wrapper img.swiper-slide').forEach(el => { el.classList.remove('show') });
//     document.querySelectorAll('#vto-image-wrapper img.swiper-slide').forEach(el => { el.dataset.variant == r.dataset.color ? el.classList.add('show') : '' });
//     animationSpeed = 300;
//     fetchFlaskDetails(r.dataset.url);
//   });
// });

document.addEventListener('click', function(e){
  if(e.target.closest('variant-radios fieldset.swatch') && e.target.type == 'radio'){
    animationSpeed = 0;
    clickFromMainRadios = true;
    checkRadioButtonWithValue(e.target.dataset.color);
    chosenMainColor = e.target.dataset.color;
    if (e.target.dataset.color_type === 'limited') {
      // variantNameLimited.innerText = ': ' + e.target.id;
      // variantNameClassic.innerText = '';
    } else {
      // variantNameLimited.innerText = '';
      // variantNameClassic.innerText = ': ' + e.target.id;
    }
    document.querySelectorAll('#vto-image-wrapper img.swiper-slide').forEach(el => { el.classList.remove('show') });
    document.querySelectorAll('#vto-image-wrapper img.swiper-slide').forEach(el => { el.dataset.variant == e.target.dataset.color ? el.classList.add('show') : '' });
    animationSpeed = 300;
    fetchFlaskDetails(e.target.dataset.url);
  }
});

mainSizeRadios.forEach(msr => {

  msr.addEventListener('click', e => {

  if(summaryCapSection.getAttribute('data-filled') != 'filled'){
    const capSection = summaryCapSection;
    capSection.querySelectorAll('.cap-type-options').forEach(section => {
      if (defaultCapType == 'robo') {
        section.querySelectorAll('input[type="radio"]')[1].checked = true;
        section.querySelectorAll('input[type="radio"]')[1].dispatchEvent(changeEvent);
      }
      else if (defaultCapType == 'pebble'){
        section.querySelectorAll('input[type="radio"]')[0].checked = true;
        section.querySelectorAll('input[type="radio"]')[0].dispatchEvent(changeEvent);
      }
      else if (defaultCapType == 'bubble'){
        section.querySelectorAll('input[type="radio"]')[2].checked = true;
        section.querySelectorAll('input[type="radio"]')[2].dispatchEvent(changeEvent);
      }
      else if (defaultCapType == 'base'){
        section.querySelectorAll('input[type="radio"]')[3].checked = true;
        section.querySelectorAll('input[type="radio"]')[3].dispatchEvent(changeEvent);
      }
      else if (defaultCapType == 'chug'){
        section.querySelectorAll('input[type="radio"]')[4].checked = true;
        section.querySelectorAll('input[type="radio"]')[4].dispatchEvent(changeEvent);
      }
      else if (defaultCapType == 'sip'){
        section.querySelectorAll('input[type="radio"]')[5].checked = true;
        section.querySelectorAll('input[type="radio"]')[5].dispatchEvent(changeEvent);
      }
    });
  }
    if(msr.value === '25oz'){
      document.querySelector('#product-price').innerText = defaultCapType == 'pebble' ? 'P995': 'P1,295';
      bottlePreview.classList.add('active');
      bottlePreview32oz.classList.remove('active');
      bottlePreview16oz.classList.remove('active');
      bottlePreview.dataset.filled = 'filled';
    }
    if(msr.value === '16oz'){
      document.querySelector('#product-price').innerText = defaultCapType == 'pebble' ? '895': 'P1,195';
      bottlePreview16oz.classList.add('active');
      bottlePreview32oz.classList.remove('active');
      bottlePreview.classList.remove('active');
      bottlePreview16oz.dataset.filled = 'filled';
    }
    else{
      document.querySelector('#product-price').innerText = defaultCapType == 'pebble' ? 'P1,095': 'P1,395';
      bottlePreview.classList.remove('active');
      bottlePreview32oz.classList.add('active');
      bottlePreview16oz.classList.remove('active');
      bottlePreview32oz.dataset.filled = 'filled';
    }
    
    if(msr.value == '32oz'){
      setTimeout(function(){
          bottleRadios32oz.forEach(br => {
            if(br.dataset.name == chosenMainColor){
              br.dispatchEvent(changeEvent);
            }
          });
          capRadios.forEach(cr => {
            if(cr.dataset.name == chosenMainColor){
              cr.dispatchEvent(changeEvent);
            }
          });
          loopRadios.forEach(lr => {
            if(lr.dataset.name == chosenMainColor){
              lr.dispatchEvent(changeEvent);
            }
          });
      }, 500);
    }

    if(msr.value == '16oz'){
      setTimeout(function(){
          bottleRadios16oz.forEach(br => {
            if(br.dataset.name == chosenMainColor){
              br.dispatchEvent(changeEvent);
            }
          });
          capRadios.forEach(cr => {
            if(cr.dataset.name == chosenMainColor){
              cr.dispatchEvent(changeEvent);
            }
          });
          loopRadios.forEach(lr => {
            if(lr.dataset.name == chosenMainColor){
              lr.dispatchEvent(changeEvent);
            }
          });
      }, 500);
    }
    updatePricing();
    checkSizeRadioButtonWithValue(msr.value);
    document.querySelector('.preview-main').classList.remove('animation')
  })
})

function mainRadioFunctions() {

}

if (engravingInput) {
  engravingInput.addEventListener('input', function (e) {
    const device = window.innerWidth > 899 ? 'desktop' : 'mobile';
    updateEngraving(e.target.value, device, e);
    checkEmoji(e.target.value);
  });
}
function isDesktopCustomizer() {
  return window.innerWidth > 899;
}

function getBottleHoverEngravingBaseSize() {
  return isDesktopCustomizer() ? '12px' : '14px';
}

function getPopupEngravingBaseSize() {
  return '14px';
}

function applyEngravingFontSize(element, baseSize, modifiedLength, currentFont) {
  if (!element) return;

  if (modifiedLength >= 10) {
    if (currentFont.includes('Only Organic')) {
      element.style.fontSize = '9px';
    } else {
      element.style.fontSize = '10px';
    }
    return;
  }

  if (currentFont === 'Only Organic') {
    element.style.fontSize = '11px';
  } else if (currentFont.includes('Nautica') || currentFont.includes('Savoye')) {
    element.style.fontSize = '17px';
  } else {
    element.style.fontSize = baseSize;
  }
}
function standardEngravingBaseSize() {
  if (window.innerWidth > 899 && !customizationMain.classList.contains('overview-engraving')) {
    return '12px';
  }
  return '14px';
}

function refreshEngravingPreviewFontSize() {
  if (window.innerWidth <= 899 || !engravingInput) return;
  updateEngraving(engravingInput.value, 'desktop', { preventDefault: function () {} });
}

function getModifiedEngravingLength(input) {
  let modifiedInput = input || '';
  if (!modifiedInput.includes('<svg')) {
    modifiedInput = modifiedInput.replace(/ᯓ★/g, 'X').replace(/•ᴗ•/g, 'Y').replace(/🐾/g, 'Y').replace(/🜲/g, 'Y').replace(/𖤓/g, 'Y');
  }
  return modifiedInput.length;
}

function updateEngraving(input, device, e){

  // Updated by Ruent: 
  //𖤓🜲��
  // Don't process SVG content - skip the replacement for paw SVG
  let modifiedInput = input;
  
  // Only replace actual emoji characters, not SVG content
  if (!input.includes('<svg')) {
    modifiedInput = input.replace(/ᯓ★/g, 'X').replace(/•ᴗ•/g, 'Y').replace(/🐾/g, 'Y').replace(/🜲/g, 'Y').replace(/𖤓/g, 'Y');
  }
  const modifiedLength = modifiedInput.length;
  
  // Get current font selection
  const currentFont = engravingFont || 'Replica';
  const bottleHoverBaseSize = getBottleHoverEngravingBaseSize();
  const popupBaseSize = getPopupEngravingBaseSize();

  applyEngravingFontSize(previewEngravingText, bottleHoverBaseSize, modifiedLength, currentFont);
  applyEngravingFontSize(popupEngravingText, popupBaseSize, modifiedLength, currentFont);

  popupEngravingText.style.fontStyle = 'normal';

  if(modifiedLength <= 15){
    // Don't replace SVG content - keep it as is
    const pawSVG = `<svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" fill="white" stroke="white" style="width: 12px; height: 12px;"><path d="M18.137 21.824c-5.645 1.549-9.088 7.132-8.092 10.944c.998 3.813 4.766-.53 10.411-2.08c5.643-1.551 11.024.281 10.028-3.532c-.997-3.813-6.702-6.883-12.347-5.332" fill="white"></path><path d="M13.768 20.047c1.701-.632 1.918-4.417 1.012-6.969c-.906-2.55-3.02-4.103-4.721-3.469c-1.7.635-2.344 3.217-1.438 5.767c.906 2.551 3.445 5.306 5.147 4.671" fill="white"></path><path d="M20.708 18.078c1.803-.162 2.967-3.759 2.736-6.465c-.23-2.704-1.879-4.763-3.682-4.604c-1.803.163-3.079 2.486-2.848 5.19c.232 2.704 1.989 6.041 3.794 5.879" fill="white"></path><path d="M28.678 10.164c-1.809 0-3.275 2.2-3.275 4.914c0 2.716 1.467 6.195 3.275 6.195c1.81 0 3.276-3.479 3.276-6.195c.001-2.715-1.466-4.914-3.276-4.914" fill="white"></path><path d="M3.318 17.127c-1.568.926-1.766 3.584-.439 5.936c1.324 2.35 4.293 4.612 5.86 3.685c1.568-.927 1.141-4.693-.184-7.043c-1.325-2.352-3.671-3.505-5.237-2.578" fill="white"></path><path d="M45.865 44.529c-5.645-1.551-11.352 1.52-12.348 5.332c-.998 3.813 4.385 1.981 10.029 3.532c5.645 1.55 9.412 5.893 10.408 2.08c.998-3.812-2.446-9.394-8.089-10.944" fill="white"></path><path d="M50.234 42.755c1.699.632 4.24-2.123 5.146-4.674c.906-2.551.262-5.133-1.438-5.767c-1.701-.635-3.813.919-4.719 3.47s-.69 6.336 1.011 6.971" fill="white"></path><path d="M43.295 40.782c1.803.162 3.561-3.174 3.791-5.878s-1.043-5.028-2.846-5.19c-1.803-.16-3.451 1.9-3.684 4.605c-.23 2.705.936 6.301 2.739 6.463" fill="white"></path><path d="M35.322 43.978c1.811 0 3.277-3.479 3.277-6.195c0-2.714-1.467-4.914-3.277-4.914s-3.277 2.2-3.277 4.916c0 2.714 1.469 6.193 3.277 6.193" fill="white"></path><path d="M60.683 39.832c-1.568-.927-3.912.226-5.236 2.577c-1.323 2.351-1.751 6.117-.186 7.044c1.568.927 4.537-1.335 5.861-3.685c1.324-2.351 1.127-5.009-.439-5.936" fill="white"></path></svg>`;
    const processedInput = input.includes('<svg') ? input : input.replace(/🐾/g, pawSVG);
    const processedInputValue = input;
    engravingInput.value = processedInputValue;
    engravingInputMobile.value = processedInputValue;
    previewEngravingText.innerHTML = processedInput
    popupEngravingText.innerHTML = processedInput
    engravingValue = processedInputValue;
    updateSummaryOverview();
  }else{
    e.preventDefault();
  }
}

// previewEngraving
// popupEngraving

// engravingPlacementDesktop.forEach — summary-desktop removed; use engravingPlacementMobile.forEach below
/*
engravingPlacementDesktop.forEach(p => {
  p.addEventListener('change', function () {
    if (p.id == 'top-placement') {
      updatePlacement('top', 'Top');
    } else if (p.id == 'middle-placement') {
      updatePlacement('middle', 'Middle');
    } else {
      updatePlacement('bottom', 'Bottom');
    }
  });
})
*/

engravingPlacementMobile.forEach(p => {
  p.addEventListener('change', function () {
    if (p.id == 'top-placement-mobile') {
      updatePlacement('top', 'Top');
    } else if (p.id == 'middle-placement-mobile') {
      updatePlacement('middle', 'Middle');
    } else {
      updatePlacement('bottom', 'Bottom');
    }
  });
})

// engravingOrientationDesktop.forEach — summary-desktop removed; use engravingOrientationMobile.forEach below
/*
engravingOrientationDesktop.forEach(o => {
  o.addEventListener('change', function () {
    updateOrientation(o);
  })
})
*/

engravingOrientationMobile.forEach(o => {
  o.addEventListener('change', function () {
    updateOrientation(o);
  })
})

function updateOrientation(o){
  if(o.id.includes('horizontal-orientation')){
    popupEngraving.setAttribute('orientation','');
    previewEngraving.setAttribute('orientation','');
    engravingOrientation = 'horizontal';
  }
  else{
    popupEngraving.setAttribute('orientation','vertical');
    previewEngraving.setAttribute('orientation','vertical');
    engravingOrientation = 'vertical';
  }
  document.querySelectorAll('#engraving-orientation-text').forEach(element => {
    element.innerText = engravingOrientation;
  });
}

function updatePlacement(placement, text) {
  popupEngraving.setAttribute('placement', placement);
  previewEngraving.setAttribute('placement', placement);
  document.querySelectorAll('#engraving-placement-text').forEach(ept => {
    ept.innerText = placement;
  });
  engravingPlacement = placement;
}


// Click event listener for opening summary sections
summaryContent.forEach(function (element) {
  element.addEventListener('click', function (event) {

    if (isOutsideOptions(event.target)) {
      sliderNavButtons.forEach(function (nav) {
        nav.classList.remove('active');
        nav.classList.remove('hidden');
      })

      summaryContent.forEach(function (e) {
        e.classList.remove('active');
      });

      if (element.getAttribute('data-filled') === 'empty') {
        if (element.querySelectorAll('input[type="radio"]')[0]) {
          if (!element.closest('.boot-section-mobile') && !element.closest('.boot-section')) {
            element.setAttribute('data-filled', 'filled');
            element.querySelectorAll('input[type="radio"]')[0].checked = true;
            element.querySelectorAll('input[type="radio"]')[0].dispatchEvent(changeEvent);
          }
          if (event.target.closest('.engraving-section') || event.target.closest('.engraving-section-mobile')) {
            engravingOrientationMobile[1].checked = true;
            engravingOrientationMobile[1].dispatchEvent(changeEvent)
          }
        } else {
          if (event.target.closest('.engraving-section') || event.target.closest('.engraving-section-mobile')) {
            element.setAttribute('data-filled', 'filled');
          }
        }
      }


      previewSections.forEach(function (ps) {
        ps.classList.remove('active');
      })

      previewMainImage.forEach(function (pmi) {
        pmi.classList.remove('active')
      })

      if (element.closest('.bottle-section') || element.closest('.bottle-section-mobile')) {
        bottleShowPreview();
      }
      else if (element.closest('.cap-section') || element.closest('.cap-section-mobile')) {
        capShowPreview();
      }
      else if (element.closest('.boot-section') || element.closest('.boot-section-mobile')) {
        bootShowPreview();
      }
      else if (element.closest('.loop-section') || element.closest('.loop-section-mobile')) {
        loopShowPreview();
      }

      // Toggle the 'active' class only if the above conditions are met
      element.classList.toggle('active');
    }
    updatePricing();
  });
});

// event listener for mobile tabs
mobileTabs.forEach(function (tab) {
  tab.addEventListener('change', function (t) {

    sliderNavButtons.forEach(function (nav) {
      nav.classList.remove('active');
      nav.classList.remove('hidden');
    })

    summaryContentMobile.forEach(function (mobileContent) {
      mobileContent.classList.remove('active');
    });

    previewSections.forEach(function (ps) {
      ps.classList.remove('active');
    });

    previewMainImage.forEach(function (pmi) {
      pmi.classList.remove('active')
    });

    if (t.target.id == "bottle-tab") {
      summaryBottleSectionMobile.classList.add('active');
      bottleShowPreview();
      summaryBottleSection.setAttribute('data-filled', 'filled');
      currentSection = 'bottle';
      window.innerWidth > 899 ? customizationMain.classList.remove('overview-engraving') : '';
      refreshEngravingPreviewFontSize();
      setTimeout(function () { scrollSummaryToColorSwatches(summaryBottleSectionMobile); }, 0);
    }
    else if (t.target.id == "cap-tab") {
      summaryCapSectionMobile.classList.add('active');
      capShowPreview();
      summaryCapSection.setAttribute('data-filled', 'filled');
      currentSection = 'cap';
      window.innerWidth > 899 ? customizationMain.classList.remove('overview-engraving') : '';
      refreshEngravingPreviewFontSize();
      setTimeout(function () { scrollSummaryToColorSwatches(summaryCapSectionMobile); }, 0);
    }
    else if (t.target.id == "loop-tab") {
      summaryLoopSectionMobile.classList.add('active');
      currentSection = 'loop';
      loopShowPreview();
      summaryLoopSection.setAttribute('data-filled', 'filled');
      window.innerWidth > 899 ? customizationMain.classList.remove('overview-engraving') : '';
      refreshEngravingPreviewFontSize();
    }
    else if (t.target.id == "boot-tab") {
      summaryBootSectionMobile.classList.add('active');
      currentSection = 'boot';
      bootShowPreview();
      summaryBootSection.setAttribute('data-filled', 'filled');
      window.innerWidth > 899 ? customizationMain.classList.remove('overview-engraving') : '';
      refreshEngravingPreviewFontSize();
    }
    else if (t.target.id == "engraving-tab") {
      summaryEngravingSectionMobile.classList.add('active');
      summaryEngravingSection.classList.add('active');
      summaryEngravingSection.setAttribute('data-filled', 'filled');
      engravingPlacement == '' ? (engravingPlacementMobile[0].checked = true, engravingPlacementMobile[0].dispatchEvent(new Event('change')) ) : '';
      currentSection = 'engraving';
      bootVariantID.length > 1 ? popupBootImage.classList.remove('hidden') : popupBootImage.classList.add('hidden');
      window.innerWidth > 899 ? customizationMain.classList.add('overview-engraving') : '';
      refreshEngravingPreviewFontSize();
    }
  })
});

function summaryMobileTabsWheelToHorizontal(e) {
  if (window.matchMedia('(max-width: 899px)').matches) return;
  var el = e.currentTarget;
  if (el.scrollWidth <= el.clientWidth) return;
  var dx = e.deltaX;
  var dy = e.deltaY;
  if (dx !== 0 && Math.abs(dx) >= Math.abs(dy)) {
    var prevX = el.scrollLeft;
    el.scrollLeft += dx;
    if (prevX !== el.scrollLeft) e.preventDefault();
    return;
  }
  if (dy !== 0) {
    var prevY = el.scrollLeft;
    el.scrollLeft += dy;
    if (prevY !== el.scrollLeft) e.preventDefault();
  }
}

function initSummaryMobileTabsMouseDrag(el) {
  var dragActive = false;
  var startX = 0;
  var scrollStart = 0;
  var didDrag = false;
  var dragThreshold = 8;

  function isDesktopTabsStrip() {
    return !window.matchMedia('(max-width: 899px)').matches;
  }

  function canScrollHorizontally() {
    return el.scrollWidth > el.clientWidth;
  }

  el.addEventListener('mousedown', function (e) {
    if (!isDesktopTabsStrip() || !canScrollHorizontally() || e.button !== 0) return;
    dragActive = true;
    didDrag = false;
    startX = e.pageX;
    scrollStart = el.scrollLeft;
  });

  document.addEventListener('mousemove', function (e) {
    if (!dragActive) return;
    var dx = e.pageX - startX;
    if (!didDrag && Math.abs(dx) < dragThreshold) return;
    if (!didDrag) {
      didDrag = true;
      el.classList.add('is-dragging');
    }
    e.preventDefault();
    el.scrollLeft = scrollStart - dx;
  });

  function endDrag() {
    if (!dragActive) return;
    dragActive = false;
    el.classList.remove('is-dragging');
  }

  document.addEventListener('mouseup', endDrag);
  el.addEventListener('click', function (e) {
    if (!didDrag) return;
    e.preventDefault();
    e.stopPropagation();
    didDrag = false;
  }, true);
}

if (summaryMobileTabsStrip) {
  summaryMobileTabsStrip.addEventListener('wheel', summaryMobileTabsWheelToHorizontal, { passive: false });
  initSummaryMobileTabsMouseDrag(summaryMobileTabsStrip);
}

function goToBottleComponent() {
  customizationMain.classList.remove('overview', 'overview-engraving');
  refreshEngravingPreviewFontSize();
  if (summaryOverviewEl) summaryOverviewEl.classList.remove('show');

  var bottleTab = document.getElementById('bottle-tab');
  if (bottleTab) {
    bottleTab.checked = true;
    bottleTab.dispatchEvent(new Event('change'));
  }

  var summarySection = document.querySelector('.summary-section');
  if (summarySection) {
    summarySection.scrollTo({ top: 0, behavior: 'smooth' });
  }
}

function openSummaryMobileTabFromOverview(tabInputId) {
  var tabInput = document.getElementById(tabInputId);
  if (!tabInput) return;
  tabInput.checked = true;
  tabInput.dispatchEvent(new Event('change'));
  if (summaryOverviewEl) summaryOverviewEl.classList.remove('show');

  if (!window.matchMedia('(max-width: 899px)').matches) return;

  if (tabInputId !== 'bottle-tab' && tabInputId !== 'cap-tab') {
    setTimeout(function () {
      var summarySection = document.querySelector('.summary-section');
      if (summarySection) summarySection.scrollTo({ top: 0, behavior: 'smooth' });
    }, 0);
  }
}

if (summaryOverviewEl) {
  summaryOverviewEl.addEventListener('click', function (e) {
    var item = e.target.closest('.summary-details-item');
    if (!item) return;
    if (item.classList.contains('boot-details') && item.classList.contains('hidden')) return;
    if (item.classList.contains('engraving-details') && item.classList.contains('hidden')) return;

    if (item.classList.contains('bottle-details')) {
      openSummaryMobileTabFromOverview('bottle-tab');
    } else if (item.classList.contains('cap-details')) {
      if (!e.target.closest('.cap-details-wrapper')) return;
      openSummaryMobileTabFromOverview('cap-tab');
    } else if (item.classList.contains('loop-details')) {
      openSummaryMobileTabFromOverview('loop-tab');
    } else if (item.classList.contains('boot-details')) {
      openSummaryMobileTabFromOverview('boot-tab');
    } else if (item.classList.contains('engraving-details')) {
      openSummaryMobileTabFromOverview('engraving-tab');
    }
    customizationMain.classList.remove('overview');
  });
}

function bottleShowPreview() {


  sliderNavButtons.forEach(function (nav) {
    nav.classList.remove('active');
    nav.classList.remove('hidden');
  })

  previewMainImage.forEach(function (pmi) {
    pmi.classList.remove('active')
  })
  previewSections.forEach(function (ps) {
    ps.classList.remove('active');
  });

  if (bottleSizeOption === '25oz') {
    bottlePreview.classList.add('active');
    bottlePreview32oz.classList.remove('active');
    bottlePreview30oz.classList.remove('active');
    bottlePreview16oz.classList.remove('active');
    checkAnimalObservatoryColor(bottleMain25oz ? bottleMain25oz : bottleRadios[0]);
  } 
  else if (bottleSizeOption === '32oz') {
    bottlePreview32oz.classList.add('active');
    bottlePreview.classList.remove('active');
    bottlePreview30oz.classList.remove('active');
    bottlePreview16oz.classList.remove('active');
    bottlePreview40oz.classList.remove('active');
    bottlePreview64oz.classList.remove('active');
    checkAnimalObservatoryColor(bottleMain32oz ? bottleMain32oz : bottleRadios32oz[0]);
  } 
  else if (bottleSizeOption === '30oz') {
    bottlePreview30oz.classList.add('active');
    bottlePreview.classList.remove('active');
    bottlePreview32oz.classList.remove('active');
    bottlePreview16oz.classList.remove('active');
    bottlePreview40oz.classList.remove('active');
    bottlePreview64oz.classList.remove('active');
    checkAnimalObservatoryColor(bottleMain30oz ? bottleMain30oz : bottleRadios30oz[0]);
  }
  else if (bottleSizeOption === '16oz') {
    bottlePreview32oz.classList.remove('active');
    bottlePreview.classList.remove('active');
    bottlePreview30oz.classList.remove('active');
    bottlePreview16oz.classList.add('active');
    bottlePreview40oz.classList.remove('active');
    bottlePreview64oz.classList.remove('active');
    checkAnimalObservatoryColor(bottleMain16oz ? bottleMain16oz : bottleRadios16oz[0]);
  }
  else if (bottleSizeOption === '40oz') {
    bottlePreview40oz.classList.add('active');
    bottlePreview.classList.remove('active');
    bottlePreview32oz.classList.remove('active');
    bottlePreview30oz.classList.remove('active');
    bottlePreview16oz.classList.remove('active');
    checkAnimalObservatoryColor(bottleMain40oz ? bottleMain40oz : bottleRadios40oz[0]);
  }
  else if (bottleSizeOption === '64oz') {
    bottlePreview64oz.classList.add('active');
    bottlePreview.classList.remove('active');
    bottlePreview32oz.classList.remove('active');
    bottlePreview30oz.classList.remove('active');
    bottlePreview16oz.classList.remove('active');
    checkAnimalObservatoryColor(bottleMain64oz ? bottleMain64oz : bottleRadios64oz[0]);
  }

  bottleImage.parentElement.parentElement.classList.add('active');
  bottlePreview.setAttribute('data-filled', 'filled');
  bottlePreview32oz.setAttribute('data-filled', 'filled');
  bottlePreview30oz.setAttribute('data-filled', 'filled');
  bottlePreview16oz.setAttribute('data-filled', 'filled');
  bottlePreview40oz.setAttribute('data-filled', 'filled');
  bottlePreview64oz.setAttribute('data-filled', 'filled');

  // Hide all slider nav buttons first
  sliderNavButtons.forEach(btn => btn.classList.remove('active'));

  // Show only the bottle nav buttons for the current size
  const bottleNavMap = {
    '25oz': [bottleNext, bottlePrevious],
    '16oz': [bottleNext16oz, bottlePrevious16oz],
    '30oz': [bottleNext30oz, bottlePrevious30oz],
    '32oz': [bottleNext32oz, bottlePrevious32oz],
    '40oz': [bottleNext40oz, bottlePrevious40oz],
    '64oz': [bottleNext64oz, bottlePrevious64oz]
  };

  const activeBottleNav = bottleNavMap[bottleSizeOption] || [bottleNext, bottlePrevious];
  activeBottleNav.forEach(btn => btn?.classList.add('active'));
}
function capShowPreview(clickFromMain) {
  const capType = document.querySelector('.flask-customization-main').dataset.capType;
  getAllCapPreviewElements().forEach(preview => preview?.classList.remove('active'));
  loopPreview?.classList.remove('active');
  bandPreview?.classList.remove('active');
  getAllConnectorPreviewElements().forEach(function (preview) {
    preview?.classList.remove('active');
  });
  if(customizationMain.dataset.capType == 'robo'){
    robocapPreview.classList.add('active');
    checkAnimalObservatoryColor(robocapMain ? robocapMain : robocapRadios[0]);
  } else if(customizationMain.dataset.capType == 'bubble'){
    bubblecapPreview.classList.add('active');
    checkAnimalObservatoryColor(bubblecapMain ? bubblecapMain : bubblecapRadios[0]);
  } else if(customizationMain.dataset.capType == 'base' && basecapPreview){
    basecapPreview.classList.add('active');
    checkAnimalObservatoryColor(basecapMain ? basecapMain : basecapRadios[0]);
  } else if(customizationMain.dataset.capType == 'chug' && chugcapPreview){
    chugcapPreview.classList.add('active');
    checkAnimalObservatoryColor(chugcapMain ? chugcapMain : chugcapRadios[0]);
  } else if(customizationMain.dataset.capType == 'sip' && sipcapPreview){
    sipcapPreview.classList.add('active');
    checkAnimalObservatoryColor(sipcapMain ? sipcapMain : sipcapRadios[0]);
  }
  else{
    capPreview.classList.add('active');
    checkAnimalObservatoryColor(capMain ? capMain : capRadios[0]);
  }

  const capSection = summaryCapSection;

  capSection.querySelectorAll('.cap-type-options').forEach(section => {
    const capTypeRadio = section.querySelector('input.cap-type-radio[data-name="' + capType + '"]')
      || section.querySelector('input.cap-type-radio[data-name="pebble"]');
    if (capTypeRadio && !capTypeRadio.checked) {
      capTypeRadio.checked = true;
      capTypeRadio.dispatchEvent(changeEvent);
    }
  });


    if(capSection.dataset.filled != 'filled'){
      if (!isAdditionalCapType(capType)) {
        const activeCapColorSection = capSection.querySelector('.color-section.' + getLoopStyleCapSectionClass(capType));
        if (activeCapColorSection) {
          const firstRadio = activeCapColorSection.querySelector('input[type="radio"]');
          if (firstRadio) {
            firstRadio.checked = true;
            firstRadio.dispatchEvent(changeEvent);
          }
        }
      }
    }

    capImage.parentElement.parentElement.classList.add('active');
    capPreview.setAttribute('data-filled', 'filled');
    basecapPreview?.setAttribute('data-filled', 'filled');
    chugcapPreview?.setAttribute('data-filled', 'filled');
    sipcapPreview?.setAttribute('data-filled', 'filled');
    robocapPreview.setAttribute('data-filled', 'filled');
    bubblecapPreview.setAttribute('data-filled', 'filled');
    capNext.classList.add('active');
    capPrevious.classList.add('active');
    // robocapNext.classList.add('active');
    // robocapPrevious.classList.add('active');
    if(!clickFromMain){
      if(window.innerWidth > 899){
        if(capBundleVariantID.length < 1){
          if(capType == 'pebble'){
          for (const [index, e] of capRadios.entries()) {
            if (!e.classList.contains('disabled')) {
              capRadios[index].dispatchEvent(changeEvent)
              break;
            }
          }
        }
        else if(!isAdditionalCapType(capType)){
          if(capType == 'bubble'){
          for (const [index, e] of bubblecapRadios.entries()) {
            if (!e.classList.contains('disabled')) {
              bubblecapRadios[index].dispatchEvent(changeEvent)
              break;
            }
          }
        }
        else{
          for (const [index, e] of robocapRadios.entries()) {
            if (!e.classList.contains('disabled')) {
              robocapRadios[index].dispatchEvent(changeEvent)
              break;
            }
          }
        }
        }
      }
    }
  }

  syncAdditionalCapSwiperForCapType(capType);
}

function loopShowPreview(clickFromMain) {
  const capType = document.querySelector('.flask-customization-main').dataset.capType;
  loopPreview?.classList.remove('active');
  bandPreview?.classList.remove('active');
  getAllConnectorPreviewElements().forEach(function (preview) {
    preview?.classList.remove('active');
  });

  if(isConnectorStyleCapType(capType)){
    connectorPreview?.classList.add('active');
    checkAnimalObservatoryColor(connectorMain ? connectorMain : connectorRadios[0]);
  }
  else if(document.querySelector('.flask-customization-main').dataset.capType == 'bubble'){
    bandPreview.classList.add('active');
    checkAnimalObservatoryColor(bandMain ? bandMain : bandRadios[0]);
  }
  else{
    loopPreview.classList.add('active');
    checkAnimalObservatoryColor(loopMain ? loopMain : loopRadios[0]);
  }

  const loopSection = summaryLoopSection;
  if(loopSection.dataset.filled != 'filled'){
    loopSection.querySelectorAll('.color-section').forEach(section => {
      section.querySelector('input[type="radio"]').checked = true;
      section.querySelector('input[type="radio"]').dispatchEvent(changeEvent);
    });
  }

  loopImage.parentElement.parentElement.classList.add('active');
  loopPreview.setAttribute('data-filled', 'filled');
  bandPreview.setAttribute('data-filled', 'filled');
  getAllConnectorPreviewElements().forEach(function (preview) {
    preview?.setAttribute('data-filled', 'filled');
  });
  loopNext.classList.add('active');
  loopPrevious.classList.add('active');
  loopNext.classList.remove('hidden');
  loopPrevious.classList.remove('hidden');
  if(!clickFromMain){
    if(window.innerWidth > 899){
      if(loopBundleVariantID.length < 1){
        if(capType == 'pebble'){
        for (const [index, e] of loopRadios.entries()) {
          if (!e.classList.contains('disabled')) {
            loopRadios[index].dispatchEvent(changeEvent)
            break;
          }
        }
      }
      else if(capType == 'bubble'){
        for (const [index, e] of bandRadios.entries()) {
          if (!e.classList.contains('disabled')) {
            bandRadios[index].dispatchEvent(changeEvent)
            break;
          }
        }
      }
      else if(isConnectorStyleCapType(capType)){
        for (const [index, e] of connectorRadios.entries()) {
          if (!e.classList.contains('disabled')) {
            connectorRadios[index].dispatchEvent(changeEvent)
            break;
          }
        }
      }
      else{
        for (const [index, e] of loopRadios.entries()) {
          if (!e.classList.contains('disabled')) {
            loopRadios[index].dispatchEvent(changeEvent)
            break;
          }
        }
      }
      }
    }
  }
}

function bootShowPreview() {
  sliderNavButtons.forEach(function (nav) {
    nav.classList.remove('active');
    nav.classList.remove('hidden');
  })
  // previewSections.forEach(function (ps) {
  //   ps.classList.remove('active');
  // })
  if (withBoot) {
    bottlePreview.classList.remove('active');
    bottlePreview32oz.classList.remove('active');
    bottlePreview30oz.classList.remove('active');
    if (bottleSizeOption == '25oz' || bottleSizeOption == '16oz' || bottleSizeOption == '30oz') {
      bootPreview32oz.classList.remove('active');
      bootPreview30oz.classList.remove('active');
      bootPreview.classList.add('active');
      checkAnimalObservatoryColor(bootMain25oz ? bootMain25oz : document.querySelector('.boot_component_radio[data-value="25oz"]:checked'));
    }
    else {
      bootPreview.classList.remove('active');
      bootPreview30oz.classList.remove('active');
      bootPreview32oz.classList.add('active');
      checkAnimalObservatoryColor(bootMain32oz ? bootMain32oz : document.querySelector('.boot_component_radio[data-value="32oz"]:checked'));
    }
    bootImage.parentElement.parentElement.classList.add('active');
    bootPreview.setAttribute('data-filled', 'filled');
    bootPreview32oz.setAttribute('data-filled', 'filled');
    bootPreview30oz.setAttribute('data-filled', 'filled');
    bootNext.classList.add('active');
    bootPrevious.classList.add('active');
    bootNext.classList.remove('hidden');
    bootPrevious.classList.remove('hidden');

    if(bottleSizeOption == '25oz' || bottleSizeOption == '16oz' || bottleSizeOption == '30oz'){
      bootNext.classList.add('active');
      bootPrevious.classList.add('active');
      bootNext.classList.remove('hidden');
      bootPrevious.classList.remove('hidden');
  
      bootNext32oz.classList.remove('active');
      bootPrevious32oz.classList.remove('active');
    }
    else{
      bootNext.classList.remove('active');
      bootPrevious.classList.remove('active');
  
      bootNext32oz.classList.add('active');
      bootPrevious32oz.classList.add('active');
      bootNext32oz.classList.remove('hidden');
      bootPrevious32oz.classList.remove('hidden');
    }
  }
  else {
    bootNext.classList.add('active');
    bootPrevious.classList.add('active');
    bootNext.classList.add('hidden');
    bootPrevious.classList.add('hidden');
    bootNext32oz.classList.add('active');
    bootPrevious32oz.classList.add('active');
    bootNext32oz.classList.add('hidden');
    bootPrevious32oz.classList.add('hidden');
  }
}

function isOutsideOptions(element) {
  return !element.closest('.scroll-up-to-choose') && !element.closest('.summary-content_options .form') && !element.closest('.loop-choices') && !element.closest('.boot-choices') && !element.closest('.cap-type-options');
}

bottleSizeRadios.forEach(function (bottleSize){
  bottleSize.addEventListener('change', function(e){
    sizeUpdate(bottleSize);
  });
});
bottleSizeRadiosMobile.forEach(function (bottleSize){
  bottleSize.addEventListener('change', function(e){
    sizeUpdate(bottleSize);
  });
});

let sizeChanging = false;
function sizeUpdate(bottleSize){
  bottleSizeHolder = bottleSize;
  bottleSizeOption = bottleSize.dataset.name;
  
  // Update component images for the new size
  updateComponentPreviewImages(bottleSizeOption);
  
  bottleShowPreview();
  changeSize(bottleSize);
  
  // Remove active class from all bottle previews
  const allBottlePreviews = [bottlePreview, bottlePreview16oz, bottlePreview30oz, bottlePreview32oz, bottlePreview40oz, bottlePreview64oz];
  allBottlePreviews.forEach(preview => preview?.classList.remove('active'));
  
  // Add active class and sync swiper for selected size
  if(bottleSizeOption == '25oz'){
    bottlePreview.classList.add('active');
    bottleSwiper.slideToLoop(bottleSwiper.realIndex, 0);
  }
  else if(bottleSizeOption == '32oz'){
    bottlePreview32oz.classList.add('active');
    bottleSwiper32oz.slideToLoop(bottleSwiper32oz.realIndex, 0);
  }
  else if(bottleSizeOption == '16oz'){
    bottlePreview16oz.classList.add('active');
    bottleSwiper16oz.slideToLoop(bottleSwiper16oz.realIndex, 0);
  }
  else if(bottleSizeOption == '30oz'){
    bottlePreview30oz.classList.add('active');
    bottleSwiper30oz.slideToLoop(bottleSwiper30oz.realIndex, 0);
  }
  else if(bottleSizeOption == '40oz'){
    bottlePreview40oz.classList.add('active');
    bottleSwiper40oz.slideToLoop(bottleSwiper40oz.realIndex, 0);
  }
  else if(bottleSizeOption == '64oz'){
    bottlePreview64oz.classList.add('active');
    bottleSwiper64oz.slideToLoop(bottleSwiper64oz.realIndex, 0);
  }

  scrollSummaryToColorSwatches(summaryBottleSectionMobile);
}
function changeSize(bottleSize){
  // if(bottleSize.dataset.name == '25oz'){
  //   sizeChanging = false;
  // }else{
  //   sizeChanging = true
  // }
  previewMainImage.forEach(p => {
    // p.style.opacity = 0;
  })
  capPreview.style.zIndex = '30';
  robocapPreview.style.zIndex = '30';
  loopPreview.style.zIndex = '35';
  bootPreview.style.zIndex = '20';
  bootPreview32oz.style.zIndex = '20';

  document.querySelector('.preview-main').classList.add('animation')
  customizationMain.dataset.size = bottleSize.dataset.name;
  
  // Update component preview images for the new size
  updateComponentPreviewImages(bottleSize.dataset.name);
  
  // Auto-switch to robo cap if changing to 64oz and currently using pebble cap
  const currentCapType = customizationMain.dataset.capType;
  if (bottleSize.dataset.name === '64oz' && (!currentCapType || currentCapType === 'pebble')) {
    const roboCapRadio = document.querySelector('.cap-type-options input[data-name="robo"]');
    if (roboCapRadio) {
      roboCapRadio.checked = true;
      roboCapRadio.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
  
  setTimeout(function(){
    document.querySelector('.preview-main').classList.remove('animation');
    previewMainImage.forEach(p => {
      p.style.opacity = '';
    })

    capPreview.style.zIndex = '';
    robocapPreview.style.zIndex = '';
    loopPreview.style.zIndex = '';
    bootPreview.style.zIndex = '';
    bootPreview32oz.style.zIndex = '';
  }, 300);

  document.querySelectorAll('#bottle-size-text').forEach(e => { e.innerText = bottleSizeOption; })
  const capType = customizationMain.dataset.capType;
  // Update cap and loop summaries using consolidated variables
  capType == 'robo' ? updateroboCapSummary(robocapMain) : capType == 'bubble' ? updateBubblecapSummary(bubblecapMain) : capType == 'base' ? updateBasecapSummary(basecapMain) : capType == 'chug' ? updateChugcapSummary(chugcapMain) : capType == 'sip' ? updateSipcapSummary(sipcapMain) : updateCapSummary(capMain);
  if (isConnectorStyleCapType(capType)) {
    updateConnectorSummary(connectorMain);
  } else if (capType == 'bubble') {
    updateBandSummary(bandMain);
  } else {
    updateLoopSummary(loopMain);
  }

  
  bootPreview.classList.remove('active'), bootPreview32oz.classList.remove('active');
  if (withBoot) {
    if (bottleSizeOption == '25oz' || bottleSizeOption == '16oz' || bottleSizeOption == '30oz') {
      updateBootSummary(bootMain25oz ? bootMain25oz : document.querySelector('.boot_component_radio[data-value="25oz"]:checked') );
      checkBootAvailability(bootMain25oz ? bootMain25oz : document.querySelector('.boot_component_radio[data-value="25oz"]:checked') );
      setTimeout(scrollSummarySectionDown, 1000);
    } else if(bottleSizeOption == '32oz'){
      updateBootSummary(bootMain32oz ? bootMain32oz : document.querySelector('.boot_component_radio[data-value="32oz"]:checked') );
      checkBootAvailability(bootMain32oz ? bootMain32oz : document.querySelector('.boot_component_radio[data-value="32oz"]:checked') ); 
      setTimeout(scrollSummarySectionDown, 1000);
    }
  }


  previewMainImage.forEach(function (pmi) {
    pmi.classList.remove('active')
  })

  previewSections.forEach(function (ps) {
    ps.classList.remove('active');
  })
  // updateBoot();
  if (bottleSizeOption === '25oz') {
    let backupBottleMain25oz = bottleMain25oz ? bottleMain25oz : bottleSwiper.slides[bottleSwiper.activeIndex];
    if(backupBottleMain25oz.classList.contains('disabled')){
      checkBottle(firstAvailableBottle25oz.dataset.name);
      backupBottleMain25oz = firstAvailableBottle25oz;
    }
    updateBottleSummary(backupBottleMain25oz);
    checkBottleAvailability(backupBottleMain25oz);  
  } else if (bottleSizeOption === '32oz') {
    let backupBottleMain32oz = bottleMain32oz ? bottleMain32oz : bottleSwiper32oz.slides[bottleSwiper32oz.activeIndex];
    if(backupBottleMain32oz.classList.contains('disabled')){
      checkBottle(firstAvailableBottle32oz.dataset.name);
      backupBottleMain32oz = firstAvailableBottle32oz;
    }
    updateBottleSummary(backupBottleMain32oz);
    checkBottleAvailability(backupBottleMain32oz);
  } else if (bottleSizeOption === '16oz') {
    
    let backupBottleMain16oz = bottleMain16oz ? bottleMain16oz : bottleSwiper16oz.slides[bottleSwiper16oz.activeIndex];
    if(backupBottleMain16oz.classList.contains('disabled')){
      checkBottle(firstAvailableBottle16oz.dataset.name);
      backupBottleMain16oz = firstAvailableBottle16oz;  
    }
    updateBottleSummary(backupBottleMain16oz);
    checkBottleAvailability(backupBottleMain16oz);
  } else if (bottleSizeOption === '30oz') {

    let backupBottleMain30ozz = bottleMain30oz ? bottleMain30oz : bottleSwiper30oz.slides[bottleSwiper30oz.activeIndex];
    if(backupBottleMain30ozz.classList.contains('disabled')){
      checkBottle(firstAvailableBottle30oz.dataset.name);
      backupBottleMain30ozz = firstAvailableBottle30oz;
    }
    updateBottleSummary(backupBottleMain30ozz);
    checkBottleAvailability(backupBottleMain30ozz);
  }
  else if (bottleSizeOption === '40oz') {
    let backupBottleMain40oz = bottleMain40oz ? bottleMain40oz : bottleSwiper40oz.slides[bottleSwiper40oz.activeIndex];
    bootVariantID = '';
    withBoot = false;
    updateBoot();
    if(backupBottleMain40oz.classList.contains('disabled')){
      checkBottle(firstAvailableBottle40oz.dataset.name);
      backupBottleMain40oz = firstAvailableBottle40oz;
    }
    updateBottleSummary(backupBottleMain40oz);
    checkBottleAvailability(backupBottleMain40oz);
  }
  else if (bottleSizeOption === '64oz') {
    let backupBottleMain64oz = bottleMain64oz ? bottleMain64oz : bottleSwiper64oz.slides[bottleSwiper64oz.activeIndex];
    bootVariantID = '';
    withBoot = false;
    updateBoot();
    if(backupBottleMain64oz.classList.contains('disabled')){
      checkBottle(firstAvailableBottle64oz.dataset.name);
      backupBottleMain64oz = firstAvailableBottle64oz;
    }
    updateBottleSummary(backupBottleMain64oz);
    checkBottleAvailability(backupBottleMain64oz);
  }
    bottleShowPreview()

    // updateBoot();
    if(bootSection.classList.contains('active') || document.querySelector('#boot-tab').checked){
      bootShowPreview();
    }
    else{

      bottleShowPreview()
    }
    // bootSection.classList.contains('active') || document.querySelector('#boot-tab').checked ? bootShowPreview() : (bottleShowPreview(), bottleSizeOption == '25oz' ? updateBottleSummary(bottleMain25oz) : updateBottleSummary(bottleMain32oz));
  updatePricing();
}

// event listener for bottle section radios
bottleRadios.forEach(function (element) {
  element.addEventListener('change', function (e) {
    bottleRadioUpdate(element);
    updatePricing();
    bottleSizeOption == '25oz' ? currentSection == 'bottle' ? element.classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '' : '';
  });
});

bottleRadios32oz.forEach(function (element) {
  element.addEventListener('change', function (e) {
    bottleRadioUpdate(element);
    updatePricing();
    bottleSizeOption == '32oz' ? currentSection == 'bottle' ? element.classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '' : '';
  });
});

bottleRadios16oz.forEach(function (element) {
  element.addEventListener('change', function (e) {
    bottleRadioUpdate(element);
    updatePricing();
    bottleSizeOption == '16oz' ? currentSection == 'bottle' ? element.classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '' : '';
  });
});

bottleRadios30oz.forEach(function (element) {
  element.addEventListener('change', function (e) {
    bottleRadioUpdate(element);
    updatePricing();
    bottleSizeOption == '30oz' ? currentSection == 'bottle' ? element.classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '' : '';
  });
});

bottleRadios40oz.forEach(function (element) {
  element.addEventListener('change', function (e) {
    bottleRadioUpdate(element);
    updatePricing();
    bottleSizeOption == '40oz' ? currentSection == 'bottle' ? element.classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '' : '';
  });
});

bottleRadios64oz.forEach(function (element) {
  element.addEventListener('change', function (e) {
    bottleRadioUpdate(element);
    updatePricing();
    bottleSizeOption == '64oz' ? currentSection == 'bottle' ? element.classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '' : '';
  });
});

let bottleIndex = 0;
function bottleRadioUpdate(element) {
  const currentIndex = parseInt(element.dataset.slider_index);
  if(currentIndex > bottleIndex + 5 || currentIndex < bottleIndex - 5){
    animationSpeed = 1000;
  }
  bottleIndex = parseInt(element.dataset.slider_index);
  customizationMain.classList.contains('show') ? (bottleSlideToPreviewMain(element.dataset.slider_index)) : (bottleSlideToPreviewMain(element.dataset.slider_index));
  animationSpeed = 300;
  updateBottleSummary(element);
  checkColor(element.dataset.variant_color);
  checkBottleAvailability(element);

}

function updateBottleSummary(value) {
  var bottle;
  bottleSizeOption == '25oz' ? bottle = bottleRadios[0] : bottleSizeOption == '32oz' ? bottle = bottleRadios32oz[0] : bottleSizeOption == '30oz' ? bottle = bottleRadios30oz[0] : bottleSizeOption == '40oz' ? bottle = bottleRadios40oz[0] : bottleSizeOption == '64oz' ? bottle = bottleRadios64oz[0] : bottle = bottleRadios16oz[0];
  const element = value ? value : bottle;
    checkAnimalObservatoryColor(bottleSizeOption == '16oz' ? bottleMain16oz ? bottleMain16oz : element : element);
  const name = element.dataset.name;
  const background = element.dataset.background;
  const mode = element.getAttribute('dark-text-mode');
  const image = element.dataset.image;
  const bundleVariantID = element.dataset.variant_id;
  const singleVariantID = element.dataset.main_variant;
  let textColor;
  let backgroundColor;
  if(element.classList.contains('no_engraving')){
    customizationMain.classList.add('no_engraving');
  }
  else{
    customizationMain.classList.remove('no_engraving');
  }
  element.dataset.colorType == "limited" 
    ? (
    bottleColorTextLimited.innerText = name, 
    bottleColorTextClassic.innerText = "", 
    bottleColorTextLimited32oz.innerText = name, 
    bottleColorTextClassic32oz.innerText = "", 
    bottleColorTextLimited30oz.innerText = name, 
    bottleColorTextClassic30oz.innerText = "", 
    bottleColorTextLimited16oz.innerText = name, 
    bottleColorTextClassic16oz.innerText = "", 
    bottleColorTextLimited40oz.innerText = name, 
    bottleColorTextClassic40oz.innerText = "", 
    bottleColorTextLimited64oz.innerText = name, 
    bottleColorTextClassic64oz.innerText = "", 
    summaryBottleSection.setAttribute('color_type', 'limited'))
    : element.dataset.colorType == "animal"
    ? (
    bottleColorTextLimited.innerText = "", 
    bottleColorTextClassic.innerText = "", 
    bottleColorTextLimited32oz.innerText = "", 
    bottleColorTextClassic32oz.innerText = "", 
    bottleColorTextLimited16oz.innerText = "", 
    bottleColorTextClassic16oz.innerText = "", 
    bottleColorTextAnimal16oz.innerText = name,
    bottleColorTextLimited40oz.innerText = "", 
    bottleColorTextClassic40oz.innerText = "", 
    bottleColorTextAnimal40oz.innerText = name,
    bottleColorTextLimited64oz.innerText = "", 
    bottleColorTextClassic64oz.innerText = "", 
    bottleColorTextAnimal64oz.innerText = name,
    summaryBottleSection.setAttribute('color_type', 'animal'))
    : (
    bottleColorTextLimited.innerText = '', 
    bottleColorTextClassic.innerText = name, 
    bottleColorTextLimited32oz.innerText = '', 
    bottleColorTextClassic32oz.innerText = name, 
    bottleColorTextLimited30oz.innerText = '', 
    bottleColorTextClassic30oz.innerText = name, 
    bottleColorTextLimited16oz.innerText = '', 
    bottleColorTextClassic16oz.innerText = name, 
    bottleColorTextAnimal16oz.innerText = "",
    bottleColorTextLimited40oz.innerText = '', 
    bottleColorTextClassic40oz.innerText = name, 
    bottleColorTextAnimal40oz.innerText = "",
    bottleColorTextLimited64oz.innerText = '', 
    bottleColorTextClassic64oz.innerText = name, 
    bottleColorTextAnimal64oz.innerText = "",
    summaryBottleSection.setAttribute('color_type', 'classic'));
  chosenBottle = name;
  if (mode == 'true') {
    engravingColor = 'dark';

  } else {
    engravingColor = 'light';
  }
  previewEngraving.setAttribute('data-text_color', engravingColor);
  popupEngraving.setAttribute('data-text_color', engravingColor);

  if (background != '') {
    backgroundColor = background;
  }
  else if (background == '') {
    backgroundColor = '#ffffff';
    textColor = '#352b27'
  }
  changeBackground(backgroundColor, textColor);
  bottlePreview.setAttribute('data-filled', 'filled');
  bottlePreview32oz.setAttribute('data-filled', 'filled');
  bottlePreview30oz.setAttribute('data-filled', 'filled');
  bottlePreview16oz.setAttribute('data-filled', 'filled');
  bottlePreview40oz.setAttribute('data-filled', 'filled');
  bottlePreview64oz.setAttribute('data-filled', 'filled');
  bottleImage.src = imageSrcWithoutWidthParam(element.dataset.image);
  popupBottleImage.src = imageSrcWithoutWidthParam(element.dataset.image);
  bottleBundleVariantID = bundleVariantID;
  bottleIndividualVariantID = singleVariantID;
  bottleBundleVariantID32oz = bundleVariantID;
  bottleIndividualVariantID32oz = singleVariantID;
  bottleBundleVariantID30oz = bundleVariantID;
  bottleIndividualVariantID30oz = singleVariantID;
  bottleBundleVariantID40oz = bundleVariantID;
  bottleIndividualVariantID40oz = singleVariantID;
  bottleBundleVariantID64oz = bundleVariantID;
  bottleIndividualVariantID64oz = singleVariantID;
  bottleInventory = {
    variantID: bundleVariantID,
    variantQuantity: element.dataset.item_count
  }
  syncBottleRadioCheckedForCurrentSize(name);
  updateSummaryOverview();
}

function syncBottleRadioCheckedForCurrentSize(name) {
  var radio = findBottleRadioByName(name);
  if (!radio) return;
  var radios = getBottleRadiosForCurrentSize();
  for (var i = 0; i < radios.length; i++) {
    radios[i].checked = radios[i] === radio;
  }
}

// change background and text on bottle change
function changeBackground(backgroundColor, textColor) {
  customizationMain.style.setProperty('--background-color', backgroundColor);
}

  let capIndex = 0;
// event listener for cap section radios
capRadios.forEach(function (element) {
  element.addEventListener('change', function (e) {
    const currentIndex = parseInt(element.dataset.slider_index);
    if (currentIndex > capIndex + 5 || currentIndex < capIndex - 5) {
      animationSpeed = 1000;
    }
    capIndex = currentIndex;
    capSlideToPreview(element.dataset.slider_index);
    const image = bottleSizeOption == '25oz' ? element.dataset.image : element.dataset.image_32oz ? element.dataset.image_32oz : '';
    if (getCapType() === 'pebble') updateCapSummary(element);
    currentSection == 'cap' ? element.classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '';
    const capType = document.querySelector('.flask-customization-main').dataset.capType;
    capType == 'robo' ? '' : checkCapAvailability(element);
    updatePricing();
    animationSpeed = 300;
  });
});

function updateCapSummary(value) {
  const element = value ? value : capRadios[0];
  const name = element.dataset.name;
  const image = element.dataset.image;
  const image_32oz = element.dataset.image_32oz;
  const image_16oz = element.dataset.image_16oz;
  const image_30oz = element.dataset.image_30oz || element.dataset.image;
  const image_40oz = element.dataset.image_40oz;
  const image_64oz = element.dataset.image_64oz;
  const bundleVariantID = element.dataset.variant_id;
  const singleVariantID = element.dataset.main_variant;
  const capType = document.querySelector('.flask-customization-main').dataset.capType;

  element.dataset.colorType == "limited" ? (capColorTextLimited.innerText = name, capColorTextClassic.innerText = "", summaryCapSection.setAttribute('color_type', 'limited')) : (capColorTextLimited.innerText = '', capColorTextClassic.innerText = name, summaryCapSection.setAttribute('color_type', 'classic'))
  chosenCap = name;
  capPreview.setAttribute('data-filled', 'filled');
  
  // Set cap image based on bottle size
  let capImageSrc = image;
  if(bottleSizeOption == '32oz') capImageSrc = image_32oz;
  else if(bottleSizeOption == '16oz') capImageSrc = image_16oz;
  else if(bottleSizeOption == '30oz') capImageSrc = image_30oz;
  else if(bottleSizeOption == '40oz') capImageSrc = image_40oz || image_32oz;
  else if(bottleSizeOption == '64oz') capImageSrc = image_64oz || image_32oz;
  
  if (capType === 'pebble') {
    capImage.src = imageSrcWithoutWidthParam(capImageSrc);
    markCapSectionFilled();
    popupCapImage.src = imageSrcWithoutWidthParam(capImageSrc);
  }
  capType == 'robo' ? capBundleVariantID = '' : (capType === 'pebble' ? capBundleVariantID = bundleVariantID : '');
  capType == 'robo' ? capIndividualVariantID = '' : (capType === 'pebble' ? capIndividualVariantID = singleVariantID : '');
  capType == 'robo' ? capInventory = '' : (capType === 'pebble' ? capInventory = {
    variantID: bundleVariantID,
    variantQuantity: element.dataset.item_count
  } : capInventory);
  updatePricing();
  updateSummaryOverview();
}


let robocapIndex = 0;
// event listener for robocap section radios
robocapRadios.forEach(function (element) {
  element.addEventListener('change', function (e) {
    const currentIndex = parseInt(element.dataset.slider_index);
    if (currentIndex > robocapIndex + 5 || currentIndex < robocapIndex - 5) {
      animationSpeed = 1000;
    }
    robocapIndex = currentIndex;
    robocapSlideToPreview(element.dataset.slider_index);
    const image = bottleSizeOption == '25oz' ? element.dataset.image : element.dataset.image_32oz ? element.dataset.image_32oz : '';
    updateroboCapSummary(element);
    currentSection == 'cap' ? element.classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '';
    const capType = document.querySelector('.flask-customization-main').dataset.capType;
    capType == 'robo' ? checkroboCapAvailability(element) : '';
    updatePricing();
    animationSpeed = 300;
  });
});

// event listener for bubblecap section radios
let bubblecapIndex = 0;
bubblecapRadios.forEach(function (element) {
  element.addEventListener('change', function (e) {
    const currentIndex = parseInt(element.dataset.slider_index);
    if (currentIndex > bubblecapIndex + 5 || currentIndex < bubblecapIndex - 5) {
      animationSpeed = 1000;
    }
    bubblecapIndex = currentIndex;
    bubblecapSlideToPreview(element.dataset.slider_index);
    const image = bottleSizeOption == '25oz' ? element.dataset.image : element.dataset.image_32oz ? element.dataset.image_32oz : '';
    updateBubblecapSummary(element);
    currentSection == 'cap' ? element.classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '';
    const capType = document.querySelector('.flask-customization-main').dataset.capType;
    capType == 'bubble' ? checkBubbleAvailability(element) : '';
    updatePricing();
    animationSpeed = 300;
  });
});

function updateroboCapSummary(value) {
  const element = value ? value : robocapRadios[0];
  const name = element.dataset.name;
  const image = element.dataset.image;
  const image_32oz = element.dataset.image_32oz;
  const image_16oz = element.dataset.image_16oz;
  const image_30oz = element.dataset.image_30oz || element.dataset.image;
  const image_40oz = element.dataset.image_40oz;
  const image_64oz = element.dataset.image_64oz;
  const bundleVariantID = element.dataset.variant_id;
  const singleVariantID = element.dataset.main_variant;
  const capType = document.querySelector('.flask-customization-main').dataset.capType;

  element.dataset.colorType == "limited" ? (robocapColorTextLimited.innerText = name, robocapColorTextClassic.innerText = "", robocapColorTextAnimal.innerText = "", summaryCapSection.setAttribute('color_type', 'limited')) : element.dataset.colorType == "animal" ? (robocapColorTextLimited.innerText = "", robocapColorTextClassic.innerText = "", robocapColorTextAnimal.innerText = name, summaryCapSection.setAttribute('color_type', 'animal')) : (robocapColorTextLimited.innerText = '', robocapColorTextClassic.innerText = name, robocapColorTextAnimal.innerText = "", summaryCapSection.setAttribute('color_type', 'classic'));

  checkAnimalObservatoryColor(robocapMain ? robocapMain : element);

  chosenCap = name;
  robocapPreview.setAttribute('data-filled', 'filled');
  
  // Set cap image based on bottle size
  let robocapImageSrc = image;
  if(bottleSizeOption == '32oz') robocapImageSrc = image_32oz;
  else if(bottleSizeOption == '16oz') robocapImageSrc = image_16oz;
  else if(bottleSizeOption == '30oz') robocapImageSrc = image_30oz;
  else if(bottleSizeOption == '40oz') robocapImageSrc = image_40oz || image_32oz;
  else if(bottleSizeOption == '64oz') robocapImageSrc = image_64oz || image_32oz;
  
  capType == 'robo' ? (capImage.src = imageSrcWithoutWidthParam(robocapImageSrc)) : '';
  if (capType === 'robo') {
    markCapSectionFilled();
    popupCapImage.src = imageSrcWithoutWidthParam(robocapImageSrc);
  }

  capType == 'robo' ? capBundleVariantID = bundleVariantID : '';
  capType == 'robo' ? capIndividualVariantID = singleVariantID : '';
  capType == 'robo' ? capInventory = {
    variantID: bundleVariantID,
    variantQuantity: element.dataset.item_count
  } : '';
  updatePricing();
  updateSummaryOverview();
}

function updateBubblecapSummary(value) {
  const element = value ? value : bubblecapRadios[0];
  const name = element.dataset.name;
  const image = element.dataset.image;
  const image_32oz = element.dataset.image_32oz;
  const image_16oz = element.dataset.image_16oz;
  const image_30oz = element.dataset.image_30oz || element.dataset.image;
  const image_40oz = element.dataset.image_40oz;
  const image_64oz = element.dataset.image_64oz;
  const bundleVariantID = element.dataset.variant_id;
  const singleVariantID = element.dataset.main_variant;
  const capType = document.querySelector('.flask-customization-main').dataset.capType;

  element.dataset.colorType == "limited" ? (bubblecapColorTextLimited.innerText = name, bubblecapColorTextClassic.innerText = "", bubblecapColorTextAnimal.innerText = "", summaryCapSection.setAttribute('color_type', 'limited')) : element.dataset.colorType == "animal" ? (bubblecapColorTextLimited.innerText = "", bubblecapColorTextClassic.innerText = "", bubblecapColorTextAnimal.innerText = name, summaryCapSection.setAttribute('color_type', 'animal')) : (bubblecapColorTextLimited.innerText = '', bubblecapColorTextClassic.innerText = name, bubblecapColorTextAnimal.innerText = "", summaryCapSection.setAttribute('color_type', 'classic'));

  if(document.querySelector('.bubblecap-preview.active'))
    checkAnimalObservatoryColor(bubblecapMain ? bubblecapMain : element);

  chosenCap = name;
  bubblecapPreview.setAttribute('data-filled', 'filled');
  
  // Set cap image based on bottle size
  let bubblecapImageSrc = image;
  if(bottleSizeOption == '32oz') bubblecapImageSrc = image_32oz;
  else if(bottleSizeOption == '16oz') bubblecapImageSrc = image_16oz;
  else if(bottleSizeOption == '30oz') bubblecapImageSrc = image_30oz;
  else if(bottleSizeOption == '40oz') bubblecapImageSrc = image_40oz || image_32oz;
  else if(bottleSizeOption == '64oz') bubblecapImageSrc = image_64oz || image_32oz;
  
  capType == 'bubble' ? (capImage.src = imageSrcWithoutWidthParam(bubblecapImageSrc)) : '';
  if (capType === 'bubble') {
    markCapSectionFilled();
    popupCapImage.src = imageSrcWithoutWidthParam(bubblecapImageSrc);
  }

  capType == 'bubble' ? capBundleVariantID = bundleVariantID : '';
  capType == 'bubble' ? capIndividualVariantID = singleVariantID : '';
  capType == 'bubble' ? capInventory = {
    variantID: bundleVariantID,
    variantQuantity: element.dataset.item_count
  } : '';
  updatePricing();
  updateSummaryOverview();
}


// event listener for loop section radios
let loopIndex = 0;
loopRadiosMobile.forEach(function (element) {
  element.addEventListener('change', function (e) {
    const currentIndex = parseInt(element.dataset.slider_index);
    if (currentIndex > loopIndex + 5 || currentIndex < loopIndex - 5) {
      animationSpeed = 1000;
    }
    loopIndex = currentIndex;
    loopSlideToPreview(element.dataset.slider_index);
    updateLoopSummary(element);
    currentSection == 'loop'
      ? element.classList.contains('disabled')
        ? scrollDownIfOOS(true)
        : scrollDownIfOOS(false)
      : '';
    checkLoopAvailability(element);
    updatePricing();
    animationSpeed = 300;
  });
});

let loopColorType = null;
function updateLoopSummary(value) {
  const element = value ? value : loopRadios[0];
  loopColorType = element.dataset.colorType;
  const name = element.dataset.name;
  const image = element.dataset.image;
  const image_32oz = element.dataset.image_32oz;
  const image_16oz = element.dataset.image_16oz;
  const image_30oz = element.dataset.image_30oz || element.dataset.image;
  const image_40oz = element.dataset.image_40oz;
  const image_64oz = element.dataset.image_64oz;
  const bundleVariantID = element.classList.contains('disabled') ? '' : element.dataset.variant_id;
  const singleVariantID = element.dataset.main_variant;
  const capType = customizationMain.dataset.capType;

  if (element.dataset.colorType == "limited") {
      loopColorTextLimited.innerText = name;
      loopColorTextClassic.innerText = "";
      loopColorTextCharm.innerText = "";
      summaryLoopSection.setAttribute('color_type', 'limited');
  } 
  else if (element.dataset.colorType == 'charm') {
    loopColorTextLimited.innerText = "";
    loopColorTextClassic.innerText = "";
    loopColorTextCharm.innerText = name.replace('charm loop ','');
    summaryLoopSection.setAttribute('color_type', 'charm');
  }
  else {
      loopColorTextLimited.innerText = "";
      loopColorTextCharm.innerText = "";
      loopColorTextClassic.innerText = name;
      summaryLoopSection.setAttribute('color_type', 'classic');
  }

  chosenLoop = name;
  loopPreview.setAttribute('data-filled', 'filled');
  
  // Set loop image based on bottle size
  let loopImageSrc = image;
  if(bottleSizeOption == '32oz') loopImageSrc = image_32oz;
  else if(bottleSizeOption == '16oz') loopImageSrc = image_16oz;
  else if(bottleSizeOption == '30oz') loopImageSrc = image_30oz;
  else if(bottleSizeOption == '40oz') loopImageSrc = image_40oz || image_32oz;
  else if(bottleSizeOption == '64oz') loopImageSrc = image_64oz || image_32oz;
  
  capType == 'robo' ? '' : (loopImage.src = imageSrcWithoutWidthParam(loopImageSrc));
  if (capType === 'pebble') {
    popupLoopImage.src = imageSrcWithoutWidthParam(loopImageSrc);
  }
  // loopImage.src = bottleSizeOption == '25oz' ? image : image_32oz;
  // popupLoopImage.src = bottleSizeOption == '25oz' ? image : image_32oz;
    if(capType == 'pebble'){
      if (withLoop) {
        loopBundleVariantID = bundleVariantID;
        loopIndividualVariantID = singleVariantID;
        loopInventory = {
          variantID: bundleVariantID,
          variantQuantity: element.dataset.item_count
        }
      }
  }
  updatePricing();
  updateSummaryOverview();

}


// event listener for connector section radios
let connectorIndex = 0;
connectorRadiosMobile.forEach(function (element) {
  element.addEventListener('change', function (e) {
    const currentIndex = parseInt(element.dataset.slider_index);
    if (currentIndex > connectorIndex + 5 || currentIndex < connectorIndex - 5) {
      animationSpeed = 1000;
    }
    connectorIndex = currentIndex;
    connectorSlideToPreview(element.dataset.slider_index);
    updateConnectorSummary(element);
    currentSection == 'loop'
      ? element.classList.contains('disabled')
        ? scrollDownIfOOS(true)
        : scrollDownIfOOS(false)
      : '';
    checkConnectorAvailability(element);
    updatePricing();
    animationSpeed = 300;
  });
});
let connectorColorType = null;
let bandColorType = null;
function updateConnectorSummary(value) {
  const element = value ? value : connectorRadios[0];
  connectorColorType = element.dataset.colorType;
  const name = element.dataset.name;
  const image = element.dataset.image;
  const image_32oz = element.dataset.image_32oz;
  const image_16oz = element.dataset.image_16oz;
  const image_30oz = element.dataset.image_30oz || element.dataset.image;
  const image_40oz = element.dataset.image_40oz;
  const image_64oz = element.dataset.image_64oz;
  const bundleVariantID = element.dataset.variant_id;
  const singleVariantID = element.dataset.main_variant;
  const capType = document.querySelector('.flask-customization-main').dataset.capType;

  checkAnimalObservatoryColor(getConnectorMainForCapType(capType) || element);

  if (element.dataset.colorType == "limited") {
      connectorColorTextLimited.innerText = name;
      connectorColorTextClassic.innerText = "";
      connectorColorTextAnimal.innerText = "";
      summaryLoopSection.setAttribute('color_type', 'limited');
  } 
  else if (element.dataset.colorType == 'charm') {
    connectorColorTextLimited.innerText = "";
    connectorColorTextClassic.innerText = "";
    connectorColorTextAnimal.innerText = "";
    summaryLoopSection.setAttribute('color_type', 'charm');
  }
  else if (element.dataset.colorType == 'animal') {
    connectorColorTextLimited.innerText = "";
    connectorColorTextClassic.innerText = "";
    connectorColorTextAnimal.innerText = name;
    summaryLoopSection.setAttribute('color_type', 'animal');
  }
  else {
      connectorColorTextLimited.innerText = "";
      connectorColorTextClassic.innerText = name;
      connectorColorTextAnimal.innerText = "";
      summaryLoopSection.setAttribute('color_type', 'classic');
  }

  chosenLoop = name;
  const activeConnectorPreview = connectorPreview;
  if (activeConnectorPreview) activeConnectorPreview.setAttribute('data-filled', 'filled');

  const connectorImageSrc = getConnectorImageSrcFromElement(element, capType);

  if (isConnectorStyleCapType(capType)) {
    loopImage.src = imageSrcWithoutWidthParam(connectorImageSrc);
    popupLoopImage.src = imageSrcWithoutWidthParam(connectorImageSrc);
  }

  if (isConnectorStyleCapType(capType)) {
    markLoopAccessorySectionFilled();
    if (withLoop) {
      loopBundleVariantID = bundleVariantID;
      loopIndividualVariantID = singleVariantID;
      loopInventory = {
        variantID: bundleVariantID,
        variantQuantity: element.dataset.item_count
      }
    }
  }
  updatePricing();
  updateSummaryOverview();

}
let bandIndex = 0;
bandRadiosMobile.forEach(function (element) {
  element.addEventListener('change', function (e) {
    const currentIndex = parseInt(element.dataset.slider_index);
    if (currentIndex > bandIndex + 5 || currentIndex < bandIndex - 5) {
      animationSpeed = 1000;
    }
    bandIndex = currentIndex;
    bandSlideToPreview(element.dataset.slider_index);
    updateBandSummary(element);
    currentSection == 'loop'
      ? element.classList.contains('disabled')
        ? scrollDownIfOOS(true)
        : scrollDownIfOOS(false)
      : '';
    checkBandAvailability(element);
    updatePricing();
    animationSpeed = 300;
  });
});

function updateBandSummary(value) {
  const element = value ? value : bandRadios[0];
  bandColorType = element.dataset.colorType;
  const name = element.dataset.name;
  const image = element.dataset.image;
  const image_32oz = element.dataset.image_32oz;
  const image_16oz = element.dataset.image_16oz;
  const image_30oz = element.dataset.image_30oz || element.dataset.image;
  const image_40oz = element.dataset.image_40oz;
  const image_64oz = element.dataset.image_64oz;
  const bundleVariantID = element.dataset.variant_id;
  const singleVariantID = element.dataset.main_variant;
  const capType = document.querySelector('.flask-customization-main').dataset.capType;

  checkAnimalObservatoryColor(bandMain ? bandMain : element);

  if (element.dataset.colorType == "limited") {
      bandColorTextLimited.innerText = name;
      bandColorTextClassic.innerText = "";
      bandColorTextAnimal.innerText = "";
      summaryLoopSection.setAttribute('color_type', 'limited');
  } 
  else if (element.dataset.colorType == 'charm') {
    bandColorTextLimited.innerText = "";
    bandColorTextClassic.innerText = "";
    bandColorTextAnimal.innerText = "";
    summaryLoopSection.setAttribute('color_type', 'charm');
  }
  else if (element.dataset.colorType == 'animal') {
    bandColorTextLimited.innerText = "";
    bandColorTextClassic.innerText = "";
    bandColorTextAnimal.innerText = name;
    summaryLoopSection.setAttribute('color_type', 'animal');
  }
  else {
      bandColorTextLimited.innerText = "";
      bandColorTextClassic.innerText = name;
      bandColorTextAnimal.innerText = "";
      summaryLoopSection.setAttribute('color_type', 'classic');
  }

  chosenLoop = name;
  bandPreview.setAttribute('data-filled', 'filled');
  
  // Set band image based on bottle size
  let bandImageSrc = image;
  if(bottleSizeOption == '32oz') bandImageSrc = image_32oz;
  else if(bottleSizeOption == '16oz') bandImageSrc = image_16oz;
  else if(bottleSizeOption == '30oz') bandImageSrc = image_30oz;
  else if(bottleSizeOption == '40oz') bandImageSrc = image_40oz || image_32oz;
  else if(bottleSizeOption == '64oz') bandImageSrc = image_64oz || image_32oz;
  
  capType == 'bubble' ? (loopImage.src = imageSrcWithoutWidthParam(bandImageSrc)) : '';
  if (capType === 'bubble') {
    popupLoopImage.src = imageSrcWithoutWidthParam(bandImageSrc);
  }

  if(capType == 'bubble'){
    markLoopAccessorySectionFilled();
    if (withLoop) {
      loopBundleVariantID = bundleVariantID;
      loopIndividualVariantID = singleVariantID;
      loopInventory = {
        variantID: bundleVariantID,
        variantQuantity: element.dataset.item_count
      }
    }
  }
  updatePricing();
  updateSummaryOverview();

}

// event listener for boot section radios
bootRadios.forEach(function (element) {
  element.addEventListener('change', function (e) {
    bootRadioUpdate(element);
    currentSection == 'boot' ? element.classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '';
  });
});
bootRadios32oz.forEach(function (element) {
  element.addEventListener('change', function (e) {
    bootRadioUpdate(element);
    currentSection == 'boot' ? element.classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '';
  });
});


let bootIndex = 0
function bootRadioUpdate(element){
  const currentIndex = parseInt(element.dataset.slider_index);
  if(currentIndex > bootIndex + 5 || currentIndex < bootIndex - 5){
    animationSpeed = 1000;
  }
  bootIndex = currentIndex;
  bootSlideToPreview(element.dataset.slider_index);
  updateBootSummary(element);
  checkBootAvailability(element);
  animationSpeed = 300;
  updatePricing();

}

function updateBootSummary(value) {
  var element;
  if(bottleSizeOption == '25oz' || bottleSizeOption == '16oz' || bottleSizeOption == '30oz'){
   element = value ? value : bootRadios[0];
  }else{
   element = value ? value : bootRadios32oz[0];
  }
  const name = element.dataset.name;
  const image = element.dataset.image;
  const variantID = element.dataset.variant_id;
  checkAnimalObservatoryColor(bottleSizeOption == '16oz' || bottleSizeOption == '25oz' || bottleSizeOption == '30oz' ? bootMain16oz ? bootMain16oz : element : element);

  if (element.dataset.colorType == "limited") {
    bootColorTextLimited.innerText = name;
    bootColorTextLimited32oz.innerText = name;
    bootColorTextClassic.innerText = "";
    bootColorTextClassic32oz.innerText = "";
    bootColorTextAnimal.innerText = "";
    bootColorTextCandy.innerText = "";
    bootColorTextCandy32oz.innerText = "";
    summaryBootSection.setAttribute('color_type', 'limited');
  } else if(element.dataset.colorType == 'animal') {
    bootColorTextLimited.innerText = "";
    bootColorTextLimited32oz.innerText = "";
    bootColorTextClassic.innerText = "";
    bootColorTextClassic32oz.innerText = "";
    bootColorTextAnimal.innerText = name;
    bootColorTextCandy.innerText = "";
    bootColorTextCandy32oz.innerText = "";
    summaryBootSection.setAttribute('color_type', 'animal');
  } else if(element.dataset.colorType == 'candy') {
    bootColorTextLimited.innerText = "";
    bootColorTextLimited32oz.innerText = "";
    bootColorTextClassic.innerText = "";
    bootColorTextClassic32oz.innerText = "";
    bootColorTextAnimal.innerText = "";
    bootColorTextCandy.innerText = name;
    bootColorTextCandy32oz.innerText = name;
    summaryBootSection.setAttribute('color_type', 'candy');
  } else {
    bootColorTextLimited.innerText = '';
    bootColorTextLimited32oz.innerText = '';
    bootColorTextClassic.innerText = name;
    bootColorTextClassic32oz.innerText = name;
    bootColorTextAnimal.innerText = "";
    bootColorTextCandy.innerText = "";
    bootColorTextCandy32oz.innerText = "";
    summaryBootSection.setAttribute('color_type', 'classic');
  }

  chosenBoot = name;
  bootPreview.setAttribute('data-filled', 'filled');
  bootPreview32oz.setAttribute('data-filled', 'filled');
  bootImage.src = imageSrcWithoutWidthParam(image);
  popupBootImage.src = imageSrcWithoutWidthParam(image);
  bootVariantID = variantID;

  bootInventory = {
    variantID: variantID,
    variantQuantity: element.dataset.item_count
  }
  updatePricing();
  updateSummaryOverview();
}

const loopMainImage = document.querySelector('.main-image-loop');
let temporaryLoopBundleVID = '';
let temporaryLoopIndividualVID = '';


// event listener for boot add-on
bootChoices.addEventListener('click', function (e) {
  [...bootChoices.children].forEach(function (element) {
    element.classList.remove('active');
  });
  if (e.target.closest('#add_boot')) {
    e.target.closest('#add_boot').classList.add('active');
    withBoot = true;
  }
  else {
    e.target.closest('#no_boot').classList.add('active')
    withBoot = false;
  }
  updateBoot();
});

const bootMainImage = document.querySelector('.main-image-boot');
let temporaryBootVID = '';

function updateBoot() {
  if (withBoot) {
    bootColorSection.classList.remove('hidden');
    bootColorSectionMobile.classList.remove('hidden');
    bootColorSection32oz.classList.remove('hidden');
    bootColorSectionMobile32oz.classList.remove('hidden');
    bootSection.querySelector('.boot-section_header h3').innerText = "Boot";
    bootSection.dataset.boot = 'with';
    bootPreview.dataset.boot = 'with';
    bootPreview32oz.dataset.boot = 'with';
    previewSections.forEach(function (ps) {
      ps.classList.remove('active');
    })
    if (bottleSizeOption == '25oz' || bottleSizeOption == '16oz' || bottleSizeOption == '30oz') {
      bootPreview.classList.add('active');
      bootPreview32oz.classList.remove('active');
    }
    else {
      bootPreview32oz.classList.add('active');
      bootPreview.classList.remove('active');
    };
    bootMainImage.classList.remove('hidden');
    bootMainImage.classList.add('active');
    popupBootImage.classList.remove('hidden');

    bootNext.classList.add('active');
    bootPrevious.classList.add('active');


    if(bottleSizeOption == '25oz' || bottleSizeOption == '16oz' || bottleSizeOption == '30oz'){
      bootNext.classList.add('active');
      bootPrevious.classList.add('active');
      bootNext.classList.remove('hidden');
      bootPrevious.classList.remove('hidden');
  
      bootNext32oz.classList.remove('active');
      bootPrevious32oz.classList.remove('active');
    }
    else{
      bootNext.classList.remove('active');
      bootPrevious.classList.remove('active');
  
      bootNext32oz.classList.add('active');
      bootPrevious32oz.classList.add('active');
      bootNext32oz.classList.remove('hidden');
      bootPrevious32oz.classList.remove('hidden');
    }

    bootSection.setAttribute('data-filled', 'filled');
    if (bootSection.getAttribute('data-filled') === 'empty') {
      if(bottleSizeOption == '25oz' || bottleSizeOption == '16oz' || bottleSizeOption == '30oz'){
        bootSection.querySelector('.color-section#boot-25oz').querySelectorAll('input[type="radio"]')[0].checked = true;
        bootSection.querySelector('.color-section#boot-25oz').querySelectorAll('input[type="radio"]')[0].dispatchEvent(changeEvent);
      }
      else{
        bootSection.querySelector('.color-section#boot-32oz').querySelectorAll('input[type="radio"]')[0].checked = true;
        bootSection.querySelector('.color-section#boot-32oz').querySelectorAll('input[type="radio"]')[0].dispatchEvent(changeEvent);
      }
    }
    if (bootVariantID.length < 1 && temporaryBootVID.length < 1 && bootIsAvailable) {
      if(bottleSizeOption == '25oz' || bottleSizeOption == '16oz' || bottleSizeOption == '30oz'){
        bootSection.querySelector('.color-section#boot-25oz').querySelectorAll('input[type="radio"]')[0].checked = true;
        bootSection.querySelector('.color-section#boot-25oz').querySelectorAll('input[type="radio"]')[0].dispatchEvent(changeEvent);
      }
      else{
        bootSection.querySelector('.color-section#boot-32oz').querySelectorAll('input[type="radio"]')[0].checked = true;
        bootSection.querySelector('.color-section#boot-32oz').querySelectorAll('input[type="radio"]')[0].dispatchEvent(changeEvent);
      }
    }
    if (bootVariantID.length < 1 && temporaryBootVID.length > 1) {

      bootVariantID = temporaryBootVID;
    }
    bootNext.classList.remove('hidden');
    bootPrevious.classList.remove('hidden');

    if (!bootIsAvailable) {
      summaryBootSection.classList.add('unavailable');
      summaryBootSection.classList.add('unavailable');
      summaryBootSectionMobile.classList.add('unavailable');
      if(window.innerWidth > 899)
      // addToBag.setAttribute('disabled', '');
      document.querySelector('[for="boot-tab"').classList.add('unavailable');
    } else {
      summaryBootSection.classList.remove('unavailable');
      summaryBootSectionMobile.classList.remove('unavailable');
      if(window.innerWidth > 899)
      addToBag.removeAttribute('disabled');
      document.querySelector('[for="boot-tab"').classList.remove('unavailable');
    }
  }
  else {
    bootColorSection.classList.add('hidden');
    bootColorSection32oz.classList.add('hidden');
    bootColorSectionMobile.classList.add('hidden');
    bootSection.querySelector('.boot-section_header h3').innerText = " No Boot";
    bootSection.dataset.boot = 'without';
    bootPreview.dataset.boot = 'without';
    bootPreview32oz.dataset.boot = 'without';
    bootMainImage.classList.add('hidden');
    popupBootImage.classList.add('hidden');
    bootSection.setAttribute('data-filled', 'filled');
    temporaryBootVID = bootVariantID;
    bootVariantID = '';
    bootNext.classList.add('hidden');
    bootPrevious.classList.add('hidden');
    bootNext32oz.classList.add('hidden');
    bootPrevious32oz.classList.add('hidden');
    bootChoices.querySelector('#add_boot').classList.remove('active');
    bootChoicesMobile.querySelector('#add_boot').classList.remove('active');
    bootChoices.querySelector('#no_boot').classList.add('active');
    bootChoicesMobile.querySelector('#no_boot').classList.add('active');
    summaryBootSection.classList.remove('unavailable');
    summaryBootSection.classList.remove('unavailable');
    summaryBootSectionMobile.classList.remove('unavailable');
    document.querySelector('[for="boot-tab"').classList.remove('unavailable');
    if (bottleIsAvailable && loopIsAvailable && capIsAvailable) {
      bootIsAvailable = true;
      if(window.innerWidth > 899)
      addToBag.removeAttribute('disabled');
      addToBag.classList.remove('disabled');
      addToBag.classList.remove('loading-icon');
    }
  }
  updatePricing();
  updateSummaryOverview();

}

function toSummaryTitleWords(str) {
  if (!str) return '';
  return str.split(/\s+/).filter(Boolean).map(function (w) {
    return w.charAt(0).toUpperCase() + w.slice(1).toLowerCase();
  }).join(' ');
}

function capTypeOverviewLabel(capType) {
  if (capType === 'pebble') return 'Pebble';
  if (capType === 'base') return 'Base';
  if (capType === 'chug') return 'Chug';
  if (capType === 'sip') return 'Sip';
  if (capType === 'robo') return 'Robo';
  if (capType === 'bubble') return 'Bubble';
  return toSummaryTitleWords(capType || '');
}

function loopAccessoryOverviewLabel(capType) {
  if (isConnectorStyleCapType(capType)) return 'Connector';
  if (capType === 'bubble') return 'Band';
  return 'Loop';
}

function formatLoopOverviewDisplayName(rawName, colorType) {
  if (!rawName) return '';
  var n = rawName;
  if (colorType === 'charm') {
    n = n.replace(/^charm loop\s*/i, '').trim();
  }
  return toSummaryTitleWords(n);
}

function bootOverviewSizeSuffix() {
  if (bottleSizeOption === '16oz' || bottleSizeOption === '25oz' || bottleSizeOption === '30oz') {
    return '16oz/25oz/30oz';
  }
  return '32oz/40oz/64oz';
}

function getBottleRadiosForCurrentSize() {
  if (bottleSizeOption === '32oz') return bottleRadios32oz;
  if (bottleSizeOption === '16oz') return bottleRadios16oz;
  if (bottleSizeOption === '30oz') return bottleRadios30oz;
  if (bottleSizeOption === '40oz') return bottleRadios40oz;
  if (bottleSizeOption === '64oz') return bottleRadios64oz;
  return bottleRadios;
}

function findBottleRadioByName(name) {
  if (!name) return null;
  var radios = getBottleRadiosForCurrentSize();
  for (var i = 0; i < radios.length; i++) {
    if (radios[i].dataset.name === name) return radios[i];
  }
  return null;
}

function getActiveBottleSlideForCurrentSize() {
  if (bottleSizeOption === '32oz') return bottleMain32oz;
  if (bottleSizeOption === '16oz') return bottleMain16oz;
  if (bottleSizeOption === '30oz') return bottleMain30oz;
  if (bottleSizeOption === '40oz') return bottleMain40oz;
  if (bottleSizeOption === '64oz') return bottleMain64oz;
  return bottleMain25oz;
}

function getCheckedBottleOverviewInput() {
  var mobileName = 'summary-bottle-component-mobile-' + bottleSizeOption;
  var checked = document.querySelector('.bottle-section-mobile input[type="radio"][name="' + mobileName + '"]:checked');
  if (checked) return checked;

  // Size can change via swiper before the new size's color radio is checked
  var fromChosen = findBottleRadioByName(chosenBottle);
  if (fromChosen) return fromChosen;

  var activeSlide = getActiveBottleSlideForCurrentSize();
  if (activeSlide && activeSlide.dataset && activeSlide.dataset.name) {
    var fromSlide = findBottleRadioByName(activeSlide.dataset.name);
    if (fromSlide) return fromSlide;
  }

  var radios = getBottleRadiosForCurrentSize();
  return radios.length ? radios[0] : null;
}

function getCheckedCapOverviewInput() {
  var capType = customizationMain.dataset.capType;
  var sectionClass = getLoopStyleCapSectionClass(capType);
  var selMobile = '.cap-section-mobile .' + sectionClass + ' input[type="radio"]:checked';
  return document.querySelector(selMobile) || document.querySelector('.cap-section-mobile .' + sectionClass + ' input[type="radio"]');
}

function getCheckedLoopAccessoryOverviewInput() {
  var capType = customizationMain.dataset.capType;
  var selMobile;
  if (isConnectorStyleCapType(capType)) {
    selMobile = '.loop-section-mobile .connector--section input[type="radio"]:checked';
  } else if (capType === 'bubble') {
    selMobile = '.loop-section-mobile .band--section input[type="radio"]:checked';
  } else {
    selMobile = '.loop-section-mobile .loop--section input[type="radio"]:checked';
  }
  return document.querySelector(selMobile) || document.querySelector(selMobile.replace(':checked', ''));
}

function getCheckedBootOverviewInput() {
  if (bottleSizeOption === '16oz' || bottleSizeOption === '25oz' || bottleSizeOption === '30oz') {
    // return document.querySelector('.boot-section input[name="summary-boot-component-25oz"]:checked') // summary-desktop
    return document.querySelector('.boot-section-mobile input[name="summary-boot-component-mobile-25oz"]:checked');
  }
  // return document.querySelector('.boot-section input[name="summary-boot-component-32oz"]:checked')
  return document.querySelector('.boot-section-mobile input[name="summary-boot-component-mobile-32oz"]:checked');
}

function setOverviewSwatch(el, input) {
  if (!el) return;
  var h = input && input.dataset && input.dataset.handleName ? input.dataset.handleName : '';
  el.setAttribute('data-handle-name', h || '');
}

function updateSummaryOverview() {
  if (!overviewBottleValue) return;

  var bottleIn = getCheckedBottleOverviewInput();
  setOverviewSwatch(overviewBottleSwatch, bottleIn);
  var bottleColorTitle = toSummaryTitleWords(chosenBottle);
  overviewBottleValue.textContent = bottleColorTitle && bottleSizeOption
    ? bottleColorTitle + ' (' + bottleSizeOption + ')'
    : '';

  var capIn = getCheckedCapOverviewInput();
  setOverviewSwatch(overviewCapSwatch, capIn);
  var capType = customizationMain.dataset.capType;
  var capColorTitle = toSummaryTitleWords(chosenCap);
  var capSuffix = capTypeOverviewLabel(capType);
  if (overviewCapValue) {
    overviewCapValue.textContent = capColorTitle && capSuffix
      ? capColorTitle + ' (' + capSuffix + ')'
      : capColorTitle;
  }

  var loopIn = getCheckedLoopAccessoryOverviewInput();
  setOverviewSwatch(overviewLoopSwatch, loopIn);
  if (overviewLoopText) {
    overviewLoopText.textContent = loopAccessoryOverviewLabel(capType) + ':';
  }
  var loopColorType = loopIn ? loopIn.dataset.colorType : '';
  if (overviewLoopValue) {
    var loopRawName = loopIn && loopIn.dataset.name ? loopIn.dataset.name : chosenLoop;
    overviewLoopValue.textContent = formatLoopOverviewDisplayName(loopRawName, loopColorType);
  }

  if (overviewBootDetails) {
    if (withBoot) {
      overviewBootDetails.classList.remove('hidden');
      var bootIn = getCheckedBootOverviewInput();
      setOverviewSwatch(overviewBootSwatch, bootIn);
      var bootColorTitle = toSummaryTitleWords(chosenBoot);
      var bootSizes = bootOverviewSizeSuffix();
      if (overviewBootValue) {
        overviewBootValue.textContent = bootColorTitle && bootSizes
          ? bootColorTitle + ' (' + bootSizes + ')'
          : bootColorTitle;
      }
    } else {
      overviewBootDetails.classList.add('hidden');
      setOverviewSwatch(overviewBootSwatch, null);
      if (overviewBootValue) overviewBootValue.textContent = '';
    }
  }

  if (overviewEngravingDetails) {
    if (engravingValue.length > 0 && !customizationMain.classList.contains('no_engraving')) {
      overviewEngravingDetails.classList.remove('hidden');
    } else {
      overviewEngravingDetails.classList.add('hidden');
    }
  }
}

// declare swipers
let bottleSwiper;
let bottleSwiper64oz;
let bottleSwiper40oz;
let bottleSwiper32oz;
let bottleSwiper30oz;
let bottleSwiper16oz;
// Consolidated swipers - single swiper per component type
let capSwiper;
let basecapSwiper;
let chugcapSwiper;
let sipcapSwiper;
let robocapSwiper;
let bubblecapSwiper;
let loopSwiper;
let connectorSwiper;
let bandSwiper;

// Function to update component images when bottle size changes
function updateComponentPreviewImages(size) {
  const imageAttribute = `data-image_${size}`;
  const componentSelectors = [
    '.cap-preview .swiper-slide',
    '.basecap-preview .swiper-slide',
    '.chugcap-preview .swiper-slide',
    '.sipcap-preview .swiper-slide',
    '.robocap-preview .swiper-slide',
    '.bubblecap-preview .swiper-slide',
    '.loop-preview .swiper-slide',
    '.band-preview .swiper-slide'
  ];

  const updateSlideImage = function (slide, newImageUrl, imageAttrName) {
    if (!newImageUrl) return;
    const img = slide.querySelector('.component-preview-image');
    if (img) {
      const cleanUrl = imageSrcWithoutWidthParam(newImageUrl);
      img.src = cleanUrl;
      img.srcset = `${cleanUrl} 500w`;
    }
    if (imageAttrName === 'data-image') {
      slide.setAttribute('data-image', newImageUrl);
    }
  };
  
  componentSelectors.forEach(selector => {
    document.querySelectorAll(selector).forEach(slide => {
      updateSlideImage(slide, slide.getAttribute(imageAttribute), 'data-image');
    });
  });

  const capType = getCapType();
  if (isConnectorStyleCapType(capType)) {
    document.querySelectorAll('.connector-preview .swiper-slide').forEach(function (slide) {
      updateSlideImage(slide, getConnectorSlideImageUrl(slide, size, capType));
    });
  }
}
let bootSwiper;
let bootSwiper32oz;

/*
*
** BOTTLE SWIPER **
* initialize bottle swipers first
*
*/

document.addEventListener('DOMContentLoaded', function () {


  bottleSwiper32oz = new Swiper("#bottle-preview-32oz.bottle-preview", {
    loop: true,
    preloadImages: false,
    loopAdditionalSlides: 2,
    observer: false,
    observeParents: false,
    allowTouchMove: false,
    allowSlideClick: true,
    loopPreventsSliding: false,
    spaceBetween: 0,
    speed: animationSpeed ? animationSpeed : 300,
    slidesPerView: 2,
    centeredSlides: true,
    watchSlidesVisibility: false,
    slideVisibleClass: 'swiper-slide-visible',
    watchSlidesProgress: false,
    slideToClickedSlide: true,
    initialSlide: 0,

    navigation: {
      nextEl: '.bottle-next-32oz',
      prevEl: '.bottle-previous-32oz',
    },
    breakpoints: {
      900: {
        allowTouchMove: false,
        allowSlideClick: true,
        slidesPerView: 3
      },
      1300: {
        slidesPerView: 5,
      }
    }
  });

  let bottle32ozSInitialized = false;

  bottleSwiper32oz.on('init', function () {
    bottleSInitialized = true;
  });
  
  bottleSwiper32oz.on('click', function (e) {
    bottleMain32oz = bottleSwiper32oz.clickedSlide;
    bottlePreviewChanges(bottleSwiper32oz.clickedSlide, '32oz')
  });
    
  bottleSwiper32oz.on('snapIndexChange', function (e) {
    const newSlide = bottleSwiper32oz.slides[bottleSwiper32oz.activeIndex];
    if (bottleMain32oz === newSlide) return; // Skip if same slide
    bottleMain32oz = newSlide;
    
    if(bottleSizeOption == '32oz'){
      if (bottle32ozSInitialized) {
        try {
          bottlePreviewChanges(newSlide, '32oz');
        } catch (error) {
          console.error(error)
        }
      }
    }
    bottle32ozSInitialized = true;
  });

  bottleSwiper40oz = new Swiper("#bottle-preview-40oz.bottle-preview", {
    loop: true,
    preloadImages: false,
    observer: false,
    observeParents: false,
    allowTouchMove: false,
    allowSlideClick: true,
    loopPreventsSliding: false,
    loopAdditionalSlides: 0,
    spaceBetween: 0,
    speed: animationSpeed ? animationSpeed : 300,
    slidesPerView: 2,
    centeredSlides: true,
    watchSlidesVisibility: false,
    slideVisibleClass: 'swiper-slide-visible',
    watchSlidesProgress: false,
    slideToClickedSlide: true,
    initialSlide: 2,
    slidesPerGroup: 1,
    navigation: {
      nextEl: '.bottle-next-40oz',
      prevEl: '.bottle-previous-40oz',
    },
    breakpoints: {
      900: {
        allowTouchMove: false,
        allowSlideClick: true,
        slidesPerView: 3,
        initialSlide: 2
      },
      1300: {
        loop: false,
        slidesPerView: 5
      }
    }
  });

  let bottle40ozSInitialized = false;

  bottleSwiper40oz.on('init', function () {
    bottle40ozSInitialized = true;
  });
  
  bottleSwiper40oz.on('click', function (e) {
    bottleMain40oz = bottleSwiper40oz.clickedSlide;
    bottlePreviewChanges(bottleSwiper40oz.clickedSlide, '40oz');
  });
    
  bottleSwiper40oz.on('snapIndexChange', function (e) {
    const newSlide = bottleSwiper40oz.slides[bottleSwiper40oz.activeIndex];
    if (bottleMain40oz === newSlide) return; // Skip if same slide
    bottleMain40oz = newSlide;
    
    if(bottleSizeOption == '40oz'){
      if (bottle40ozSInitialized) {
        try {
          bottlePreviewChanges(newSlide, '40oz');
        } catch (error) {
          console.error(error)
        }
      } else {
        bottleRadioCheck(newSlide.dataset.name, '40oz');
      }
    }
    bottle40ozSInitialized = true;
  });

  bottleSwiper64oz = new Swiper("#bottle-preview-64oz.bottle-preview", {
    loop: false,
    preloadImages: false,
    loopAdditionalSlides: 2,
    observer: false,
    observeParents: false,
    allowTouchMove: false,
    allowSlideClick: true,
    loopPreventsSliding: false,
    spaceBetween: 0,
    speed: animationSpeed ? animationSpeed : 300,
    slidesPerView: 2,
    centeredSlides: true,
    watchSlidesVisibility: false,
    slideVisibleClass: 'swiper-slide-visible',
    watchSlidesProgress: false,
    slideToClickedSlide: true,
    initialSlide: 1,

    navigation: {
      nextEl: '.bottle-next-64oz',
      prevEl: '.bottle-previous-64oz',
    },
    breakpoints: {
      900: {
        allowTouchMove: false,
        allowSlideClick: true,
        slidesPerView: 3
      },
      1300: {
        slidesPerView: 3,
      }
    }
  });

  let bottle64ozSInitialized = false;

  bottleSwiper64oz.on('init', function () {
    bottle64ozSInitialized = true;
  });
  
  bottleSwiper64oz.on('click', function (e) {
    bottleMain64oz = bottleSwiper64oz.clickedSlide;
    bottlePreviewChanges(bottleSwiper64oz.clickedSlide, '64oz');
  });
    
  bottleSwiper64oz.on('snapIndexChange', function (e) {
    const newSlide = bottleSwiper64oz.slides[bottleSwiper64oz.activeIndex];
    if (bottleMain64oz === newSlide) return; // Skip if same slide
    bottleMain64oz = newSlide;
    
    if(bottleSizeOption == '64oz'){
      if (bottle64ozSInitialized) {
        try {
          bottlePreviewChanges(newSlide, '64oz');
        } catch (error) {
          console.error(error)
        }
      } else {
        bottleRadioCheck(newSlide.dataset.name, '64oz');
      }
    }
    bottle64ozSInitialized = true;
  });

  bottleSwiper = new Swiper("#bottle-preview-25oz.bottle-preview", {
    loop: true,
    preloadImages: false,
    loopAdditionalSlides: 2,
    observer: false,
    observeParents: false,
    allowTouchMove: false,
    allowSlideClick: true,
    loopPreventsSliding: false,
    spaceBetween: 0,
    speed: animationSpeed ? animationSpeed : 300,
    slidesPerView: 2,
    centeredSlides: true,
    watchSlidesVisibility: false,
    slideVisibleClass: 'swiper-slide-visible',
    watchSlidesProgress: false,
    slideToClickedSlide: true,

    navigation: {
      nextEl: '.bottle-next',
      prevEl: '.bottle-previous',
    },
    breakpoints: {
      900: {
        allowTouchMove: false,
        allowSlideClick: true,
        slidesPerView: 3
      },
      1300: {
        slidesPerView: 5,
      }
    }
  });

  bottleSwiper16oz = new Swiper("#bottle-preview-16oz.bottle-preview", {
    loop: true,
    preloadImages: false,
    loopAdditionalSlides: 2,
    observer: false,
    observeParents: false,
    allowTouchMove: false,
    allowSlideClick: true,
    loopPreventsSliding: false,
    spaceBetween: 0,
    speed: animationSpeed ? animationSpeed : 300,
    slidesPerView: 2,
    centeredSlides: true,
    watchSlidesVisibility: false,
    slideVisibleClass: 'swiper-slide-visible',
    watchSlidesProgress: false,
    slideToClickedSlide: true,
    initialSlide: 0,

    navigation: {
      nextEl: '.bottle-next-16oz',
      prevEl: '.bottle-previous-16oz',
    },
    breakpoints: {
      900: {
        allowTouchMove: false,
        allowSlideClick: true,
        slidesPerView: 3
      },
      1300: {
        slidesPerView: 5,
      }
    }
  });

  let bottleSInitialized = false;
  let bottle16ozSInitialized = false;
  
  bottleSwiper.on('init', function () {
    bottleSInitialized = true;
  });
  
  bottleSwiper16oz.on('init', function () {
    bottle16ozSInitialized = true;
  });

  bottleSwiper.on('click', function (e) {
    bottleMain25oz = bottleSwiper.clickedSlide;
    bottlePreviewChanges(bottleSwiper.clickedSlide, '25oz');
  });
  
  bottleSwiper16oz.on('click', function (e) {
    bottleMain16oz = bottleSwiper16oz.clickedSlide;
    bottlePreviewChanges(bottleSwiper16oz.clickedSlide, '16oz');
  });

  bottleSwiper.on('snapIndexChange', function (e) {
    const newSlide = bottleSwiper.slides[bottleSwiper.activeIndex];
    if (bottleMain25oz === newSlide) return; // Skip if same slide
    bottleMain25oz = newSlide;
    
    if(bottleSizeOption == '25oz'){
      if (bottleSInitialized) {
        try {
          bottlePreviewChanges(newSlide, '25oz');
        } catch (error) {
          console.error(error);
        }
      }
    }
    bottleSInitialized = true;
  });
  
  bottleSwiper16oz.on('snapIndexChange', function (e) {
    const newSlide = bottleSwiper16oz.slides[bottleSwiper16oz.activeIndex];
    if (bottleMain16oz === newSlide) return; // Skip if same slide
    bottleMain16oz = newSlide;
    
    if(bottleSizeOption == '16oz'){
      if (bottle16ozSInitialized) {
        try {
          bottlePreviewChanges(newSlide, '16oz');
        } catch (error) {
          console.error(error)
        }
      }
    }
    bottle16ozSInitialized = true;
  });

  bottleSwiper30oz = new Swiper("#bottle-preview-30oz.bottle-preview", {
    loop: false,
    preloadImages: false,
    loopAdditionalSlides: 2,
    observer: false,
    observeParents: false,
    allowTouchMove: false,
    allowSlideClick: true,
    loopPreventsSliding: false,
    spaceBetween: 0,
    speed: animationSpeed ? animationSpeed : 300,
    slidesPerView: 2,
    centeredSlides: true,
    watchSlidesVisibility: false,
    slideVisibleClass: 'swiper-slide-visible',
    watchSlidesProgress: false,
    slideToClickedSlide: true,
    initialSlide: 2,
    navigation: {
      nextEl: '.bottle-next-30oz',
      prevEl: '.bottle-previous-30oz',
    },
    breakpoints: {
      900: {
        allowTouchMove: false,
        allowSlideClick: true,
        slidesPerView: 3
      },
      1300: {
        slidesPerView: 5 
      }
    }
  });

  let bottle30ozSInitialized = false;

  bottleSwiper30oz.on('init', function () {
    bottle30ozSInitialized = true;
  });
  
  bottleSwiper30oz.on('click', function (e) {
    bottleMain30oz = bottleSwiper30oz.clickedSlide;
    bottlePreviewChanges(bottleSwiper30oz.clickedSlide, '30oz');
  });
  
  bottleSwiper30oz.on('snapIndexChange', function (e) {
    const newSlide = bottleSwiper30oz.slides[bottleSwiper30oz.activeIndex];
    if (bottleMain30oz === newSlide) return; // Skip if same slide
    bottleMain30oz = newSlide;
    
    if(bottleSizeOption == '30oz'){
      if (bottle30ozSInitialized) {
        try {
          bottlePreviewChanges(newSlide, '30oz');
        } catch (error) {
          console.error(error)
        }
      }
    }
    bottle30ozSInitialized = true;
  });
  
  if(!sourceExists || localStorage.getItem('flaskOnboarding') != 'hide'){
    swiperInitialized ? '' : initSwipers();
  }
  else if(!sourceExists && localStorage.getItem('flaskOnboarding') == 'hide'){
    swiperInitialized ? '' : initSwipers();
  }
  else if(sourceExists && localStorage.getItem('flaskOnboarding') == 'hide'){
    swiperInitialized ? '' : initSwipers();
  }

  if (!capExists || !loopExists || !bottleExists) {
    if(defaultSize == '32oz'){
    bottleRadios32oz[0].dispatchEvent(changeEvent);
    }
    else if(defaultSize == '16oz'){
      bottleRadios16oz[0].dispatchEvent(changeEvent);
    }
    else if(defaultSize == '30oz'){
      bottleRadios30oz[0].dispatchEvent(changeEvent);
    }
    else if(defaultSize == '40oz'){
      bottleRadios40oz[0].dispatchEvent(changeEvent);
    }
    else if(defaultSize == '64oz'){
      bottleRadios64oz[0].dispatchEvent(changeEvent);
    }
    else if(defaultSize == '25oz'){
      bottleRadios[0].dispatchEvent(changeEvent);
    }
  } 
  // document.querySelectorAll('.preview-components.bottle-preview').forEach(function (bottle) {
  //   bottle.classList.remove('invisible');
  // });
});

function closeOnboarding(){
  if(!swiperInitialized){
    initSwipers();
  }
  document.querySelector('.onboarding-section').classList.add('fade-out');
  document.querySelector('.onboarding-section').classList.add('hidden');
}

// Performance optimization: Debounce function to reduce excessive calls
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

// Performance optimization: Throttle function for scroll/resize events
function throttle(func, limit) {
  let inThrottle;
  return function() {
    const args = arguments;
    const context = this;
    if (!inThrottle) {
      func.apply(context, args);
      inThrottle = true;
      setTimeout(() => inThrottle = false, limit);
    }
  }
}

function updateGenericLoopCapSummary(value, config) {
  const element = value || document.querySelector(config.radioSelector);
  if (!element) return;
  const name = element.dataset.name;
  const image = element.dataset.image;
  const image_32oz = element.dataset.image_32oz;
  const image_16oz = element.dataset.image_16oz;
  const image_30oz = element.dataset.image_30oz || element.dataset.image;
  const image_40oz = element.dataset.image_40oz;
  const image_64oz = element.dataset.image_64oz;
  const bundleVariantID = element.dataset.variant_id;
  const singleVariantID = element.dataset.main_variant;
  const capType = getCapType();
  const colorTextClassic = document.querySelector(config.colorTextClassicSelector);
  const colorTextLimited = document.querySelector(config.colorTextLimitedSelector);

  if (colorTextClassic && colorTextLimited) {
    element.dataset.colorType == "limited"
      ? (colorTextLimited.innerText = name, colorTextClassic.innerText = "", summaryCapSection.setAttribute('color_type', 'limited'))
      : (colorTextLimited.innerText = '', colorTextClassic.innerText = name, summaryCapSection.setAttribute('color_type', 'classic'));
  }
  chosenCap = name;
  if (config.previewEl) config.previewEl.setAttribute('data-filled', 'filled');

  let capImageSrc = image;
  if (bottleSizeOption == '32oz') capImageSrc = image_32oz;
  else if (bottleSizeOption == '16oz') capImageSrc = image_16oz;
  else if (bottleSizeOption == '30oz') capImageSrc = image_30oz;
  else if (bottleSizeOption == '40oz') capImageSrc = image_40oz || image_32oz;
  else if (bottleSizeOption == '64oz') capImageSrc = image_64oz || image_32oz;

  if (capType === config.capType) {
    markCapSectionFilled();
    capImage.src = imageSrcWithoutWidthParam(capImageSrc);
    popupCapImage.src = imageSrcWithoutWidthParam(capImageSrc);
    capBundleVariantID = bundleVariantID;
    capIndividualVariantID = singleVariantID;
    capInventory = {
      variantID: bundleVariantID,
      variantQuantity: element.dataset.item_count
    };
    syncConnectorAccessoryForCapType(capType);
  }
  updatePricing();
  updateSummaryOverview();
}

function updateBasecapSummary(value) {
  updateGenericLoopCapSummary(value, {
    capType: 'base',
    radioSelector: '.basecap_component_radio',
    previewEl: basecapPreview,
    colorTextClassicSelector: '#basecap-color-text-classic',
    colorTextLimitedSelector: '#basecap-color-text-limited'
  });
}

function updateChugcapSummary(value) {
  updateGenericLoopCapSummary(value, {
    capType: 'chug',
    radioSelector: '.chugcap_component_radio',
    previewEl: chugcapPreview,
    colorTextClassicSelector: '#chugcap-color-text-classic',
    colorTextLimitedSelector: '#chugcap-color-text-limited'
  });
}

function updateSipcapSummary(value) {
  updateGenericLoopCapSummary(value, {
    capType: 'sip',
    radioSelector: '.sipcap_component_radio',
    previewEl: sipcapPreview,
    colorTextClassicSelector: '#sipcap-color-text-classic',
    colorTextLimitedSelector: '#sipcap-color-text-limited'
  });
}

function basecapPreviewChanges(activeSlide) {
  basecapRadioCheck(activeSlide.dataset.name);
  updateBasecapSummary(activeSlide);
  if (getCapType() === 'base') checkCapAvailability(activeSlide);
  summaryCapSection.dataset.filled != 'filled' ? capBundleVariantID = '' : '';
  updatePricing();
}

function chugcapPreviewChanges(activeSlide) {
  chugcapRadioCheck(activeSlide.dataset.name);
  updateChugcapSummary(activeSlide);
  if (getCapType() === 'chug') checkCapAvailability(activeSlide);
  summaryCapSection.dataset.filled != 'filled' ? capBundleVariantID = '' : '';
  updatePricing();
}

function sipcapPreviewChanges(activeSlide) {
  sipcapRadioCheck(activeSlide.dataset.name);
  updateSipcapSummary(activeSlide);
  if (getCapType() === 'sip') checkCapAvailability(activeSlide);
  summaryCapSection.dataset.filled != 'filled' ? capBundleVariantID = '' : '';
  updatePricing();
}

function basecapRadioCheck(param) {
  basecapRadios.forEach(function (element) {
    if (element.dataset.name == param) element.checked = true;
  });
}

function chugcapRadioCheck(param) {
  chugcapRadios.forEach(function (element) {
    if (element.dataset.name == param) element.checked = true;
  });
}

function sipcapRadioCheck(param) {
  sipcapRadios.forEach(function (element) {
    if (element.dataset.name == param) element.checked = true;
  });
}

function attachLoopStyleCapRadioListeners(radios, slideToPreviewFn, updateSummaryFn, capTypeName) {
  let slideIndex = 0;
  radios.forEach(function (element) {
    element.addEventListener('change', function () {
      const currentIndex = parseInt(element.dataset.slider_index);
      if (currentIndex > slideIndex + 5 || currentIndex < slideIndex - 5) animationSpeed = 1000;
      slideIndex = currentIndex;
      slideToPreviewFn(element.dataset.slider_index);
      updateSummaryFn(element);
      currentSection == 'cap' ? element.classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '';
      if (getCapType() === capTypeName) checkCapAvailability(element);
      updatePricing();
      animationSpeed = 300;
    });
  });
}

attachLoopStyleCapRadioListeners(basecapRadios, function (params) {
  slideAdditionalCapSwiper(basecapSwiper, params);
}, updateBasecapSummary, 'base');
attachLoopStyleCapRadioListeners(chugcapRadios, function (params) {
  slideAdditionalCapSwiper(chugcapSwiper, params);
}, updateChugcapSummary, 'chug');
attachLoopStyleCapRadioListeners(sipcapRadios, function (params) {
  slideAdditionalCapSwiper(sipcapSwiper, params);
}, updateSipcapSummary, 'sip');

// add function to initialize component swipers
function initSwipers() {

  /*
  *
  ** CAP SWIPER (Consolidated) **
  *
  */
  let capSInitialized = false;
  capSwiper = new Swiper('#cap-preview', {
    loop: true,
    preloadImages: false,
    observer: false,
    observeParents: false,
    allowTouchMove: false,
    allowSlideClick: true,
    spaceBetween: 0,
    speed: animationSpeed ? animationSpeed : 300,
    slidesPerView: 2,
    centeredSlides: true,
    watchSlidesVisibility: false,
    slideVisibleClass: 'swiper-slide-visible',
    watchSlidesProgress: false,
    slideToClickedSlide: true,

    navigation: {
      nextEl: '.cap-next',
      prevEl: '.cap-previous',
    },
    breakpoints: {
      900: {
        allowTouchMove: false,
        allowSlideClick: true,
        slidesPerView: 3
      },
      1300: {
        slidesPerView: 5,
      }
    }
  });

  capSwiper.on('click', function (e) {
    if (getCapType() !== 'pebble') return;
    const activeSlide = capSwiper.clickedSlide;
    capPreviewChanges(capSwiper.clickedSlide);
    currentSection == 'cap' ? capSwiper.clickedSlide.classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '';
  });

  capSwiper.on('snapIndexChange', function (e) {
    capMain = capSwiper.slides[capSwiper.activeIndex];
    if (getCapType() !== 'pebble') {
      capSInitialized = true;
      return;
    }
    if (capSInitialized) {
      capPreviewChanges(capSwiper.slides[capSwiper.activeIndex]);
    } else {
      try {
        sourceExists ? '' : capPreviewChanges(capSwiper.slides[capSwiper.activeIndex]);
        if (!sourceExists) {
          capBundleVariantID = '';
          capIndividualVariantID = '';
          popupCapImage.src = '';
        }
      } catch (error) {
        console.error(error);
      }
    }
    capSInitialized = true;
    currentSection == 'cap' ? capSwiper.slides[capSwiper.activeIndex].classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '';
  });

  /*
  *
  ** ROBO CAP SWIPER (Consolidated) **
  *
  */
  let robocapSInitialized = false;
  robocapSwiper = new Swiper('#robocap-preview', {
    loop: true,
    preloadImages: false,
    observer: false,
    observeParents: false,
    allowTouchMove: false,
    allowSlideClick: true,
    spaceBetween: 0,
    speed: animationSpeed ? animationSpeed : 300,
    slidesPerView: 2,
    centeredSlides: true,
    watchSlidesVisibility: false,
    slideVisibleClass: 'swiper-slide-visible',
    watchSlidesProgress: false,
    slideToClickedSlide: true,

    navigation: {
      nextEl: '.cap-next',
      prevEl: '.cap-previous',
    },
    breakpoints: {
      900: {
        allowTouchMove: false,
        allowSlideClick: true,
        slidesPerView: 3
      },
      1300: {
        slidesPerView: 5,
      }
    }
  });

  /*
  *
  ** BUBBLECAP SWIPER (Consolidated) **
  *
  */
  let bubblecapSInitialized = false;
  bubblecapSwiper = new Swiper('#bubblecap-preview', {
    loop: true,
    preloadImages: false,
    observer: false,
    observeParents: false,
    allowTouchMove: false,
    allowSlideClick: true,
    spaceBetween: 0,
    speed: animationSpeed ? animationSpeed : 300,
    slidesPerView: 2,
    centeredSlides: true,
    watchSlidesVisibility: false,
    slideVisibleClass: 'swiper-slide-visible',
    watchSlidesProgress: false,
    slideToClickedSlide: true,

    navigation: {
      nextEl: '.cap-next',
      prevEl: '.cap-previous',
    },
    breakpoints: {
      900: {
        allowTouchMove: false,
        allowSlideClick: true,
        slidesPerView: 3
      },
      1300: {
        slidesPerView: 5,
      }
    }
  });

  bubblecapSwiper.on('click', function (e) {
    const activeSlide = bubblecapSwiper.clickedSlide;
    bubblecapPreviewChanges(bubblecapSwiper.clickedSlide);
    currentSection == 'cap' ? bubblecapSwiper.clickedSlide.classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '';
  });

  bubblecapSwiper.on('snapIndexChange', function (e) {
    bubblecapMain = bubblecapSwiper.slides[bubblecapSwiper.activeIndex];
    if (bubblecapSInitialized) {
      bubblecapPreviewChanges(bubblecapSwiper.slides[bubblecapSwiper.activeIndex]);
    } else {
      try {
        sourceExists ? '' : bubblecapPreviewChanges(bubblecapSwiper.slides[bubblecapSwiper.activeIndex]);
        capBundleVariantID = '';
        capIndividualVariantID = '';
        popupCapImage.src = '';
      } catch (error) {
        console.error(error);
      }
    }
    bubblecapSInitialized = true;
    currentSection == 'cap' ? bubblecapSwiper.slides[bubblecapSwiper.activeIndex].classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '';
  });

  function initAdditionalCapSwiper(previewId, previewChangesHandler, mainRefSetter) {
    if (!document.querySelector(previewId)) return null;
    let initialized = false;
    const swiper = new Swiper(previewId, {
      loop: false,
      preloadImages: false,
      observer: false,
      observeParents: false,
      allowTouchMove: false,
      allowSlideClick: true,
      spaceBetween: 0,
      speed: animationSpeed ? animationSpeed : 300,
      slidesPerView: 2,
      centeredSlides: true,
      watchSlidesVisibility: false,
      slideVisibleClass: 'swiper-slide-visible',
      watchSlidesProgress: false,
      slideToClickedSlide: true,
      initialSlide: 1,
      navigation: {
        nextEl: '.cap-next',
        prevEl: '.cap-previous',
      },
      breakpoints: {
        900: {
          allowTouchMove: false,
          allowSlideClick: true,
          slidesPerView: 3
        },
        1300: {
          slidesPerView: 3
        }
      }
    });

    swiper.on('click', function () {
      previewChangesHandler(swiper.clickedSlide);
      currentSection == 'cap' ? swiper.clickedSlide.classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '';
    });

    swiper.on('snapIndexChange', function () {
      mainRefSetter(swiper.slides[swiper.activeIndex]);
      if (initialized) {
        previewChangesHandler(swiper.slides[swiper.activeIndex]);
      } else {
        try {
          sourceExists ? '' : previewChangesHandler(swiper.slides[swiper.activeIndex]);
          capBundleVariantID = '';
          capIndividualVariantID = '';
          popupCapImage.src = '';
        } catch (error) {
          console.error(error);
        }
      }
      initialized = true;
      currentSection == 'cap' ? swiper.slides[swiper.activeIndex].classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '';
    });

    return swiper;
  }

  basecapSwiper = initAdditionalCapSwiper('#basecap-preview', basecapPreviewChanges, function (slide) { basecapMain = slide; });
  chugcapSwiper = initAdditionalCapSwiper('#chugcap-preview', chugcapPreviewChanges, function (slide) { chugcapMain = slide; });
  sipcapSwiper = initAdditionalCapSwiper('#sipcap-preview', sipcapPreviewChanges, function (slide) { sipcapMain = slide; });

  robocapSwiper.on('click', function (e) {
    const activeSlide = robocapSwiper.clickedSlide;
    robocapPreviewChanges(robocapSwiper.clickedSlide);
    currentSection == 'cap' ? robocapSwiper.clickedSlide.classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '';
  });

  robocapSwiper.on('snapIndexChange', function (e) {
    robocapMain = robocapSwiper.slides[robocapSwiper.activeIndex];
    if (robocapSInitialized) {
      robocapPreviewChanges(robocapSwiper.slides[robocapSwiper.activeIndex]);
    } else {
      try {
        sourceExists ? '' : robocapPreviewChanges(robocapSwiper.slides[robocapSwiper.activeIndex]);
        capBundleVariantID = '';
        capIndividualVariantID = '';
        popupCapImage.src = '';
      } catch (error) {
        console.error(error);
      }
    }
    robocapSInitialized = true;
    currentSection == 'cap' ? robocapSwiper.slides[robocapSwiper.activeIndex].classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '';
  });

  /*
  *
  ** LOOP SWIPER (Consolidated) **
  *
  */
  let loopSInitialized = false;
  loopSwiper = new Swiper("#loop-preview", {
    loop: true,
    preloadImages: false,
    observer: false,
    observeParents: false,
    allowTouchMove: false,
    allowSlideClick: true,
    spaceBetween: 0,
    speed: animationSpeed ? animationSpeed : 300,
    slidesPerView: 2,
    centeredSlides: true,
    watchSlidesVisibility: false,
    slideVisibleClass: 'swiper-slide-visible',
    watchSlidesProgress: false,
    slideToClickedSlide: true,

    navigation: {
      nextEl: '.loop-next',
      prevEl: '.loop-previous',
    },
    breakpoints: {
      900: {
        allowTouchMove: false,
        allowSlideClick: true,
        slidesPerView: 3
      },
      1300: {
        slidesPerView: 5,
      }
    }
  });

  loopSwiper.on('click', function (e) {
    const activeSlide = loopSwiper.clickedSlide;
    loopPreviewChanges(loopSwiper.slides[loopSwiper.activeIndex]);
    currentSection == 'loop' ? loopSwiper.clickedSlide.classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '';
  });

  loopSwiper.on('snapIndexChange', function (e) {
    loopMain = loopSwiper.slides[loopSwiper.activeIndex];
    if (loopSInitialized) {
      loopPreviewChanges(loopSwiper.slides[loopSwiper.activeIndex]);
    } else {
      try {
        sourceExists ? '' : loopPreviewChanges(loopSwiper.slides[loopSwiper.activeIndex]);
        loopBundleVariantID = '';
        loopIndividualVariantID = '';
        popupLoopImage.src = '';
      } catch (error) {
        console.error(error);
      }
    }
    loopSInitialized = true;
    currentSection == 'loop' ? loopSwiper.slides[loopSwiper.activeIndex].classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '';
    updatePricing();
  });

  /*
  *
  ** CONNECTOR SWIPER (Consolidated) **
  *
  */
  let connectorSInitialized = false;
  connectorSwiper = new Swiper("#connector-preview", {
    loop: true,
    preloadImages: false,
    observer: false,
    observeParents: false,
    allowTouchMove: false,
    allowSlideClick: true,
    spaceBetween: 0,
    speed: animationSpeed ? animationSpeed : 300,
    slidesPerView: 2,
    centeredSlides: true,
    watchSlidesVisibility: false,
    slideVisibleClass: 'swiper-slide-visible',
    watchSlidesProgress: false,
    slideToClickedSlide: true,

    navigation: {
      nextEl: '.loop-next',
      prevEl: '.loop-previous',
    },
    breakpoints: {
      900: {
        allowTouchMove: false,
        allowSlideClick: true,
        slidesPerView: 3
      },
      1300: {
        slidesPerView: 5,
      }
    }
  });

  connectorSwiper.on('click', function (e) {
    const activeSlide = connectorSwiper.clickedSlide;
    connectorPreviewChanges(connectorSwiper.slides[connectorSwiper.activeIndex]);
    currentSection == 'loop' ? connectorSwiper.clickedSlide.classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '';
  });

  connectorSwiper.on('snapIndexChange', function (e) {
    connectorMain = connectorSwiper.slides[connectorSwiper.activeIndex];
    if (connectorSInitialized) {
      connectorPreviewChanges(connectorSwiper.slides[connectorSwiper.activeIndex]);
    } else {
      try {
        sourceExists ? '' : connectorPreviewChanges(connectorSwiper.slides[connectorSwiper.activeIndex]);
        connectorBundleVariantID = '';
        connectorIndividualVariantID = '';
        popupLoopImage.src = '';
      } catch (error) {
        console.error(error);
      }
    }
    connectorSInitialized = true;
    currentSection == 'loop' ? connectorSwiper.slides[connectorSwiper.activeIndex].classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '';
    updatePricing();
  });

  /*
  *
  ** BAND SWIPER (Consolidated) **
  *
  */
  let bandSInitialized = false;
  bandSwiper = new Swiper("#band-preview", {
    loop: true,
    preloadImages: false,
    observer: false,
    observeParents: false,
    allowTouchMove: false,
    allowSlideClick: true,
    spaceBetween: 0,
    speed: animationSpeed ? animationSpeed : 300,
    slidesPerView: 2,
    centeredSlides: true,
    watchSlidesVisibility: false,
    slideVisibleClass: 'swiper-slide-visible',
    watchSlidesProgress: false,
    slideToClickedSlide: true,

    navigation: {
      nextEl: '.loop-next',
      prevEl: '.loop-previous',
    },
    breakpoints: {
      900: {
        allowTouchMove: false,
        allowSlideClick: true,
        slidesPerView: 3
      },
      1300: {
        slidesPerView: 5,
      }
    }
  });

  bandSwiper.on('click', function (e) {
    const activeSlide = bandSwiper.clickedSlide;
    bandPreviewChanges(bandSwiper.slides[bandSwiper.activeIndex]);
    currentSection == 'loop' ? bandSwiper.clickedSlide.classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '';
  });

  bandSwiper.on('snapIndexChange', function (e) {
    bandMain = bandSwiper.slides[bandSwiper.activeIndex];
    if (bandSInitialized) {
      bandPreviewChanges(bandSwiper.slides[bandSwiper.activeIndex]);
    } else {
      try {
        sourceExists ? '' : bandPreviewChanges(bandSwiper.slides[bandSwiper.activeIndex]);
        bandBundleVariantID = '';
        bandIndividualVariantID = '';
        popupLoopImage.src = '';
      } catch (error) {
        console.error(error);
      }
    }
    bandSInitialized = true;
    currentSection == 'loop' ? bandSwiper.slides[bandSwiper.activeIndex].classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '';
    updatePricing();
  });

  /*
  *
  ** BOOT SWIPER **
  *
  */
  let bootSInitialized = false;
  bootSwiper = new Swiper(".boot-preview[data-size-category='25oz']", {
    loop: true,
    preloadImages: false,
    observer: false,
    observeParents: false,
    loopAdditionalSlides: 3,
    allowTouchMove: false,
    allowSlideClick: true,
    spaceBetween: 0,
    speed: animationSpeed ? animationSpeed : 300,
    slidesPerView: 2,
    centeredSlides: true,
    watchSlidesVisibility: false,
    slideVisibleClass: 'swiper-slide-visible',
    watchSlidesProgress: false,
    slideToClickedSlide: true,
    initialSlide: 0,
    navigation: {
      nextEl: '.boot-next',
      prevEl: '.boot-previous',
    },
    breakpoints: {
      900: {
        allowTouchMove: false,
        allowSlideClick: true,
        slidesPerView: 3
      },
      1300: {
        slidesPerView: 5,
      }
    }
  });

  bootSwiper32oz = new Swiper(".boot-preview[data-size-category='32oz']", {
    loop: true,
    preloadImages: false,
    observer: false,
    observeParents: false,
    loopAdditionalSlides: 3,
    allowTouchMove: false,
    allowSlideClick: true,
    spaceBetween: 0,
    speed: animationSpeed ? animationSpeed : 300,
    slidesPerView: 2,
    centeredSlides: true,
    watchSlidesVisibility: false,
    slideVisibleClass: 'swiper-slide-visible',
    watchSlidesProgress: false,
    slideToClickedSlide: true,
    initialSlide: 0,
    navigation: {
      nextEl: '.boot-next-32oz',
      prevEl: '.boot-previous-32oz',
    },
    breakpoints: {
      900: {
        allowTouchMove: false,
        allowSlideClick: true,
        slidesPerView: 3
      },
      1300: {
        slidesPerView: 5,
      }
    },
    on: {
      init: function () {
        // closeOnboarding();
      swiperInitialized = true;
      }
    }
  });

  bootSwiper.on('click', function (e) {
    if (!(bottleSizeOption === '16oz' || bottleSizeOption === '25oz' || bottleSizeOption === '30oz')) return;
    bootMain25oz = bootSwiper.clickedSlide;
    bootPreviewChanges(bootSwiper.clickedSlide);
    bottleSizeOption == '25oz' ? currentSection == 'boot' ? bootMain25oz.classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '' : '';
  });
  
  bootSwiper32oz.on('click', function (e) {
    if (bottleSizeOption !== '32oz') return;
    bootMain32oz = bootSwiper32oz.clickedSlide;
    bootPreviewChanges(bootSwiper32oz.clickedSlide);
    bottleSizeOption == '32oz' ? currentSection == 'boot' ? bootMain32oz.classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '' : '';
  });

  bootSwiper.on('snapIndexChange', function (e) {
    if (!(bottleSizeOption === '16oz' || bottleSizeOption === '25oz' || bottleSizeOption === '30oz')) return;
    bootMain25oz = bootSwiper.slides[bootSwiper.activeIndex];
    if (bootPreview.dataset.filled != '' || bootPreview.dataset.filled != 'empty') {
      if (bootSInitialized) {
        withBoot ? bootPreviewChanges(bootSwiper.slides[bootSwiper.activeIndex]) : '';
      } else {
        try {
          sourceExists ? '' : (withBoot ? bootPreviewChanges(bootSwiper.slides[bootSwiper.activeIndex]) : '');
        } catch (error) { }
      }
    }
    bootSInitialized = true;
    bottleSizeOption == '25oz' ? currentSection == 'boot' ? bootMain25oz.classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '' : '';
    updatePricing();
  });

  bootSwiper32oz.on('snapIndexChange', function (e) {
    if (bottleSizeOption !== '32oz') return;
    bootMain32oz = bootSwiper32oz.slides[bootSwiper32oz.activeIndex];
    if (bootPreview32oz.dataset.filled != '' || bootPreview32oz.dataset.filled != 'empty') {
      if (bootSInitialized) {
        withBoot ? bootPreviewChanges(bootSwiper32oz.slides[bootSwiper32oz.activeIndex]) : '';
      } else {
        try {
          sourceExists ? '' : (withBoot ? bootPreviewChanges(bootSwiper32oz.slides[bootSwiper32oz.activeIndex]) : '');
        } catch (error) { }
      }
    }
    bootSInitialized = true;
    currentSection == 'boot' ? bottleSizeOption == '32oz' ? (bootMain32oz && bootMain32oz.classList.contains('disabled')) ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '' : '';
    updatePricing();
  });
  bootSwiper32oz.on('init', function (e) {
    swiperInitialized = true;
  });


  // Update component preview images based on initial bottle size
  // This ensures cap/loop/connector/band images match the default size on load
  if (bottleSizeOption && bottleSizeOption !== '25oz') {
    updateComponentPreviewImages(bottleSizeOption);
  }
}



function bottlePreviewChanges(activeSlide, size) {
  bottleRadioCheck(activeSlide.dataset.name, size)
  updateBottleSummary(activeSlide);
  checkColor(activeSlide.dataset.variant_color);
  checkBottleAvailability(activeSlide);
  updatePricing();
}

function bottleRadioCheck(param,size) {

  bottleRadios.forEach(element => {
    if (element.dataset.name === param) {
      size == '25oz' ? element.checked = true : '';
      size == '25oz' ? element.classList.contains('disabled') ? currentSection == 'bottle' ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '' : '';
    }
  });
  bottleRadios32oz.forEach(element => {
    if (element.dataset.name === param) {
      size == '32oz' ? element.checked = true : '';
      size == '32oz' ? element.classList.contains('disabled') ? currentSection == 'bottle' ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '' : '';
    }
  });

  bottleRadios16oz.forEach(element => {
    if (element.dataset.name === param) {
      size == '16oz' ? element.checked = true : '';
      size == '16oz' ? element.classList.contains('disabled') ? currentSection == 'bottle' ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '' : '';
    }
  });
  bottleRadios30oz.forEach(element => {
    if (element.dataset.name === param) {
      size == '30oz' ? element.checked = true : '';
      size == '30oz' ? element.classList.contains('disabled') ? currentSection == 'bottle' ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '' : '';
    }
  });
  bottleRadios40oz.forEach(element => {
    if (element.dataset.name === param) {
      size == '40oz' ? element.checked = true : '';
      size == '40oz' ? element.classList.contains('disabled') ? currentSection == 'bottle' ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '' : '';
    }
  });
  bottleRadios64oz.forEach(element => {
    if (element.dataset.name === param) {
      size == '64oz' ? element.checked = true : '';
      size == '64oz' ? element.classList.contains('disabled') ? currentSection == 'bottle' ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '' : '';
    }
  });
}



// functionality for slide to preview if customizer is not open
function bottleSlideToPreviewMain(params){
  bottleSizeOption == '25oz' ? bottleSwiper.slideToLoop(params, randomizeCondition ? 0 : animationSpeed, false) : '';
  bottleSizeOption == '32oz' ? bottleSwiper32oz.slideToLoop(params, randomizeCondition ? 0 : animationSpeed, false) : '';
  bottleSizeOption == '16oz' ? bottleSwiper16oz.slideToLoop(params, randomizeCondition ? 0 : animationSpeed, false) : '';
  bottleSizeOption == '30oz' ? bottleSwiper30oz.slideToLoop(params, randomizeCondition ? 0 : animationSpeed, false) : '';
  bottleSizeOption == '40oz' ? bottleSwiper40oz.slideToLoop(params, randomizeCondition ? 0 : animationSpeed, false) : '';
  bottleSizeOption == '64oz' ? bottleSwiper64oz.slideToLoop(params, randomizeCondition ? 0 : animationSpeed, false) : '';
}



// robocap swiper



function capPreviewChanges(activeSlide) {
  if (getCapType() !== 'pebble') return;
  capRadioCheck(activeSlide.dataset.name);
  updateCapSummary(activeSlide);
  const capType = document.querySelector('.flask-customization-main').dataset.capType;
  capType == 'robo' ? '' : checkCapAvailability(activeSlide);
  summaryCapSection.dataset.filled != 'filled' ? capBundleVariantID = '' : '';
  updatePricing();
}

function capRadioCheck(param) {
  capRadios.forEach(element => {
    if (element.dataset.name == param) {
      element.checked = true;
    }
  });
}

function robocapPreviewChanges(activeSlide) {
  robocapRadioCheck(activeSlide.dataset.name);
  updateroboCapSummary(activeSlide);
  const capType = document.querySelector('.flask-customization-main').dataset.capType;
  capType == 'robo' ? checkroboCapAvailability(activeSlide) : '';
  summaryCapSection.dataset.filled != 'filled' ? capBundleVariantID = '' : '';
  updatePricing();
}

function bubblecapPreviewChanges(activeSlide) {
  bubblecapRadioCheck(activeSlide.dataset.name);
  updateBubblecapSummary(activeSlide);
  const capType = document.querySelector('.flask-customization-main').dataset.capType;
  capType == 'bubble' ? checkBubbleAvailability(activeSlide) : '';
  summaryCapSection.dataset.filled != 'filled' ? capBundleVariantID = '' : '';
  updatePricing();
}

function robocapRadioCheck(param) {
  robocapRadios.forEach(element => {
    if (element.dataset.name == param) {
      element.checked = true;
    }
  });
}

function bubblecapRadioCheck(param) {
  bubblecapRadios.forEach(element => {
    if (element.dataset.name == param) {
      element.checked = true;
    }
  });
}

function bandPreviewChanges(activeSlide) {
  bandRadioCheck(activeSlide.dataset.name);
  updateBandSummary(activeSlide);
  const capType = document.querySelector('.flask-customization-main').dataset.capType;
  capType == 'bubble' ? checkBandAvailability(activeSlide) : '';
  loopSection.dataset.filled != 'filled' ? loopBundleVariantID = '' : '';
  updatePricing();
}

function bandRadioCheck(param) {
  bandRadios.forEach(element => {
    if (element.dataset.name == param) {
      element.checked = true;
    }
  });
}



function basecapSlideToPreview(params) {
  slideAdditionalCapSwiper(basecapSwiper, params);
}

function chugcapSlideToPreview(params) {
  slideAdditionalCapSwiper(chugcapSwiper, params);
}

function sipcapSlideToPreview(params) {
  slideAdditionalCapSwiper(sipcapSwiper, params);
}

function capSlideToPreview(params) {
  capSwiper.slideToLoop(params, randomizeCondition ? 0 : animationSpeed, false);
}

function robocapSlideToPreview(params) {
  robocapSwiper.slideToLoop(params, randomizeCondition ? 0 : animationSpeed, false);
}

function bubblecapSlideToPreview(params) {
  bubblecapSwiper.slideToLoop(params, randomizeCondition ? 0 : animationSpeed, false);
}


function loopPreviewChanges(activeSlide) {
  loopRadioCheck(activeSlide.dataset.name);
  updateLoopSummary(activeSlide);
  const capType = document.querySelector('.flask-customization-main').dataset.capType;
  capType == 'robo' ? '' : checkLoopAvailability(activeSlide);
  loopSection.dataset.filled != 'filled' ? loopBundleVariantID = '' : '';
  updatePricing();
}

function loopRadioCheck(param) {
  loopRadios.forEach(element => {
    if (element.dataset.name == param) {
      element.checked = true;
    }
  });
}


function loopSlideToPreview(params) {
  loopSwiper.slideToLoop(params, randomizeCondition ? 0 : animationSpeed, false);
}

function connectorPreviewChanges(activeSlide) {
  connectorRadioCheck(activeSlide.dataset.name);
  updateConnectorSummary(activeSlide);
  const capType = document.querySelector('.flask-customization-main').dataset.capType;
  if (isConnectorStyleCapType(capType)) checkConnectorAvailability(activeSlide);
  loopSection.dataset.filled != 'filled' ? connectorBundleVariantID = '' : '';
  updatePricing();
}

function connectorRadioCheck(param) {
  connectorRadios.forEach(element => {
    if (element.dataset.name == param) {
      element.checked = true;
    }
  });
}


function connectorSlideToPreview(params) {
  const swiper = getActiveConnectorSwiper();
  if (swiper) swiper.slideToLoop(params, randomizeCondition ? 0 : animationSpeed, false);
}

function bandSlideToPreview(params) {
  bandSwiper.slideToLoop(params, randomizeCondition ? 0 : animationSpeed, false);
}



function bootPreviewChanges(activeSlide) {
  bootRadioCheck(activeSlide.dataset.name)
  updateBootSummary(activeSlide);
  checkBootAvailability(activeSlide);
  updatePricing();
}

function bootRadioCheck(param) {
  if(bottleSizeOption == '25oz' || bottleSizeOption == '16oz' || bottleSizeOption == '30oz'){
    bootRadios.forEach(element => {
      if (element.dataset.name == param) {
        element.checked = true;
      }
    });
  }
  else{ 
    bootRadios32oz.forEach(element => {
      if (element.dataset.name == param) {
        element.checked = true;
      }
    });
  }
}


function bootSlideToPreview(params) {
  bottleSizeOption == '25oz' || bottleSizeOption == '16oz' || bottleSizeOption == '30oz' ? bootSwiper.slideToLoop(params, randomizeCondition ? 0 : animationSpeed, false) : '';
  bottleSizeOption == '32oz' ? bootSwiper32oz.slideToLoop(params, randomizeCondition ? 0 : animationSpeed, false) : '';
}

function checkSizeRadioButtonWithValue(value){
  summaryBottleSection.setAttribute('data-filled', 'filled');
  summaryCapSection.setAttribute('data-filled', 'filled');
  summaryLoopSection.setAttribute('data-filled', 'filled');

  bottleSizeRadios.forEach(function(bottle){
    if (bottle.dataset.name == value) {
      bottle.checked = true;
      bottle.dispatchEvent(changeEvent);
    }
  })

  bottleSizeRadiosMobile.forEach(function(bottle){
    if (bottle.dataset.name == value) {
      bottle.checked = true;
      bottle.dispatchEvent(changeEvent);
    }
  })
}

function checkRadioButtonWithValue(value) {

  if(summaryCapSection.getAttribute('data-filled') != 'filled'){
    const capSection = summaryCapSection;
    capSection.querySelectorAll('.cap-type-options').forEach(section => {
      if (defaultCapType == 'robo') {
        section.querySelectorAll('input[type="radio"]')[1].checked = true;
        section.querySelectorAll('input[type="radio"]')[1].dispatchEvent(changeEvent);
      }
      else if (defaultCapType == 'pebble'){
        section.querySelectorAll('input[type="radio"]')[0].checked = true;
        section.querySelectorAll('input[type="radio"]')[0].dispatchEvent(changeEvent);
      }
      else if (defaultCapType == 'bubble'){
        section.querySelectorAll('input[type="radio"]')[2].checked = true;
        section.querySelectorAll('input[type="radio"]')[2].dispatchEvent(changeEvent);
      }
      else if (defaultCapType == 'base'){   
        section.querySelectorAll('input[type="radio"]')[3].checked = true;
        section.querySelectorAll('input[type="radio"]')[3].dispatchEvent(changeEvent);
      }
      else if (defaultCapType == 'chug'){
        section.querySelectorAll('input[type="radio"]')[4].checked = true;
        section.querySelectorAll('input[type="radio"]')[4].dispatchEvent(changeEvent);
      } 
      else if (defaultCapType == 'sip'){
        section.querySelectorAll('input[type="radio"]')[5].checked = true;
        section.querySelectorAll('input[type="radio"]')[5].dispatchEvent(changeEvent);
      }
    });
  }

  summaryBottleSection.setAttribute('data-filled', 'filled');
  summaryCapSection.setAttribute('data-filled', 'filled');
  summaryLoopSection.setAttribute('data-filled', 'filled');

  // Get all the names of available components
  const bottleRadioNames = Array.from(bottleRadios).map(bottle => bottle.dataset.name);
  const bottleRadioNames32oz = Array.from(bottleRadios32oz).map(bottle => bottle.dataset.name);
  const bottleRadioNames16oz = Array.from(bottleRadios16oz).map(bottle => bottle.dataset.name);
  const bottleRadioNames30oz = Array.from(bottleRadios30oz || []).map(bottle => bottle.dataset.name);
  const bottleRadioNames40oz = Array.from(bottleRadios40oz || []).map(bottle => bottle.dataset.name);
  const bottleRadioNames64oz = Array.from(bottleRadios64oz || []).map(bottle => bottle.dataset.name);
  const capRadioNames = Array.from(capRadios).map(cap => cap.dataset.name);
  const loopRadioNames = Array.from(loopRadios).map(loop => loop.dataset.name);
  const robocapRadioNames = Array.from(robocapRadios).map(robocap => robocap.dataset.name);
  const bubblecapRadioNames = Array.from(bubblecapRadios).map(bubblecap => bubblecap.dataset.name);
  const bandRadioNames = Array.from(bandRadios).map(band => band.dataset.name);
  const connectorRadioNames = Array.from(connectorRadios).map(connector => connector.dataset.name);

  if (bottleRadioNames.includes(value)) {
    bottleRadios.forEach(function (bottle) {
      if (bottle.dataset.name == value) {
        bottle.checked = true;

        if(bottleSizeOption == '25oz')
        bottle.dispatchEvent(changeEvent);
      }
    });
  }
  else {
    if(bottleSizeOption == '25oz'){
      for (const [index, e] of bottleRadios.entries()) {
        if (!e.classList.contains('disabled')) {
          bottleRadios[index].dispatchEvent(changeEvent)
          break;
        }
      }
    }
  }

  if (bottleRadioNames32oz.includes(value)) {
    bottleRadios32oz.forEach(function (bottle) {
      if (bottle.dataset.name == value) {
        bottle.checked = true;
        if(bottleSizeOption == '32oz')
        bottle.dispatchEvent(changeEvent);
      }
    });
  }
  else {
    if(bottleSizeOption == '32oz'){
      for (const [index, e] of bottleRadios32oz.entries()) {
        if (!e.classList.contains('disabled')) {
          bottleRadios32oz[index].dispatchEvent(changeEvent)
          break;
        }
      }
    }
  }

  if (bottleRadioNames16oz.includes(value)) {
    bottleRadios16oz.forEach(function (bottle) {
      if (bottle.dataset.name == value) {
        bottle.checked = true;

        if(bottleSizeOption == '16oz')
        bottle.dispatchEvent(changeEvent);
      }
    });
  }
  else {
    if(bottleSizeOption == '16oz'){
      for (const [index, e] of bottleRadios16oz.entries()) {
        if (!e.classList.contains('disabled')) {
          bottleRadios16oz[index].dispatchEvent(changeEvent)
          break;
        }
      }
    }
  }

  if (bottleRadioNames30oz.includes(value)) {
    bottleRadios30oz.forEach(function (bottle) {
      if (bottle.dataset.name == value) {
        bottle.checked = true;
        if(bottleSizeOption == '30oz')
        bottle.dispatchEvent(changeEvent);
      }
    });
  }
  else {
    if(bottleSizeOption == '30oz' && bottleRadios30oz.length){
      for (const [index, e] of bottleRadios30oz.entries()) {
        if (!e.classList.contains('disabled')) {
          bottleRadios30oz[index].dispatchEvent(changeEvent)
          break;
        }
      }
    }
  }

  if (bottleRadioNames40oz.includes(value)) {
    bottleRadios40oz.forEach(function (bottle) {
      if (bottle.dataset.name == value) {
        bottle.checked = true;
        if(bottleSizeOption == '40oz')
        bottle.dispatchEvent(changeEvent);
      }
    });
  }
  else {
    if(bottleSizeOption == '40oz' && bottleRadios40oz.length){
      for (const [index, e] of bottleRadios40oz.entries()) {
        if (!e.classList.contains('disabled')) {
          bottleRadios40oz[index].dispatchEvent(changeEvent)
          break;
        }
      }
    }
  }

  if (bottleRadioNames64oz.includes(value)) {
    bottleRadios64oz.forEach(function (bottle) {
      if (bottle.dataset.name == value) {
        bottle.checked = true;
        if(bottleSizeOption == '64oz')
        bottle.dispatchEvent(changeEvent);
      }
    });
  }
  else {
    if(bottleSizeOption == '64oz' && bottleRadios64oz.length){
      for (const [index, e] of bottleRadios64oz.entries()) {
        if (!e.classList.contains('disabled')) {
          bottleRadios64oz[index].dispatchEvent(changeEvent)
          break;
        }
      }
    }
  }

  if(defaultCapType == 'pebble'){ 
    if (capRadioNames.includes(value)) {
      capRadios.forEach(function (cap) {
        if(value == 'chrome'){
          if (cap.dataset.name == 'chia') {
            cap.checked = true;
            cap.dispatchEvent(changeEvent);
          }
        }
        else{
          if (cap.dataset.name == value) {
            cap.checked = true;
            cap.dispatchEvent(changeEvent);
          }
        }
      });
    }
    else {
      for (const [index, e] of capRadios.entries()) {
        if (!e.classList.contains('disabled')) {
          capRadios[index].dispatchEvent(changeEvent)
          break;
        }
      }
    }

    if (loopRadioNames.includes(value)) {
      loopRadios.forEach(function (loop) {
        if(value == 'chrome'){
          if (loop.dataset.name == 'chia') {
            loop.checked = true;
            loop.dispatchEvent(changeEvent);
          }
        }
        else{
          if (loop.dataset.name == value) {
            loop.checked = true;
            loop.dispatchEvent(changeEvent);
          }
        }
      });
    }
    else {
      for (const [index, e] of loopRadios.entries()) {
        if (!e.classList.contains('disabled')) {
          loopRadios[index].dispatchEvent(changeEvent)
          break;
        }
      }
    }
  }
  else if(defaultCapType == 'bubble'){
    if(bubblecapRadioNames.includes(value)){
      bubblecapRadios.forEach(function (bubblecap) {
        if(bubblecap.dataset.name == value){
          bubblecap.checked = true;
          bubblecap.dispatchEvent(changeEvent);
        }
      });
    }
    if(bandRadioNames.includes(value)){
      bandRadios.forEach(function (band) {
        if(band.dataset.name == value){
          band.checked = true;
          band.dispatchEvent(changeEvent);
        }
      });
    }
    else{
      for (const [index, e] of bubblecapRadios.entries()) {
        if (!e.classList.contains('disabled')) {
          bubblecapRadios[index].dispatchEvent(changeEvent)
          break;
        }
      }
    }
  }
  else{
    if (robocapRadioNames.includes(value)) {
      robocapRadios.forEach(function (cap) {
        if(value == 'chrome'){
          if (cap.dataset.name == 'chia') {
            cap.checked = true;
            cap.dispatchEvent(changeEvent);
          }
        }
        else{
          if (cap.dataset.name == value) {
            cap.checked = true;
            cap.dispatchEvent(changeEvent);
          }
        }
      });
    }
    else {
      for (const [index, e] of robocapRadios.entries()) {
        if (!e.classList.contains('disabled')) {
          robocapRadios[index].dispatchEvent(changeEvent)
          break;
        }
      }
    }
    
    if (connectorRadioNames.includes(value)) {
      connectorRadios.forEach(function (connector) {
        if(value == 'chrome'){
          if (connector.dataset.name == 'chia') {
            connector.checked = true;
            connector.dispatchEvent(changeEvent);
          }
        }
        else{
          if (connector.dataset.name == value) {
            connector.checked = true;
            connector.dispatchEvent(changeEvent);
          }
        }
      });
    }
    else {
      for (const [index, e] of connectorRadios.entries()) {
        if (!e.classList.contains('disabled')) {
          connectorRadios[index].dispatchEvent(changeEvent)
          break;
        }
      }
    }
  }
}

let temporaryRandomNumber = null;

// Helper function to randomly select a bottle from all available bottles with the matching color
function getRandomBottleByColor(colorName, sizeOption) {
  let swiper;
  let targetRadios = [];
  
  // Get the appropriate swiper and radio sets based on size
  if (sizeOption == '25oz') {
    swiper = bottleSwiper;
    targetRadios = [bottleRadios];
  } else if (sizeOption == '32oz') {
    swiper = bottleSwiper32oz;
    targetRadios = [bottleRadios32oz];
  } else if (sizeOption == '16oz') {
    swiper = bottleSwiper16oz;
    targetRadios = [bottleRadios16oz];
  } else if (sizeOption == '30oz') {
    swiper = bottleSwiper30oz;
    targetRadios = [bottleRadios30oz];
  } else if (sizeOption == '40oz') {
    swiper = bottleSwiper40oz;
    targetRadios = [bottleRadios40oz];
  } else if (sizeOption == '64oz') {
    swiper = bottleSwiper64oz;
    targetRadios = [bottleRadios64oz];
  }
  
  if (!swiper || !targetRadios.length) return colorName;
  
  // Find all available bottles with the matching color
  const availableBottles = [];
  targetRadios[0].forEach(radio => {
    if (radio.dataset.name === colorName && !radio.classList.contains('disabled')) {
      availableBottles.push(radio);
    }
  });
  
  // If no available bottles found, try to find any bottle with that color (even if disabled)
  if (availableBottles.length === 0) {
    targetRadios[0].forEach(radio => {
      if (radio.dataset.name === colorName) {
        availableBottles.push(radio);
      }
    });
  }
  
  // Randomly select one from available bottles
  if (availableBottles.length > 0) {
    const randomIndex = Math.floor(Math.random() * availableBottles.length);
    return availableBottles[randomIndex].dataset.name;
  }
  
  return colorName; // Fallback to original color name
}

randomize && randomize.addEventListener('click', function () {
  randomizeCondition = true;
  const colorMax = randomColors.length;

  // If only one color option, use it directly
  let randomColorIndex;
  if (colorMax === 1) {
    randomColorIndex = 0;
  } else {
    let attempts = 0;
    const maxAttempts = 10; // Prevent infinite loop
    
    // Generate a random number that's different from the previous one
    do {
      randomColorIndex = Math.floor(Math.random() * colorMax);
      attempts++;
      // If we've tried too many times, break to avoid infinite loop
      if (attempts >= maxAttempts) {
        break;
      }
    } while (temporaryRandomNumber !== null && temporaryRandomNumber === randomColorIndex);
  }
  
  // Update temporaryRandomNumber with the newly generated randomColorIndex
  temporaryRandomNumber = randomColorIndex;

  animationSpeed = 0;
  const capColor = randomColors[randomColorIndex].cap;
  const loopColor = randomColors[randomColorIndex].loop;
  const bottleColor = randomColors[randomColorIndex].bottle;
  const bootColor = randomColors[randomColorIndex].boot;
  
  // Get a random bottle from all available bottles with the matching color
  const randomBottleColor = getRandomBottleByColor(bottleColor, bottleSizeOption);
  if(bottleSizeOption == '25oz'){
    checkLoop(loopColor);
    checkCap(capColor);
    bootColor ? checkBoot(bootColor) : (withBoot = false, updateBoot(), bootImage.src = '', popupLoopImage.src = '');
    checkBottle(randomBottleColor);
  } else if(bottleSizeOption == '32oz'){
    checkLoop(loopColor);
    checkCap(capColor);
    bootColor ? checkBoot(bootColor) : (withBoot = false, updateBoot(), bootImage.src = '', popupLoopImage.src = '');
    checkBottle(randomBottleColor);
  } else if(bottleSizeOption == '16oz'){
    checkLoop(loopColor);
    checkCap(capColor);
    bootColor ? checkBoot(bootColor) : (withBoot = false, updateBoot(), bootImage.src = '', popupLoopImage.src = '');
    checkBottle(randomBottleColor);
  } else if(bottleSizeOption == '30oz'){
    checkLoop(loopColor);
    checkCap(capColor);
    bootColor ? checkBoot(bootColor) : (withBoot = false, updateBoot(), bootImage.src = '', popupLoopImage.src = '');
    checkBottle(randomBottleColor);
  } else if(bottleSizeOption == '40oz'){
    checkLoop(loopColor);
    checkCap(capColor);
    bootColor ? checkBoot(bootColor) : (withBoot = false, updateBoot(), bootImage.src = '', popupLoopImage.src = '');
    checkBottle(randomBottleColor);
  } else if(bottleSizeOption == '64oz'){
    checkLoop(loopColor);
    checkCap(capColor);
    checkBottle(randomBottleColor);
  }
  
  previewMainImage.forEach(function (element) {
    if (element.classList.contains('active')) {
      element.classList.add('active');
      // setTimeout(function () {
      //   element.classList.remove('active');
      // }, animationSpeed);
    }
  });

  animationSpeed = 300;
  randomizeCondition = false;
});

const priceContainer = document.querySelector('.price-container');
function updatePricing() {

  const capType = document.querySelector('.flask-customization-main').dataset.capType;

  // Pricing by size: 40oz = 32oz + 100, 64oz = 40oz + 400 (32oz + 500)
  const combinedPriceMap = {
    '16oz': { charm: 1385, robo: 1485, bubble: 1385, pebble: 1335 },
    '25oz': { charm: 1485, robo: 1585, bubble: 1485, pebble: 1435 },
    '30oz': { charm: 1185, robo: 1285, bubble: 1185, pebble: 1135 },
    '32oz': { charm: 1585, robo: 1685, bubble: 1585, pebble: 1535 },
    '40oz': { charm: 1685, robo: 1785, bubble: 1685, pebble: 1635 },
    '64oz': { charm: 2085, robo: 2185, bubble: 2085, pebble: 2035 }
  };
  
  const bundlePriceMap = {
    '16oz': { charm: 945, pebble: 895, bubble: 995, robo: 1095 },
    '25oz': { charm: 1045, pebble: 995, bubble: 1095, robo: 1195 },
    '30oz': { charm: 745, pebble: 695, bubble: 795, robo: 895 },
    '32oz': { charm: 1145, pebble: 1095, bubble: 1195, robo: 1295 },
    '40oz': { charm: 1245, pebble: 1195, bubble: 1295, robo: 1395 },
    '64oz': { charm: 1645, pebble: 1595, bubble: 1695, robo: 1795 }
  };
  
  const bottlePriceMap = {
    '16oz': 795,
    '25oz': 895,
    '30oz': 595,
    '32oz': 995,
    '40oz': 1095,
    '64oz': 1495
  };

  const baseBundlePriceMap = {
    '16oz': 795,
    '25oz': 895,
    '30oz': 595,
    '32oz': 995,
    '40oz': 1095,
    '64oz': 1495
  };

  const baseCombinedPriceMap = {
    '16oz': 1235,
    '25oz': 1335,
    '30oz': 1035,
    '32oz': 1435,
    '40oz': 1535,
    '64oz': 1935
  };
  
  const currentSize = bottleSizeOption || '32oz';
  const currentCapType = capType || 'pebble';
  const resolvedPricing = resolveFlaskBundlePricing(currentSize, currentCapType, loopColorType, {
    bundlePriceMap,
    combinedPriceMap,
    baseBundlePriceMap,
    baseCombinedPriceMap
  });
  
  totalPrice = 0;
  loopPrice = loopColorType == 'charm' && currentCapType == 'pebble' ? (245) : (195);
  bundlePrice = resolvedPricing.bundle;
  let combinedPrice = resolvedPricing.combined;
  bottlePrice = bottlePriceMap[currentSize] || 995;
  bootPrice = (currentSize == '25oz' || currentSize == '16oz' || currentSize == '30oz') ? 195 : 245;
  if (currentCapType == 'base') {
    capPrice = 245;
  } else if (currentCapType == 'chug' || currentCapType == 'sip') {
    capPrice = 345;
  } else if (currentCapType == 'bubble') {
    capPrice = 395;
  } else if (currentCapType == 'robo') {
    capPrice = 495;
  } else {
    capPrice = 345;
  }
  summaryCapSection.dataset.filled != 'filled' ? capBundleVariantID = '' : '';
  if (loopSection.dataset.filled != 'filled' && !isConnectorStyleCapType(currentCapType) && currentCapType !== 'bubble') {
    loopBundleVariantID = '';
  }

  if (bottleBundleVariantID.length > 1 && capBundleVariantID.length > 1 && loopBundleVariantID.length) {
    if (bootVariantID.length > 1 || (gliderActive && isStrawGliderCapType(capType))) {
      bootVariantID.length > 1 ? (combinedPrice = combinedPrice + bootPrice, bundlePrice = bundlePrice + bootPrice) : '';
      gliderActive && isStrawGliderCapType(capType) ? (combinedPrice = combinedPrice + gliderPrice, bundlePrice = bundlePrice + gliderPrice) : '';
      totalPriceText.innerText = 'P' + bundlePrice.toLocaleString();
      originalPriceText.innerText = 'P' + combinedPrice.toLocaleString();
    } else {
      originalPriceText.innerText = 'P' + combinedPrice.toLocaleString();
      totalPriceText.innerText = 'P' + bundlePrice.toLocaleString();
    }

    priceContainer.classList.add('bundle');
  }
  else {
    bottleBundleVariantID.length > 1 ? totalPrice = totalPrice + bottlePrice : '';
    capBundleVariantID.length > 1 ? totalPrice = totalPrice + capPrice : '';
    loopBundleVariantID.length > 1 ? totalPrice = totalPrice + loopPrice : '';
    bootVariantID.length > 1 ? totalPrice = totalPrice + bootPrice : '';
    
    if (gliderActive && isStrawGliderCapType(capType) && capBundleVariantID.length > 1) {
      totalPrice = totalPrice + gliderPrice;
    }

    totalPriceText.innerText = ('P' + totalPrice.toLocaleString());
    originalPriceText.innerText = '';
    priceContainer.classList.remove('bundle');
  }
  if(bottleBundleVariantID.length > 1){
    if(loopBundleVariantID.length > 1 || capBundleVariantID.length > 1 || bootVariantID.length > 1){
      priceContainer.classList.add('bottle-plus');
      priceContainer.classList.remove('bottle');
}
    else{
      priceContainer.classList.remove('bottle-plus');
      priceContainer.classList.add('bottle');
    }
  }
  else{
    priceContainer.classList.remove('bottle','bottle-plus');
  }


  if(capBundleVariantID.length > 1) {
    if(isStrawGliderCapType(capType)) {
      priceContainer.classList.add('cap-plus');
      priceContainer.classList.remove('cap');
      
      if(gliderActive) {
        priceContainer.classList.remove('straw', 'straw-plus');
        
        if(loopBundleVariantID.length > 1 || bootVariantID.length > 1) {
          priceContainer.classList.add('glider-plus');
          priceContainer.classList.remove('glider');
        } else {
          priceContainer.classList.remove('glider-plus');
          priceContainer.classList.add('glider');
        }
      } else {
        priceContainer.classList.remove('glider', 'glider-plus');
        
        if(loopBundleVariantID.length > 1 || bootVariantID.length > 1) {
          priceContainer.classList.add('straw-plus');
          priceContainer.classList.remove('straw');
        } else {
          priceContainer.classList.remove('straw-plus');
          priceContainer.classList.add('straw');
        }
      }
    } else {
      if(loopBundleVariantID.length > 1 || bootVariantID.length > 1) {
        priceContainer.classList.add('cap-plus');
        priceContainer.classList.remove('cap');
      } else {
        priceContainer.classList.remove('cap-plus');
        priceContainer.classList.add('cap');
      }
      
      priceContainer.classList.remove('straw', 'straw-plus', 'glider', 'glider-plus');
    }
  } else {
    priceContainer.classList.remove('cap', 'cap-plus', 'straw', 'straw-plus', 'glider', 'glider-plus');
  }

  if(loopBundleVariantID.length > 1){
    const looptext = document.querySelector('.price-text.price-text--loop');
    loopColorType == 'charm' ? looptext.innerText = 'Charm Loop' : looptext.innerText = 'Loop'
    if(bootVariantID.length > 1){
      priceContainer.classList.add('loop-plus');
      priceContainer.classList.remove('loop');
    }
    else{
      priceContainer.classList.remove('loop-plus');
      priceContainer.classList.add('loop');
    }
  }
  else{
    priceContainer.classList.remove('loop','loop-plus');
  }

  if(bootVariantID.length > 1){
    if(bottleSizeOption == '64oz' || bottleSizeOption == '40oz'){
      priceContainer.classList.remove('boot');
      priceContainer.classList.replace('loop-plus', 'loop');
    }
    else{
      priceContainer.classList.add('boot');
    }
  }
  else{
    priceContainer.classList.remove('boot');
  }
}

if (capTypeValue.length > 0 && sizeExists || capExists || loopExists || bottleExists || bootExists) {
    showCustomizer(true);
    animationSpeed = 0;

    document.addEventListener('DOMContentLoaded', function () {
      swiperInitialized ? '' : initSwipers();
      setTimeout(function () {
        randomizeCondition = true;
        bottleSizeOption = sizeValue;
        document.querySelectorAll('cap-type-options').forEach(function(option){
          
          const radioInput = option.querySelector(`input[type="radio"][data-name="${capTypeValue}"]`);
          
          if (radioInput) {
            const customChangeEvent = new Event('change', {
              bubbles: true,
              cancelable: true
            });
            
            radioInput.checked = true;
            const dispatched = radioInput.dispatchEvent(customChangeEvent);
          }
        });
  
        capValue.length > 1 ? checkCap(capValue) : '';
        loopValue.length > 1 ? checkLoop(loopValue) : '';
        if (bottleValue.length > 1 || (sizeExists && bottleValue.length < 1)) {
          setTimeout(function(){
              checkBottle(bottleValue);
          }, 500);
          
        }
        if(bootValue.length > 1){
          setTimeout(function(){
            checkBoot(bootValue);
          }, 500);
        }
        
        if(sizeValue == '25oz') {
          document.querySelector('#product-price').innerText = 'P995';
          bottlePreview.classList.add('active');
          bottlePreview.dataset.filled = 'filled';
          bottlePreview16oz.classList.remove('active');
          bottlePreview32oz.classList.remove('active');
          bottlePreview30oz.classList.remove('active');
          bottlePreview40oz.classList.remove('active');
          bottlePreview64oz.classList.remove('active');
  
          if(withBoot ){
            // bootRadios[0].dispatchEvent(changeEvent);
          }
          updatePricing();
          checkSizeRadioButtonWithValue('25oz');
          document.querySelector('.preview-main').classList.remove('animation');
          changeSize(bottleSizeHolder);
          oosModal.classList.remove('show');
        }
        else if(sizeValue == '16oz'){
  
          document.querySelector('#product-price').innerText = 'P995';
          bottlePreview.classList.remove('active');
          bottlePreview16oz.classList.add('active');
          bottlePreview16oz.dataset.filled = 'filled';
          bottlePreview32oz.classList.remove('active');
          bottlePreview30oz.classList.remove('active');
          bottlePreview40oz.classList.remove('active');
          bottlePreview64oz.classList.remove('active');
  
          if(withBoot ){
            // bootRadios[0].dispatchEvent(changeEvent);
          }
          updatePricing();
          checkSizeRadioButtonWithValue('16oz');
          document.querySelector('.preview-main').classList.remove('animation');
          changeSize(bottleSizeHolder);
          oosModal.classList.remove('show');
        }
        else if(sizeValue == '30oz'){
          document.querySelector('#product-price').innerText = 'P995';
          bottlePreview.classList.remove('active');
          bottlePreview16oz.classList.remove('active');
          bottlePreview32oz.classList.remove('active');
          bottlePreview40oz.classList.remove('active');
          bottlePreview64oz.classList.remove('active');
          bottlePreview30oz.classList.add('active');
          bottlePreview30oz.dataset.filled = 'filled';

          updatePricing();
          checkSizeRadioButtonWithValue('30oz');
          document.querySelector('.preview-main').classList.remove('animation');
          changeSize(bottleSizeHolder);
          oosModal.classList.remove('show');
        }
        else if(sizeValue == '32oz'){
          document.querySelector('#product-price').innerText = 'P1,095';
          bottlePreview.classList.remove('active');
          bottlePreview16oz.classList.remove('active');
          bottlePreview30oz.classList.remove('active');
          bottlePreview32oz.classList.add('active');
          bottlePreview32oz.dataset.filled = 'filled';
          bottlePreview40oz.classList.remove('active');
          bottlePreview64oz.classList.remove('active');
  
          updatePricing();
          checkSizeRadioButtonWithValue('32oz');
          document.querySelector('.preview-main').classList.remove('animation');
          changeSize(bottleSizeHolder);
          oosModal.classList.remove('show');
        }
        else if(sizeValue == '40oz'){
          document.querySelector('#product-price').innerText = 'P1,195';
          bottlePreview.classList.remove('active');
          bottlePreview16oz.classList.remove('active');
          bottlePreview30oz.classList.remove('active');
          bottlePreview32oz.classList.remove('active');
          bottlePreview64oz.classList.remove('active');
          bottlePreview40oz.classList.add('active');
          bottlePreview40oz.dataset.filled = 'filled';
  
          updatePricing();
          checkSizeRadioButtonWithValue('40oz');
          document.querySelector('.preview-main').classList.remove('animation');
          changeSize(bottleSizeHolder);
          oosModal.classList.remove('show');
        }
        else if(sizeValue == '64oz'){
          document.querySelector('#product-price').innerText = 'P1,495';
          bottlePreview.classList.remove('active');
          bottlePreview16oz.classList.remove('active');
          bottlePreview30oz.classList.remove('active');
          bottlePreview32oz.classList.remove('active');
          bottlePreview40oz.classList.remove('active');
          bottlePreview64oz.classList.add('active');
          bottlePreview64oz.dataset.filled = 'filled';
  
          updatePricing();
          checkSizeRadioButtonWithValue('64oz');
          document.querySelector('.preview-main').classList.remove('animation');
          changeSize(bottleSizeHolder);
          oosModal.classList.remove('show');
        }
        randomizeCondition = false;
        animationSpeed = 300;
      }, 0);
    }); 
}
if (sourceExists) {
  showCustomizer(true);;
  document.querySelector('body').classList.remove('hide');
}


function checkCap(value) {
  summaryCapSection.setAttribute('data-filled', 'filled');
  const capType = document.querySelector('.flask-customization-main').dataset.capType;
  if(capType == 'robo'){
    robocapRadios.forEach(function (connector) {
      if (connector.dataset.name == value) {
        connector.checked = true;
        connector.dispatchEvent(changeEvent);
      }
    });
  }
  else if(capType == 'bubble'){
    bubblecapRadios.forEach(function (bubblecap) {
      if (bubblecap.dataset.name == value) {
        bubblecap.checked = true;
        bubblecap.dispatchEvent(changeEvent);
      }
    });
  }
  else if(capType == 'base'){
    basecapRadios.forEach(function (cap) {
      if (cap.dataset.name == value) {
        cap.checked = true;
        cap.dispatchEvent(changeEvent);
      }
    });
  }
  else if(capType == 'chug'){
    chugcapRadios.forEach(function (cap) {
      if (cap.dataset.name == value) {
        cap.checked = true;
        cap.dispatchEvent(changeEvent);
      }
    });
  }
  else if(capType == 'sip'){
    sipcapRadios.forEach(function (cap) {
      if (cap.dataset.name == value) {
        cap.checked = true;
        cap.dispatchEvent(changeEvent);
      }
    });
  }
  else{
    capRadios.forEach(function (cap) {
      if (cap.dataset.name == value) {
        cap.checked = true;
        cap.dispatchEvent(changeEvent);
      }
    });
  }
}

function checkLoop(value) {
  summaryLoopSection.setAttribute('data-filled', 'filled');
  // withLoop = true;
  summaryLoopSection.setAttribute('data-loop', 'with');
  const capType = document.querySelector('.flask-customization-main').dataset.capType;
  // updateLoop();
  if(isConnectorStyleCapType(capType)){
    connectorRadios.forEach(function (connector) {
      if (connector.dataset.name == value) {
        connector.checked = true;
        connector.dispatchEvent(changeEvent);
      }
    });
  }
  else if(capType == 'bubble'){
    bandRadios.forEach(function (band) {
      if (band.dataset.name == value) {
        band.checked = true;
        band.dispatchEvent(changeEvent);
      }
    });
  }
  else{
    loopRadios.forEach(function (loop) {
      if (loop.dataset.name == value) {
        loop.checked = true;
        loop.dispatchEvent(changeEvent);
      }
    });
  }
  
}
function checkBottle(value) {
  // Prevent recursive calls
  if (isCheckingBottle) {
    // return;
  }
  
  isCheckingBottle = true;
  randomizeCondition = true;
  summaryBottleSection.setAttribute('data-filled', 'filled');

  let foundAvailable = false;
  let firstAvailable = null;
  let targetRadios = [];

  // Determine which radio sets to check based on bottle size
  if (bottleSizeOption == '25oz') {
    targetRadios = [bottleRadios, bottleRadios32oz, bottleRadios16oz];
  } else if (bottleSizeOption == '32oz') {
    targetRadios = [bottleRadios32oz, bottleRadios, bottleRadios16oz];
  } else if (bottleSizeOption == '16oz') {
    targetRadios = [bottleRadios16oz, bottleRadios, bottleRadios32oz];
  } else if (bottleSizeOption == '30oz') {
    targetRadios = [bottleRadios30oz, bottleRadios, bottleRadios32oz];
  } else if (bottleSizeOption == '40oz') {
    targetRadios = [bottleRadios40oz, bottleRadios, bottleRadios32oz];
  } else if (bottleSizeOption == '64oz') {
    targetRadios = [bottleRadios64oz, bottleRadios, bottleRadios32oz];
  }

  // First pass: find first available radio and check if selected one is available
  targetRadios[0].forEach(element => {
    if (!element.classList.contains('disabled') && !firstAvailable) {
      firstAvailable = element;
    }
    if (element.dataset.name === value) {
      if (element.classList.contains('disabled')) {
        foundAvailable = false;
      } else {
        foundAvailable = true;
      }
    }
  });

  // If selected bottle is disabled, use first available
  if (!foundAvailable && firstAvailable) {
    value = firstAvailable.dataset.name;
  }

  // Set the radio buttons
  targetRadios.forEach(radioSet => {
    radioSet.forEach(bottle => {
      if (bottle.dataset.name === value) {
        bottle.checked = true;
        if (radioSet === targetRadios[0] && !isDispatchingEvents) {
          isDispatchingEvents = true;
          try {
            bottle.dispatchEvent(changeEvent);
          } finally {
            isDispatchingEvents = false;
          }
        }
      }
    });
  });

  randomizeCondition = false;
  isCheckingBottle = false;
}
function checkBoot(value) {
  summaryBootSection.setAttribute('data-filled', 'filled');
  summaryBootSection.setAttribute('data-boot', 'with');
  withBoot = true;
  bootChoices.querySelector('#add_boot').classList.add('active');
  bootChoices.querySelector('#no_boot').classList.remove('active');
  updateBoot();

  // Define radio sets for optimization based on bottle size
  let targetRadios = [];

  if (bottleSizeOption === '16oz' || bottleSizeOption === '25oz' || bottleSizeOption === '30oz') {
    targetRadios = [bootRadios];
  } else {
    targetRadios = [bootRadios32oz, bootRadios];
  }

  // Set the radio buttons
  targetRadios.forEach(radioSet => {
    radioSet.forEach(bottle => {
      if (bottle.dataset.name === value) {
        bottle.checked = true;
        if (radioSet === targetRadios[0] && !isDispatchingEvents) {
          isDispatchingEvents = true;
          try {
            bottle.dispatchEvent(changeEvent);
          } finally {
            isDispatchingEvents = false;
          }
        }
      }
    });
  });

  summaryBottleSection.click();
}


function reset() {
  randomizeCondition = true;
  animationSpeed = 0;

  const bottleBool = bottleBundleVariantID.length > 1;
  const capBool = capBundleVariantID.length > 1;
  const loopBool = loopBundleVariantID.length > 1;
  const bootBool = bootVariantID.length > 1;

  popupCheckout.classList.remove('show');
  popupCheckout.classList.remove('slide-in');

  if(bottleSizeOption == '16oz' && bottleRadios16oz.length){
    bottleRadios16oz[0].checked = true
    bottleRadios16oz[0].dispatchEvent(changeEvent);
  }
  if(bottleSizeOption == '25oz' && bottleRadios.length){
    bottleRadios[0].checked = true
    bottleRadios[0].dispatchEvent(changeEvent);
  }
  if(bottleSizeOption == '32oz' && bottleRadios32oz.length){
    bottleRadios32oz[0].checked = true
    bottleRadios32oz[0].dispatchEvent(changeEvent);
  }
  if (bottleSizeOption == '30oz' && bottleRadios30oz.length) {
    bottleRadios30oz[1].checked = true;
    bottleRadios30oz[1].dispatchEvent(changeEvent);
  }
  if (bottleSizeOption == '40oz' && bottleRadios40oz.length) {
    bottleRadios40oz[2].checked = true;
    bottleRadios40oz[2].dispatchEvent(changeEvent);
  }
  if (bottleSizeOption == '64oz' && bottleRadios64oz.length) {
    bottleRadios64oz[1].checked = true;
    bottleRadios64oz[1].dispatchEvent(changeEvent);
  }

  if(getCapType() == 'pebble'){
    loopRadios[0].checked = true
    loopRadios[0].dispatchEvent(changeEvent);
    capRadios[0].checked = true
    capRadios[0].dispatchEvent(changeEvent);
  }
  if(getCapType() == 'robo'){
    robocapRadios[0].checked = true
    robocapRadios[0].dispatchEvent(changeEvent);
    robocapRadios[0].checked = true
    robocapRadios[0].dispatchEvent(changeEvent);
  }
  if(getCapType() == 'bubble'){
    bubblecapRadios[0].checked = true
    bubblecapRadios[0].dispatchEvent(changeEvent);
    bubblecapRadios[0].checked = true
    bubblecapRadios[0].dispatchEvent(changeEvent);
  }
  if(getCapType() == 'base'){
    basecapRadios[0].checked = true;
    basecapRadios[0].dispatchEvent(changeEvent);
    connectorRadios[0].checked = true;
    connectorRadios[0].dispatchEvent(changeEvent);
  }
  if(getCapType() == 'chug'){
    chugcapRadios[0].checked = true;
    chugcapRadios[0].dispatchEvent(changeEvent);
    connectorRadios[0].checked = true;
    connectorRadios[0].dispatchEvent(changeEvent);
  }
  if(getCapType() == 'sip'){
    sipcapRadios[0].checked = true;
    sipcapRadios[0].dispatchEvent(changeEvent);
    connectorRadios[0].checked = true;
    connectorRadios[0].dispatchEvent(changeEvent);
  }


  withBoot = false;
  bootVariantID = '';
  engravingInput.value = '';
  engravingInputMobile.value = '';
  popupEngravingText.innerText = '';
  engravingValue = '';
  updateSummaryOverview();
  document.querySelector('.bottle-hover span').innerText = '';

  bottleBool ? '' : (bottleBundleVariantID = '', popupBottleImage.src = '');
  capBool ? '' : (capBundleVariantID = '', popupCapImage.src = '');
  loopBool ? '' : (loopBundleVariantID = '', popupLoopImage.src = '', withLoop = true);
  bootBool ? '' : (bootVariantID = '', popupBootImage.src = '', withBoot = false);
  
  if (!bootBool) {
    [...bootChoices.children].forEach(function (element) {
      element.classList.remove('active');
      element.id == 'no_boot' ? element.classList.add('active') : ''
    });
  }
  if (!bootBool) {
    [...bootChoicesMobile.children].forEach(function (element) {
      element.classList.remove('active');
      element.id == 'no_boot' ? element.classList.add('active') : ''
    });
  }



  updateBoot();
  
  summaryBottleSection.click();
  document.querySelector('#bottle-tab').checked = true;
  document.querySelector('#bottle-tab').dispatchEvent(changeEvent);
  summaryEngravingSection.dataset.filled = 'empty';
  
  updateCTA();

  customizationMain.classList.remove('loading-icon');
  //   const css = document.querySelector('#flaskCustomizerCSS').innerHTML;
  //   document.querySelector('#flaskCustomizerCSS').remove();
  //   const cssel = document.createElement('style');
  //   cssel.id = 'flaskCustomizerCSS';
  //   cssel.innerHTML = css;
  // setTimeout(function(){
  //   document.head.append(cssel);}, 10)
  
  
  randomizeCondition = false;
  animationSpeed = 300;
}

const isWindowSizeGreaterThan899 = window.innerWidth > 899;
// component clicks
document.querySelector('.bottle-hover').addEventListener('click', function () {
  summaryBottleSection.click();
  summaryBottleSectionMobile.classList.add('active');
  document.querySelector('#bottle-tab').checked = true;
  document.querySelector('#bottle-tab').dispatchEvent(changeEvent);
})
document.querySelector('.cap-hover').addEventListener('click', function () {
  summaryCapSection.click();
  summaryCapSectionMobile.classList.add('active');
  document.querySelector('#cap-tab').checked = true;
  document.querySelector('#cap-tab').dispatchEvent(changeEvent);
})
document.querySelector('.loop-hover').addEventListener('click', function () {
  summaryLoopSection.click();
  summaryLoopSectionMobile.classList.add('active');
  document.querySelector('#loop-tab').checked = true;
  document.querySelector('#loop-tab').dispatchEvent(changeEvent);
})
document.querySelector('.boot-hover').addEventListener('click', function () {
  if(withBoot){
    summaryBootSection.click();
    summaryBootSectionMobile.classList.add('active');
    document.querySelector('#boot-tab').checked = true;
    document.querySelector('#boot-tab').dispatchEvent(changeEvent);
  }
})


// onboarding functions
const onboardingNext = document.querySelectorAll('.ocf--next');
const onboardingBack = document.querySelectorAll('.ocf--back');


function onBoardingNextSlide(param) {
  const step = parseInt(param) + 1;
  const slide = document.querySelector(`.onboarding_content.onboarding--step-${step}`);
  document.querySelectorAll('.onboarding_content').forEach(function (oc) { oc.classList.remove('active') })
  stopOnboardingVideo();

  param != '4' ? (slide.classList.add('active'), slide.querySelector('.ocm--video').play()) : setTimeout(function(){closeOnboarding()}, 100), localStorage.setItem('flaskOnboarding', 'hide');
}

function onBoardingPreviousSlide(param) {
  const step = parseInt(param) - 1;
  const slide = document.querySelector(`.onboarding_content.onboarding--step-${step}`);
  document.querySelectorAll('.onboarding_content').forEach(function (oc) { oc.classList.remove('active') })
  stopOnboardingVideo();

  param != '1' ? (slide.classList.add('active'), slide.querySelector('.ocm--video').play()) : setTimeout(function(){closeOnboarding()}, 100), localStorage.setItem('flaskOnboarding', 'hide');
}

function stopOnboardingVideo() {
  document.querySelectorAll('.ocm--video').forEach(function (vid) { vid.pause() })
}


function isLight(color) {
  // Convert the color to RGB
  let rgb = hexToRgb(color);

  // Calculate the perceived brightness using the formula
  let brightness = (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;

  // Return true if the brightness is greater than 128 (considered light)
  return brightness > 128;
}

// Function to convert hex color to RGB
function hexToRgb(hex) {
  // Remove the hash if present
  hex = hex.replace(/^#/, '');

  // Parse the hex value into RGB
  let bigint = parseInt(hex, 16);
  let r = (bigint >> 16) & 255;
  let g = (bigint >> 8) & 255;
  let b = bigint & 255;

  // Return an object with RGB values
  return { r, g, b };
}

// Function to set text color based on background color
function checkColor(hex) {

  const eColor = isLight(hex) ? 'dark' : 'light';
  // Set the text color
  // previewEngraving.setAttribute('data-text_color', eColor);
  // popupEngraving.setAttribute('data-text_color', eColor);
  // engravingColor = eColor;
}


// custom swipe mobile functionality
let touchStartX = 0;
let touchMoveX = 0;
let touchStartY = 0;
let touchStartTime = 0;
let swipeTriggered = false; // Prevent multiple triggers per swipe
const maxSwipeTime = 300; // 0.3 seconds in milliseconds

swipeElement.addEventListener('touchstart', handleTouchStart);
swipeElement.addEventListener('touchmove', handleTouchMove);
swipeElement.addEventListener('touchend', handleTouchEnd);

function handleTouchStart(event) {
  touchStartX = event.touches[0].clientX;
  touchStartY = event.touches[0].clientY;
  touchStartTime = new Date().getTime(); // record the start time of the touch
  swipeTriggered = false; // Reset flag on new touch
}

function handleTouchEnd() {
  swipeTriggered = false; // Reset flag when touch ends
}

function handleTouchMove(event) {
  // If already triggered a swipe this gesture, don't trigger again
  if (swipeTriggered) return;

  const currentTime = new Date().getTime();
  const elapsedTime = currentTime - touchStartTime;

  // If the swipe takes longer than 0.3s, stop handling it
  if (elapsedTime > maxSwipeTime) return;

  touchMoveX = event.touches[0].clientX;
  const touchMoveY = event.touches[0].clientY;
  let deltaX = touchMoveX - touchStartX;
  let deltaY = touchMoveY - touchStartY;

  // Only trigger swipe if horizontal movement is significant (more than 20px)
  // and horizontal movement is greater than vertical movement
  if (Math.abs(deltaX) > 20 && Math.abs(deltaX) > Math.abs(deltaY)) {
    if (deltaX > 0) {
      // Move to the right
      document.querySelector('#bottle-preview-25oz.bottle-preview.active') ? bottleSwiper.slidePrev() : '';
      document.querySelector('#bottle-preview-16oz.bottle-preview.active') ? bottleSwiper16oz.slidePrev() : '';
      document.querySelector('#bottle-preview-32oz.bottle-preview.active') ? bottleSwiper32oz.slidePrev() : '';
      document.querySelector('#bottle-preview-30oz.bottle-preview.active') ? bottleSwiper30oz.slidePrev() : '';
      document.querySelector('#bottle-preview-40oz.bottle-preview.active') ? bottleSwiper40oz.slidePrev() : '';
      document.querySelector('#bottle-preview-64oz.bottle-preview.active') ? bottleSwiper64oz.slidePrev() : '';
      document.querySelector('.cap-preview.active') ? capSwiper.slidePrev() : '';
      document.querySelector('.robocap-preview.active') ? robocapSwiper.slidePrev() : '';
      document.querySelector('.bubblecap-preview.active') ? bubblecapSwiper.slidePrev() : '';
      document.querySelector('.basecap-preview.active') ? basecapSwiper.slidePrev() : '';
      document.querySelector('.chugcap-preview.active') ? chugcapSwiper.slidePrev() : '';
      document.querySelector('.sipcap-preview.active') ? sipcapSwiper.slidePrev() : '';
      document.querySelector('.loop-preview.active') ? loopSwiper.slidePrev() : '';
      document.querySelector('.band-preview.active') ? bandSwiper.slidePrev() : '';
      isConnectorPreviewActive() ? getActiveConnectorSwiper()?.slidePrev() : '';
      document.querySelector('#boot-preview-25oz.boot-preview.active') ? bootSwiper.slidePrev() : '';
      document.querySelector('#boot-preview-32oz.boot-preview.active') ? bootSwiper32oz.slidePrev() : '';
    } else if (deltaX < 0) {
      // Move to the left
      document.querySelector('#bottle-preview-16oz.bottle-preview.active') ? bottleSwiper16oz.slideNext() : '';
      document.querySelector('#bottle-preview-25oz.bottle-preview.active') ? bottleSwiper.slideNext() : '';
      document.querySelector('#bottle-preview-32oz.bottle-preview.active') ? bottleSwiper32oz.slideNext() : '';
      document.querySelector('#bottle-preview-30oz.bottle-preview.active') ? bottleSwiper30oz.slideNext() : '';
      document.querySelector('#bottle-preview-40oz.bottle-preview.active') ? bottleSwiper40oz.slideNext() : '';
      document.querySelector('#bottle-preview-64oz.bottle-preview.active') ? bottleSwiper64oz.slideNext() : '';
      document.querySelector('.cap-preview.active') ? capSwiper.slideNext() : '';
      document.querySelector('.robocap-preview.active') ? robocapSwiper.slideNext() : '';
      document.querySelector('.bubblecap-preview.active') ? bubblecapSwiper.slideNext() : '';
      document.querySelector('.basecap-preview.active') ? basecapSwiper.slideNext() : '';
      document.querySelector('.chugcap-preview.active') ? chugcapSwiper.slideNext() : '';
      document.querySelector('.sipcap-preview.active') ? sipcapSwiper.slideNext() : '';
      document.querySelector('.loop-preview.active') ? loopSwiper.slideNext() : '';
      isConnectorPreviewActive() ? getActiveConnectorSwiper()?.slideNext() : '';
      document.querySelector('.band-preview.active') ? bandSwiper.slideNext() : '';
      document.querySelector('#boot-preview-25oz.boot-preview.active') ? bootSwiper.slideNext() : '';
      document.querySelector('#boot-preview-32oz.boot-preview.active') ? bootSwiper32oz.slideNext() : '';
    }
    // Mark swipe as triggered to prevent multiple slides per gesture
    swipeTriggered = true;
  }
}


// functions to check if component is available
function checkBottleAvailability(params) {
  if (params.classList.contains('disabled')) {
    bottleBundleVariantID = '';
    bottleIndividualVariantID = '';
    bottleIsAvailable = false;
    summaryBottleSection.classList.add('unavailable');
    summaryBottleSectionMobile.classList.add('unavailable');
    document.querySelector('[for="bottle-tab"').classList.add('unavailable');
  } else {
    bottleIsAvailable = true;
    summaryBottleSection.classList.remove('unavailable');
    summaryBottleSectionMobile.classList.remove('unavailable');
    document.querySelector('[for="bottle-tab"').classList.remove('unavailable');
  }
  updateCTA();
}
function checkCapAvailability(params) {
  if (params.classList.contains('disabled')) {
    capBundleVariantID = '';
    capIndividualVariantID = '';
    capIsAvailable = false;
    summaryCapSection.classList.add('unavailable', 'unavailable--pebble');
    summaryCapSectionMobile.classList.add('unavailable', 'unavailable--pebble');
    document.querySelector('[for="cap-tab"').classList.add('unavailable', 'unavailable--pebble');
  } else {
    capIsAvailable = true;
    summaryCapSection.classList.remove('unavailable', 'unavailable--pebble', 'unavailable--robo');
    summaryCapSectionMobile.classList.remove('unavailable', 'unavailable--pebble', 'unavailable--robo');
    document.querySelector('[for="cap-tab"').classList.remove('unavailable', 'unavailable--pebble', 'unavailable--robo');
  }
  updateCTA();
}

function checkroboCapAvailability(params) {
  if (params.classList.contains('disabled')) {
    capBundleVariantID = '';
    capIndividualVariantID = '';
    capIsAvailable = false;
    summaryCapSection.classList.add('unavailable', 'unavailable--robo');
    summaryCapSectionMobile.classList.add('unavailable', 'unavailable--robo');
    document.querySelector('[for="cap-tab"').classList.add('unavailable', 'unavailable--robo');
  } else {
    capIsAvailable = true;
    summaryCapSection.classList.remove('unavailable', 'unavailable--robo', 'unavailable--pebble');
    summaryCapSectionMobile.classList.remove('unavailable', 'unavailable--robo', 'unavailable--pebble');
    document.querySelector('[for="cap-tab"').classList.remove('unavailable', 'unavailable--robo', 'unavailable--pebble');
  }
  updateCTA();
}

function checkBubbleAvailability(params) {
  if (params.classList.contains('disabled')) {
    capBundleVariantID = '';
    capIndividualVariantID = '';
    capIsAvailable = false;
    summaryCapSection.classList.add('unavailable', 'unavailable--bubble');
    summaryCapSectionMobile.classList.add('unavailable', 'unavailable--bubble');
    document.querySelector('[for="cap-tab"').classList.add('unavailable', 'unavailable--bubble');
  } else {
    capIsAvailable = true;
    summaryCapSection.classList.remove('unavailable', 'unavailable--bubble', 'unavailable--pebble');
    summaryCapSectionMobile.classList.remove('unavailable', 'unavailable--bubble', 'unavailable--pebble');
    document.querySelector('[for="cap-tab"').classList.remove('unavailable', 'unavailable--bubble', 'unavailable--pebble');
  }
  updateCTA();
}

function checkBandAvailability(params) {
  if (params.classList.contains('disabled')) {
    loopBundleVariantID = '';
    loopIndividualVariantID = '';
    loopIsAvailable = false;
    summaryLoopSection.classList.add('unavailable', 'unavailable--band');
    summaryLoopSectionMobile.classList.add('unavailable', 'unavailable--band');
    document.querySelector('[for="loop-tab"').classList.add('unavailable', 'unavailable--band');
  } else {
    loopIsAvailable = true;
    summaryLoopSection.classList.remove('unavailable', 'unavailable--band', 'unavailable--loop');
    summaryLoopSectionMobile.classList.remove('unavailable', 'unavailable--band', 'unavailable--loop');
    document.querySelector('[for="loop-tab"').classList.remove('unavailable', 'unavailable--band', 'unavailable--loop');
  }
  updateCTA();
}
function checkLoopAvailability(params) {
  if (params.classList.contains('disabled')) {
    loopBundleVariantID = '';
    loopIndividualVariantID = '';
    loopIsAvailable = false;
    summaryLoopSection.classList.add('unavailable');
    summaryLoopSectionMobile.classList.add('unavailable');
    document.querySelector('[for="loop-tab"').classList.add('unavailable');
  } else {
    loopIsAvailable = true;
    summaryLoopSection.classList.remove('unavailable');
    summaryLoopSectionMobile.classList.remove('unavailable');
    document.querySelector('[for="loop-tab"').classList.remove('unavailable');
  }
  updateCTA();
}

function checkConnectorAvailability(params) {
  if (params.classList.contains('disabled')) {
    loopBundleVariantID = '';
    loopIndividualVariantID = '';
    loopIsAvailable = false;
    summaryLoopSection.classList.add('unavailable');
    summaryLoopSectionMobile.classList.add('unavailable');
    document.querySelector('[for="loop-tab"').classList.add('unavailable');
  } else {
    loopIsAvailable = true;
    summaryLoopSection.classList.remove('unavailable');
    summaryLoopSectionMobile.classList.remove('unavailable');
    document.querySelector('[for="loop-tab"').classList.remove('unavailable');
  }
  updateCTA();
}
function checkBootAvailability(params) {
  if (params.classList.contains('disabled')) {
    bootVariantID = '';
    bootIsAvailable = false;
    summaryBootSection.classList.add('unavailable');
    summaryBootSectionMobile.classList.add('unavailable');
    document.querySelector('[for="boot-tab"').classList.add('unavailable');
  } else {
    bootIsAvailable = true;
    summaryBootSection.classList.remove('unavailable');
    summaryBootSectionMobile.classList.remove('unavailable');
    document.querySelector('[for="boot-tab"').classList.remove('unavailable');
  }
  updateCTA();
}

function updateCTA() {
    if (bottleIsAvailable && bootIsAvailable && loopIsAvailable && capIsAvailable && engravingIsValid) {
      addToBag.classList.remove('disabled');
      addToBag.removeAttribute('disabled');
      addToBag.classList.remove('loading-icon');
    }
    else {
      addToBag.classList.add('disabled');
    }
  // }
}


document.querySelector('.onboarding_modal--container').classList.add('active');
document.addEventListener('DOMContentLoaded', function () {
  pageLoaded = true;
  if (sourceExists || !document.querySelector('.onboarding-section').classList.contains('hidden')) {
    setTimeout(() => {
      document.querySelector('.onboarding--step-1.active .ocm--video').play();
      swiperInitialized ? '' : initSwipers();
      sourceExists = false;
      setTimeout(() => {
        document.querySelector('.onboarding-section').classList.remove('closed');
      }, 5000);
    }, 1000);
  }
})

async function fetchFlaskDetails(url) {
  const fullUrl = url /*+ '&section_id=' + section*/;

  fetch(fullUrl)
    .then((response) => {
      if (!response.ok) {
        throw new Error(`Network response was not ok: ${response.statusText}`);
      }
      return response.text(); // assuming the response is in text format
    })
    .then((data) => {
      // const sectionElement = document.querySelector(`#shopify-section-${section} form`);

      updateFlaskGallery(data);
      initializeVTOGallerySwiper();
    })
    .catch((error) => {
      console.error('Fetch error:', error);
    });
}

function updateFlaskGallery(data) {
  const productGallery = document.querySelectorAll('.product-gallery-swipper');
  const doc = parser.parseFromString(data, 'text/html');
  const newProductGallery = doc.querySelectorAll('.product-gallery-swipper');
  productGallery.forEach((element, index) => {
    element.replaceWith(newProductGallery[index]);
  })

  const productVTOContainer = document.querySelector('.desktop-product-vto-container');
  const newproductVTOContainer = doc.querySelector('.desktop-product-vto-container');
  productVTOContainer.replaceWith(newproductVTOContainer);

  document.querySelector('#product-gallery-container').setAttribute('data-product-sku', doc.querySelector('#product-gallery-container').getAttribute('data-product-sku'));
  try {
    loadGallerySwiper();
  } catch (error) {

  }

}


popupButtonEdit.forEach(function (button) {
  button.addEventListener('click', function (event) {
    popupCheckout.classList.remove('show');
    popupCheckout.classList.remove('slide-in');
  })
})


// disable emoji input in engraving

const allowedEmoji = ['♡','☻','✿','☆','⟡','☾','🐾','☯','🜲','𖤓','ᯓ','★','ꕤ','❆','•','ᴗ','♫','0','1','2','3','4','5','6','7','8','9'];
let emojies = '';

function disableEmojiInput(event) {
  const isEmoji = isEmojiCharacter(event.key);

  if (isEmoji) {
      event.preventDefault();
  }
}
function checkEmoji(param){
  emojies = '';
  let invalidEmojiCounter = 0;
  const characters = Array.from(param);

  characters.forEach(character => {
      if(isEmojiCharacter(character)){
        invalidEmojiCounter++;
        emojies = emojies + character;
      }
  });
  updateEmoji(invalidEmojiCounter);
}

function updateEmoji(param){
  if(param > 0){
    document.querySelectorAll('.emoji-error').forEach(er => { er.style.display = 'flex' });
    document.querySelector('.summary-mobile #emoji-characters').innerText = emojies
    // document.querySelector('.summary-desktop #emoji-characters').innerText = emojies // summary-desktop removed
    engravingIsValid = false;
  }
  else{
    document.querySelectorAll('.emoji-error').forEach(er => { er.style.display = 'none' });
    engravingIsValid = true;
  }
  updateCTA();
}

function isEmojiCharacter(char) {
  const emojiPattern = /^[\u{1F300}-\u{1F5FF}\u{1F600}-\u{1F64F}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}]+$/u;
  // emojiPattern.test(char) && !allowedEmoji.includes(char) ? emojies = emojies + char : '';
  return emojiPattern.test(char) && !allowedEmoji.includes(char);
}

document.querySelectorAll('.summary-mobile .button-emoji').forEach(function (emojiButton) {
  emojiButton.addEventListener('click', function (e) {
    e.preventDefault();
    if (getModifiedEngravingLength(engravingInput.value) > 14) {
      return;
    }
    engravingInput.value = engravingInput.value + emojiButton.value;
    engravingInput.dispatchEvent(new Event('input', { bubbles: true }));
  });
});

buttonFont.forEach(btn => {
  btn.addEventListener('click', function (e) {
    buttonFont.forEach(e => e.classList.remove('active'));
    btn.classList.add('active');
    engravingInput.style.fontFamily = btn.value;
    engravingInputMobile.style.fontFamily = btn.value;
    previewEngraving.style.fontFamily = btn.value;
    popupEngravingText.style.fontFamily = btn.value;
    engravingFont = btn.value;

      engravingInput.dispatchEvent(new Event('input'));
      engravingInputMobile.dispatchEvent(new Event('input'));

      if(btn.closest('.summary-mobile')){
        updateEngraving(engravingInputMobile.value, 'mobile', e);
      }
      // if(btn.closest('.summary-desktop')){
      //   updateEngraving(engravingInput.value, 'desktop', e);
      // }
    // update font size (desktop sizes are set by updateEngraving via input dispatch)
    if (window.innerWidth <= 899) {
      popupEngravingText.style.fontSize = btn.dataset.fontSize;
      previewEngravingText.style.fontSize = btn.dataset.fontSize;
    }
  })
})

// scroll down on mobile swipe if component is out of stock
function scrollDownIfOOS(element){
  element == true ? setTimeout(() => {customizationMain.scrollTop = +999999;}, 200) : customizationMain.scrollTop = -999999;
        
}

// flask tooltip
document.querySelector('.flask-tooltip').addEventListener('click', function(e){
  document.querySelector('.flask-customization-main .price-container').classList.toggle('show-tooltip');
})

customizationMain.addEventListener('click', e => {
  if(!e.target.closest('.flask-tooltip')){
    document.querySelector('.flask-customization-main .price-container').classList.remove('show-tooltip');
  }
})
customizerLoaded = true;


function scrollSummaryToElement(scrollTarget) {
  const summarySection = document.querySelector('.summary-section');
  if (!summarySection || !scrollTarget) return;

  const top = scrollTarget.getBoundingClientRect().top - summarySection.getBoundingClientRect().top + summarySection.scrollTop;
  summarySection.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
}

function scrollSummaryToColorSwatches(mobileSection) {
  if (!window.matchMedia('(max-width: 899px)').matches || !mobileSection) return;

  let colorSection = null;

  if (mobileSection.classList.contains('bottle-section-mobile')) {
    colorSection = mobileSection.querySelector('.color-section[data-size-category="' + bottleSizeOption + '"]')
      || mobileSection.querySelector('#bottle-' + bottleSizeOption);
  } else if (mobileSection.classList.contains('cap-section-mobile')) {
    const capType = customizationMain.dataset.capType || defaultCapType;
    const capSectionClass = getLoopStyleCapSectionClass(capType);
    colorSection = mobileSection.querySelector('.color-section.' + capSectionClass);
  }

  if (!colorSection) {
    colorSection = Array.from(mobileSection.querySelectorAll('.color-section')).find(function (el) {
      return el.offsetParent !== null;
    });
  }

  if (!colorSection) return;

  requestAnimationFrame(function () {
    scrollSummaryToElement(colorSection);
  });
}

function scrollSummarySectionDown(){
  const summary_section = document.querySelector('.summary-section');

  // Ensure the element exists
  if (summary_section) {
    // Scroll the element down by a specific amount (e.g., 100 pixels)
    summary_section.scrollBy({
      top: 100, // Amount to scroll down
      behavior: 'smooth', // Smooth scrolling effect
    });

    // Or scroll to the bottom of the element
    summary_section.scrollTo({
      top: summary_section.scrollHeight, // Scroll to the maximum height
      behavior: 'smooth', // Smooth scrolling effect
    });
  } else {
    console.error('Element not found!');
  }

}

function activateLoopStyleCapSelection(options) {
  getAllCapPreviewElements().forEach(preview => preview?.classList.remove('active'));
  if (options.previewEl) options.previewEl.classList.add('active');

  let selectedCap = document.querySelector(options.radioSelector + ':checked') || document.querySelector(options.radioSelector);
  if (selectedCap && !selectedCap.checked) {
    selectedCap.checked = true;
    selectedCap.dispatchEvent(new Event('change'));
  }

  let selectedLoop = document.querySelector('.loop_component_radio:checked') || document.querySelector('.loop_component_radio');
  if (selectedLoop && !selectedLoop.checked) {
    selectedLoop.checked = true;
    selectedLoop.dispatchEvent(new Event('change'));
  }

  if (selectedCap) {
    selectedCap.classList.contains('disabled')
      ? (summaryCapSection.classList.add(options.unavailableClass), summaryCapSectionMobile.classList.add(options.unavailableClass))
      : (summaryCapSection.classList.remove(options.unavailableClass), summaryCapSectionMobile.classList.remove(options.unavailableClass));
  }

  (options.clearUnavailableClasses || []).forEach(function (cls) {
    summaryCapSection.classList.remove(cls);
    summaryCapSectionMobile.classList.remove(cls);
  });

  return { selectedCap: selectedCap, selectedLoop: selectedLoop, capType: options.capTypeName };
}

function activateConnectorStyleCapSelection(options) {
  getAllCapPreviewElements().forEach(preview => preview?.classList.remove('active'));
  getAllConnectorPreviewElements().forEach(preview => preview?.classList.remove('active'));

  if (currentSection === 'loop') {
    connectorPreview?.classList.add('active');
  } else if (options.capPreviewEl) {
    options.capPreviewEl.classList.add('active');
  }

  let selectedCap = document.querySelector(options.radioSelector + ':checked') || getDefaultAdditionalCapRadio(options.radioSelector);
  const capSummaryByType = {
    base: updateBasecapSummary,
    chug: updateChugcapSummary,
    sip: updateSipcapSummary
  };
  if (selectedCap) {
    if (!selectedCap.checked) {
      selectedCap.checked = true;
      selectedCap.dispatchEvent(new Event('change'));
    } else if (capSummaryByType[options.capTypeName]) {
      capSummaryByType[options.capTypeName](selectedCap);
    }
  }

  let selectedLoop = getCheckedConnectorRadio();
  if (selectedLoop) {
    if (!selectedLoop.checked) {
      selectedLoop.checked = true;
      selectedLoop.dispatchEvent(new Event('change'));
    } else {
      updateConnectorSummary(selectedLoop);
    }
  }

  if (selectedCap) {
    selectedCap.classList.contains('disabled')
      ? (summaryCapSection.classList.add(options.unavailableClass), summaryCapSectionMobile.classList.add(options.unavailableClass))
      : (summaryCapSection.classList.remove(options.unavailableClass), summaryCapSectionMobile.classList.remove(options.unavailableClass));
  }

  (options.clearUnavailableClasses || []).forEach(function (cls) {
    summaryCapSection.classList.remove(cls);
    summaryCapSectionMobile.classList.remove(cls);
  });

  syncMainCapImageForCapType(options.capTypeName);

  return { selectedCap: selectedCap, selectedLoop: selectedLoop, capType: options.capTypeName };
}

class CapTypeOptions extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', function(e){
      customizationMain.dataset.capType = e.target.dataset.name;

      if (!isStrawGliderCapType(e.target.dataset.name) && gliderActive) {
        syncAllUpgradeGliders(false);
      }

      const connectorStyleConfigs = {
        base: {
          capPreviewEl: basecapPreview,
          radioSelector: '.basecap_component_radio',
          unavailableClass: 'unavailable--base'
        },
        chug: {
          capPreviewEl: chugcapPreview,
          radioSelector: '.chugcap_component_radio',
          unavailableClass: 'unavailable--chug'
        },
        sip: {
          capPreviewEl: sipcapPreview,
          radioSelector: '.sipcap_component_radio',
          unavailableClass: 'unavailable--sip'
        }
      };
      const clearUnavailableClasses = ['unavailable--pebble', 'unavailable--base', 'unavailable--chug', 'unavailable--sip', 'unavailable--robo', 'unavailable--bubble'];
      
      if(e.target.dataset.name == 'robo'){
        getAllCapPreviewElements().forEach(preview => preview?.classList.remove('active'));
        getAllConnectorPreviewElements().forEach(preview => preview?.classList.remove('active'));
        if (currentSection === 'loop') {
          connectorPreview?.classList.add('active');
        } else {
          robocapPreview.classList.add('active');
        }
        
        this.selectedCap = document.querySelector('.robocap_component_radio:checked') || document.querySelector('.robocap_component_radio');
        if (this.selectedCap) {
          if (!this.selectedCap.checked) {
            this.selectedCap.checked = true;
            this.selectedCap.dispatchEvent(new Event('change'));
          } else {
            updateroboCapSummary(this.selectedCap);
          }
        }
        this.selectedCap.classList.contains('disabled') ? (summaryCapSection.classList.add('unavailable--robo'), summaryCapSectionMobile.classList.add('unavailable--robo')) : (summaryCapSection.classList.remove('unavailable--robo'), summaryCapSectionMobile.classList.remove('unavailable--robo'));
        
        this.selectedLoop = document.querySelector('.connector_component_radio:checked');
        if (!this.selectedLoop) {
          this.selectedLoop = document.querySelector('.connector_component_radio');
          if (this.selectedLoop) {
            this.selectedLoop.checked = true;
            this.selectedLoop.dispatchEvent(new Event('change'));
          }
        }
        this.capType = e.target.dataset.name;
        clearUnavailableClasses.filter(cls => cls !== 'unavailable--robo').forEach(function (cls) {
          summaryCapSection.classList.remove(cls);
          summaryCapSectionMobile.classList.remove(cls);
        });
      }
      else if(e.target.dataset.name == 'bubble'){
        getAllCapPreviewElements().forEach(preview => preview?.classList.remove('active'));
        bubblecapPreview.classList.add('active');
        
        this.selectedCap = document.querySelector('.bubblecap_component_radio:checked');
        if (!this.selectedCap) {
          this.selectedCap = document.querySelector('.bubblecap_component_radio');
          if (this.selectedCap) {
            this.selectedCap.checked = true;
            this.selectedCap.dispatchEvent(new Event('change'));
          }
        }
        this.selectedCap.classList.contains('disabled') ? (summaryCapSection.classList.add('unavailable--bubble'), summaryCapSectionMobile.classList.add('unavailable--bubble')) : (summaryCapSection.classList.remove('unavailable--bubble'), summaryCapSectionMobile.classList.remove('unavailable--bubble'));
        
        this.selectedLoop = document.querySelector('.band_component_radio:checked');
        if (!this.selectedLoop) {
          this.selectedLoop = document.querySelector('.band_component_radio');
          if (this.selectedLoop) {
            this.selectedLoop.checked = true;
            this.selectedLoop.dispatchEvent(new Event('change'));
          }
        }
        this.capType = e.target.dataset.name;
        clearUnavailableClasses.filter(cls => cls !== 'unavailable--bubble').forEach(function (cls) {
          summaryCapSection.classList.remove(cls);
          summaryCapSectionMobile.classList.remove(cls);
        });
      }
      else if(connectorStyleConfigs[e.target.dataset.name]){
        const connectorStyleResult = activateConnectorStyleCapSelection({
          capTypeName: e.target.dataset.name,
          capPreviewEl: connectorStyleConfigs[e.target.dataset.name].capPreviewEl,
          radioSelector: connectorStyleConfigs[e.target.dataset.name].radioSelector,
          unavailableClass: connectorStyleConfigs[e.target.dataset.name].unavailableClass,
          clearUnavailableClasses: clearUnavailableClasses.filter(function (cls) {
            return cls !== connectorStyleConfigs[e.target.dataset.name].unavailableClass;
          })
        });
        this.selectedCap = connectorStyleResult.selectedCap;
        this.selectedLoop = connectorStyleResult.selectedLoop;
        this.capType = connectorStyleResult.capType;
      }
      else if(e.target.dataset.name == 'pebble'){
        getAllConnectorPreviewElements().forEach(preview => preview?.classList.remove('active'));
        const loopStyleResult = activateLoopStyleCapSelection({
          capTypeName: 'pebble',
          previewEl: capPreview,
          radioSelector: '.cap_component_radio',
          unavailableClass: 'unavailable--pebble',
          clearUnavailableClasses: clearUnavailableClasses.filter(function (cls) {
            return cls !== 'unavailable--pebble';
          })
        });
        this.selectedCap = loopStyleResult.selectedCap;
        this.selectedLoop = loopStyleResult.selectedLoop;
        this.capType = loopStyleResult.capType;
      }
      else{
        getAllConnectorPreviewElements().forEach(preview => preview?.classList.remove('active'));
        const loopStyleResult = activateLoopStyleCapSelection({
          capTypeName: 'pebble',
          previewEl: capPreview,
          radioSelector: '.cap_component_radio',
          unavailableClass: 'unavailable--pebble',
          clearUnavailableClasses: clearUnavailableClasses.filter(function (cls) {
            return cls !== 'unavailable--pebble';
          })
        });
        this.selectedCap = loopStyleResult.selectedCap;
        this.selectedLoop = loopStyleResult.selectedLoop;
        this.capType = 'pebble';
      }

      syncMainCapImageForCapType(e.target.dataset.name);

      if (!this.selectedCap) {
        this.checkCTA();
        updatePricing();
        updateSummaryOverview();
        setTimeout(function () { scrollSummaryToColorSwatches(summaryCapSectionMobile); }, 0);
        return;
      }

      this.capImage = getCapImageSrcFromElement(this.selectedCap);
      this.variantID = this.selectedCap.classList.contains('disabled') ? '' : this.selectedCap.dataset.variant_id;
      this.loopImage = '';
      this.loopVariantID = '';

      if (this.selectedLoop) {
        if (isConnectorStyleCapType(this.capType)) {
          this.loopImage = getConnectorImageSrcFromElement(this.selectedLoop, this.capType);
        } else if (bottleSizeOption == '25oz') {
          this.loopImage = this.selectedLoop.dataset.image;
        } else if (bottleSizeOption == '16oz') {
          this.loopImage = this.selectedLoop.dataset.image_16oz;
        } else if (bottleSizeOption == '30oz') {
          this.loopImage = this.selectedLoop.dataset.image_30oz || this.selectedLoop.dataset.image;
        } else if (bottleSizeOption == '32oz') {
          this.loopImage = this.selectedLoop.dataset.image_32oz;
        } else if (bottleSizeOption == '40oz') {
          this.loopImage = this.selectedLoop.dataset.image_40oz || this.selectedLoop.dataset.image_32oz;
        } else if (bottleSizeOption == '64oz') {
          this.loopImage = this.selectedLoop.dataset.image_64oz || this.selectedLoop.dataset.image_32oz;
        } else {
          this.loopImage = this.selectedLoop.dataset[`image_${bottleSizeOption}`];
        }
        this.loopVariantID = this.selectedLoop.classList.contains('disabled') ? '' : this.selectedLoop.dataset.variant_id;

        if (isConnectorStyleCapType(this.capType)) {
          syncConnectorSelectionForCapType(this.capType, this.selectedLoop);
        }
      }

      this.updateCapType(this.capImage, this.variantID, this.capType, this.loopImage, this.loopVariantID, this.selectedLoop, this.selectedCap);
      this.checkCTA();
      updatePricing();
      updateSummaryOverview();
      setTimeout(function () { scrollSummaryToColorSwatches(summaryCapSectionMobile); }, 0);
    });
  }

  checkCTA(){
    capIsAvailable = this.selectedCap?.classList.contains('disabled') ? false : true;
    loopIsAvailable = this.selectedLoop?.classList.contains('disabled') ? false : true;
    if (!loopIsAvailable) loopBundleVariantID = '';
    updateCTA();
  }
  updateCapType(capimage, id, type, loopimage, loopid, loopElement, capElement){
    const resolvedCapImage = capimage || getCapImageSrcFromElement(capElement);
    if (resolvedCapImage) {
      const capSrc = imageSrcWithoutWidthParam(resolvedCapImage);
      popupCapImage.src = capSrc;
      capImage.src = capSrc;
    }
    capBundleVariantID = id || '';
    if (id && capElement) {
      capInventory = {
        variantID: id,
        variantQuantity: capElement.dataset.item_count
      };
    }
    if (loopimage) {
      const loopSrc = imageSrcWithoutWidthParam(loopimage);
      loopImage.src = loopSrc;
      popupLoopImage.src = loopSrc;
    }
    loopBundleVariantID = loopid || '';
    if (loopid && loopElement) {
      loopInventory = {
        variantID: loopid,
        variantQuantity: loopElement.dataset.item_count
      };
    }
    const capTypeText = document.querySelectorAll('#cap-type-text');
    if (capTypeText) capTypeText.forEach(text => text.innerText = type || '');
  }
}

// Register the custom element
customElements.define("cap-type-options", CapTypeOptions);

function getCapType(){
  const capType = document.querySelector('.flask-customization-main').dataset.capType;
  return capType;
}

function showCustomizer(sourceExists){
  customizationMain.classList.add('show');

  if(!sourceExists){
    randomizeCondition = true
    bootShowPreview(clickFromMainRadios);
    capShowPreview(clickFromMainRadios);
    loopShowPreview(clickFromMainRadios);
    if(clickFromMainRadios == false){
      checkCap(mainRadios[0].dataset.color);
      checkLoop(mainRadios[0].dataset.color);
      checkBottle(mainRadios[0].dataset.color);
    }
      randomizeCondition = false;
      bottleShowPreview();
  }
  clickFromMainRadios = false;
}

// Glider Upgrade [Ron]
function updateUpgradeGliderIcon(glider, isActive) {
  const gliderAction = glider.querySelector('.upgrade-glider-action');
  if (!gliderAction) return;

  const isSummary = !!gliderAction.closest('.summary-details-item.cap-details');

  if (isActive) {
    if (isSummary) {
      gliderAction.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.99996 0.666687C3.94996 0.666687 0.666626 3.95002 0.666626 8.00002C0.666626 12.05 3.94996 15.3334 7.99996 15.3334C12.05 15.3334 15.3333 12.05 15.3333 8.00002C15.3333 3.95002 12.05 0.666687 7.99996 0.666687ZM11.1786 6.76002C11.2372 6.69312 11.2817 6.61518 11.3097 6.5308C11.3377 6.44642 11.3485 6.3573 11.3415 6.26868C11.3345 6.18006 11.3099 6.09373 11.269 6.01477C11.2282 5.93582 11.1719 5.86582 11.1037 5.80892C11.0354 5.75201 10.9564 5.70933 10.8714 5.6834C10.7863 5.65746 10.697 5.6488 10.6085 5.65791C10.5201 5.66702 10.4344 5.69372 10.3565 5.73644C10.2785 5.77917 10.2099 5.83705 10.1546 5.90669L7.28796 9.34602L5.80463 7.86202C5.67889 7.74058 5.51049 7.67339 5.33569 7.6749C5.16089 7.67642 4.99369 7.74654 4.87008 7.87014C4.74648 7.99375 4.67636 8.16096 4.67484 8.33575C4.67332 8.51055 4.74052 8.67895 4.86196 8.80469L6.86196 10.8047C6.92746 10.8702 7.00589 10.9213 7.09224 10.9547C7.17858 10.9882 7.27096 11.0033 7.36347 10.9991C7.45599 10.9949 7.54661 10.9715 7.62957 10.9303C7.71252 10.8892 7.78599 10.8312 7.84529 10.76L11.1786 6.76002Z" fill="var(--text-color)"/></svg>';
    } else {
      gliderAction.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.99996 0.666687C3.94996 0.666687 0.666626 3.95002 0.666626 8.00002C0.666626 12.05 3.94996 15.3334 7.99996 15.3334C12.05 15.3334 15.3333 12.05 15.3333 8.00002C15.3333 3.95002 12.05 0.666687 7.99996 0.666687ZM11.1786 6.76002C11.2372 6.69312 11.2817 6.61518 11.3097 6.5308C11.3377 6.44642 11.3485 6.3573 11.3415 6.26868C11.3345 6.18006 11.3099 6.09373 11.269 6.01477C11.2282 5.93582 11.1719 5.86582 11.1037 5.80892C11.0354 5.75201 10.9564 5.70933 10.8714 5.6834C10.7863 5.65746 10.697 5.6488 10.6085 5.65791C10.5201 5.66702 10.4344 5.69372 10.3565 5.73644C10.2785 5.77917 10.2099 5.83705 10.1546 5.90669L7.28796 9.34602L5.80463 7.86202C5.67889 7.74058 5.51049 7.67339 5.33569 7.6749C5.16089 7.67642 4.99369 7.74654 4.87008 7.87014C4.74648 7.99375 4.67636 8.16096 4.67484 8.33575C4.67332 8.51055 4.74052 8.67895 4.86196 8.80469L6.86196 10.8047C6.92746 10.8702 7.00589 10.9213 7.09224 10.9547C7.17858 10.9882 7.27096 11.0033 7.36347 10.9991C7.45599 10.9949 7.54661 10.9715 7.62957 10.9303C7.71252 10.8892 7.78599 10.8312 7.84529 10.76L11.1786 6.76002Z" fill="white"/></svg>';
    }
    return;
  }

  if (isSummary) {
    gliderAction.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_398_3965)"><path d="M8.00431 5.0705V8.0045M8.00431 8.0045V10.9385M8.00431 8.0045H10.9383M8.00431 8.0045H5.07031" stroke="#352B27" stroke-linecap="round" /><path d="M8.00492 15.3382C12.0559 15.3382 15.3399 12.0542 15.3399 8.00315C15.3399 3.95214 12.0559 0.668152 8.00492 0.668152C3.95391 0.668152 0.669922 3.95214 0.669922 8.00315C0.669922 12.0542 3.95391 15.3382 8.00492 15.3382Z" stroke="#352B27" /></g><defs><clipPath id="clip0_398_3965"><rect width="16" height="16" fill="var(--text-color)" /></clipPath></defs></svg>';
  } else {
    gliderAction.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_398_3965)"><path d="M8.00431 5.0705V8.0045M8.00431 8.0045V10.9385M8.00431 8.0045H10.9383M8.00431 8.0045H5.07031" stroke="#352B27" stroke-linecap="round" /><path d="M8.00492 15.3382C12.0559 15.3382 15.3399 12.0542 15.3399 8.00315C15.3399 3.95214 12.0559 0.668152 8.00492 0.668152C3.95391 0.668152 0.669922 3.95214 0.669922 8.00315C0.669922 12.0542 3.95391 15.3382 8.00492 15.3382Z" stroke="#352B27" /></g><defs><clipPath id="clip0_398_3965"><rect width="16" height="16" fill="white" /></clipPath></defs></svg>';
  }
}

function syncAllUpgradeGliders(isActive) {
  document.querySelectorAll('.robocap--upgrade-glider').forEach(function (glider) {
    glider.classList.toggle('active', isActive);
    updateUpgradeGliderIcon(glider, isActive);
  });

  gliderActive = isActive;
  if (!isActive) {
    gliderVariantID = '';
  }

  const popupGliderMobile = document.querySelector('.popup-glider-wrapper-mobile');
  if (popupGliderMobile) {
    popupGliderMobile.style.display = isActive ? 'none' : 'block';
  }

  updatePricing();
}

document.querySelectorAll('.robocap--upgrade-glider').forEach(function (glider) {
  updateUpgradeGliderIcon(glider, glider.classList.contains('active'));

  glider.addEventListener('click', function (e) {
    if (glider.getAttribute('disabled') == 'true' || glider.getAttribute('data-stock-quantity') == 0) {
      return;
    }
    e.preventDefault();
    syncAllUpgradeGliders(!glider.classList.contains('active'));
  });
});

function checkAnimalObservatoryColor(element){
  if(element.dataset.colorType == 'animal' && element.dataset.animalObservatoryColor.length > 0){
    customizationMain.classList.add('animal-observatory-color');
    document.querySelectorAll('.flask-animal-border').forEach(e => e.style.background = element.dataset.animalObservatoryColor);
  }
  else{
    customizationMain.classList.remove('animal-observatory-color');
  }
}

document.querySelectorAll('.scroll-up-to-choose').forEach(function (element) {
  element.addEventListener('click', function (e) {
    e.preventDefault();
    e.stopPropagation();

    const summarySection = document.querySelector('.summary-section');
    if (!summarySection) return;

    const mobileSection = element.closest('.summary-content-mobile');
    const scrollTarget = mobileSection?.querySelector('.type-section')
      || mobileSection?.querySelector('.size-section');

    if (scrollTarget) {
      const top = scrollTarget.getBoundingClientRect().top - summarySection.getBoundingClientRect().top + summarySection.scrollTop;
      summarySection.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      return;
    }

    summarySection.scrollTo({ top: 0, behavior: 'smooth' });
  });
});